/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function mt(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n of e.split(",")) t[n] = 1;
  return (n) => n in t;
}
const Q = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, on = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], ce = () => {
}, Vl = () => !1, ir = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), Sr = (e) => e.startsWith("onUpdate:"), se = Object.assign, ns = (e, t) => {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}, Al = Object.prototype.hasOwnProperty, K = (e, t) => Al.call(e, t), A = Array.isArray, Zt = (e) => qr(e) === "[object Map]", Io = (e) => qr(e) === "[object Set]", M = (e) => typeof e == "function", re = (e) => typeof e == "string", It = (e) => typeof e == "symbol", ee = (e) => e !== null && typeof e == "object", rs = (e) => (ee(e) || M(e)) && M(e.then) && M(e.catch), Ro = Object.prototype.toString, qr = (e) => Ro.call(e), is = (e) => qr(e).slice(8, -1), Gr = (e) => qr(e) === "[object Object]", ss = (e) => re(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, Dn = /* @__PURE__ */ mt(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Pl = /* @__PURE__ */ mt(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), Jr = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, jl = /-(\w)/g, fe = Jr(
  (e) => e.replace(jl, (t, n) => n ? n.toUpperCase() : "")
), Il = /\B([A-Z])/g, Ve = Jr(
  (e) => e.replace(Il, "-$1").toLowerCase()
), Kt = Jr((e) => e.charAt(0).toUpperCase() + e.slice(1)), $t = Jr(
  (e) => e ? `on${Kt(e)}` : ""
), St = (e, t) => !Object.is(e, t), xn = (e, ...t) => {
  for (let n = 0; n < e.length; n++)
    e[n](...t);
}, Cr = (e, t, n, r = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: r,
    value: n
  });
}, Rl = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, Ds = (e) => {
  const t = re(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let Vs;
const sr = () => Vs || (Vs = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function os(e) {
  if (A(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const r = e[n], i = re(r) ? Ll(r) : os(r);
      if (i)
        for (const s in i)
          t[s] = i[s];
    }
    return t;
  } else if (re(e) || ee(e))
    return e;
}
const Ml = /;(?![^(]*\))/g, $l = /:([^]+)/, Fl = /\/\*[^]*?\*\//g;
function Ll(e) {
  const t = {};
  return e.replace(Fl, "").split(Ml).forEach((n) => {
    if (n) {
      const r = n.split($l);
      r.length > 1 && (t[r[0].trim()] = r[1].trim());
    }
  }), t;
}
function Yr(e) {
  let t = "";
  if (re(e))
    t = e;
  else if (A(e))
    for (let n = 0; n < e.length; n++) {
      const r = Yr(e[n]);
      r && (t += r + " ");
    }
  else if (ee(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
const Zl = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot", zl = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view", Ul = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics", Hl = /* @__PURE__ */ mt(Zl), Bl = /* @__PURE__ */ mt(zl), Wl = /* @__PURE__ */ mt(Ul), Kl = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", ql = /* @__PURE__ */ mt(Kl);
function Mo(e) {
  return !!e || e === "";
}
const $o = (e) => !!(e && e.__v_isRef === !0), Fo = (e) => re(e) ? e : e == null ? "" : A(e) || ee(e) && (e.toString === Ro || !M(e.toString)) ? $o(e) ? Fo(e.value) : JSON.stringify(e, Lo, 2) : String(e), Lo = (e, t) => $o(t) ? Lo(e, t.value) : Zt(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (n, [r, i], s) => (n[yi(r, s) + " =>"] = i, n),
    {}
  )
} : Io(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((n) => yi(n))
} : It(t) ? yi(t) : ee(t) && !A(t) && !Gr(t) ? String(t) : t, yi = (e, t = "") => {
  var n;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    It(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e
  );
};
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function it(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let De;
class Gl {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = De, !t && De && (this.index = (De.scopes || (De.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].pause();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].resume();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const n = De;
      try {
        return De = this, t();
      } finally {
        De = n;
      }
    } else process.env.NODE_ENV !== "production" && it("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    De = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    De = this.parent;
  }
  stop(t) {
    if (this._active) {
      this._active = !1;
      let n, r;
      for (n = 0, r = this.effects.length; n < r; n++)
        this.effects[n].stop();
      for (this.effects.length = 0, n = 0, r = this.cleanups.length; n < r; n++)
        this.cleanups[n]();
      if (this.cleanups.length = 0, this.scopes) {
        for (n = 0, r = this.scopes.length; n < r; n++)
          this.scopes[n].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !t) {
        const i = this.parent.scopes.pop();
        i && i !== this && (this.parent.scopes[this.index] = i, i.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function Jl() {
  return De;
}
let J;
const bi = /* @__PURE__ */ new WeakSet();
class Zo {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, De && De.active && De.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, bi.has(this) && (bi.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || Uo(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, As(this), Ho(this);
    const t = J, n = He;
    J = this, He = !0;
    try {
      return this.fn();
    } finally {
      process.env.NODE_ENV !== "production" && J !== this && it(
        "Active effect was not restored correctly - this is likely a Vue internal bug."
      ), Bo(this), J = t, He = n, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        cs(t);
      this.deps = this.depsTail = void 0, As(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? bi.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    Pi(this) && this.run();
  }
  get dirty() {
    return Pi(this);
  }
}
let zo = 0, Vn, An;
function Uo(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = An, An = e;
    return;
  }
  e.next = Vn, Vn = e;
}
function as() {
  zo++;
}
function ls() {
  if (--zo > 0)
    return;
  if (An) {
    let t = An;
    for (An = void 0; t; ) {
      const n = t.next;
      t.next = void 0, t.flags &= -9, t = n;
    }
  }
  let e;
  for (; Vn; ) {
    let t = Vn;
    for (Vn = void 0; t; ) {
      const n = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (r) {
          e || (e = r);
        }
      t = n;
    }
  }
  if (e) throw e;
}
function Ho(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function Bo(e) {
  let t, n = e.depsTail, r = n;
  for (; r; ) {
    const i = r.prevDep;
    r.version === -1 ? (r === n && (n = i), cs(r), Yl(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = i;
  }
  e.deps = t, e.depsTail = n;
}
function Pi(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (Wo(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function Wo(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Rn))
    return;
  e.globalVersion = Rn;
  const t = e.dep;
  if (e.flags |= 2, t.version > 0 && !e.isSSR && e.deps && !Pi(e)) {
    e.flags &= -3;
    return;
  }
  const n = J, r = He;
  J = e, He = !0;
  try {
    Ho(e);
    const i = e.fn(e._value);
    (t.version === 0 || St(i, e._value)) && (e._value = i, t.version++);
  } catch (i) {
    throw t.version++, i;
  } finally {
    J = n, He = r, Bo(e), e.flags &= -3;
  }
}
function cs(e, t = !1) {
  const { dep: n, prevSub: r, nextSub: i } = e;
  if (r && (r.nextSub = i, e.prevSub = void 0), i && (i.prevSub = r, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = i), n.subs === e && (n.subs = r, !r && n.computed)) {
    n.computed.flags &= -5;
    for (let s = n.computed.deps; s; s = s.nextDep)
      cs(s, !0);
  }
  !t && !--n.sc && n.map && n.map.delete(n.key);
}
function Yl(e) {
  const { prevDep: t, nextDep: n } = e;
  t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
let He = !0;
const Ko = [];
function gt() {
  Ko.push(He), He = !1;
}
function vt() {
  const e = Ko.pop();
  He = e === void 0 ? !0 : e;
}
function As(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const n = J;
    J = void 0;
    try {
      t();
    } finally {
      J = n;
    }
  }
}
let Rn = 0;
class Xl {
  constructor(t, n) {
    this.sub = t, this.dep = n, this.version = n.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class us {
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(t) {
    if (!J || !He || J === this.computed)
      return;
    let n = this.activeLink;
    if (n === void 0 || n.sub !== J)
      n = this.activeLink = new Xl(J, this), J.deps ? (n.prevDep = J.depsTail, J.depsTail.nextDep = n, J.depsTail = n) : J.deps = J.depsTail = n, qo(n);
    else if (n.version === -1 && (n.version = this.version, n.nextDep)) {
      const r = n.nextDep;
      r.prevDep = n.prevDep, n.prevDep && (n.prevDep.nextDep = r), n.prevDep = J.depsTail, n.nextDep = void 0, J.depsTail.nextDep = n, J.depsTail = n, J.deps === n && (J.deps = r);
    }
    return process.env.NODE_ENV !== "production" && J.onTrack && J.onTrack(
      se(
        {
          effect: J
        },
        t
      )
    ), n;
  }
  trigger(t) {
    this.version++, Rn++, this.notify(t);
  }
  notify(t) {
    as();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let n = this.subsHead; n; n = n.nextSub)
          n.sub.onTrigger && !(n.sub.flags & 8) && n.sub.onTrigger(
            se(
              {
                effect: n.sub
              },
              t
            )
          );
      for (let n = this.subs; n; n = n.prevSub)
        n.sub.notify() && n.sub.dep.notify();
    } finally {
      ls();
    }
  }
}
function qo(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let r = t.deps; r; r = r.nextDep)
        qo(r);
    }
    const n = e.dep.subs;
    n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
  }
}
const ji = /* @__PURE__ */ new WeakMap(), zt = Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), Ii = Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), Mn = Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function le(e, t, n) {
  if (He && J) {
    let r = ji.get(e);
    r || ji.set(e, r = /* @__PURE__ */ new Map());
    let i = r.get(n);
    i || (r.set(n, i = new us()), i.map = r, i.key = n), process.env.NODE_ENV !== "production" ? i.track({
      target: e,
      type: t,
      key: n
    }) : i.track();
  }
}
function et(e, t, n, r, i, s) {
  const o = ji.get(e);
  if (!o) {
    Rn++;
    return;
  }
  const a = (l) => {
    l && (process.env.NODE_ENV !== "production" ? l.trigger({
      target: e,
      type: t,
      key: n,
      newValue: r,
      oldValue: i,
      oldTarget: s
    }) : l.trigger());
  };
  if (as(), t === "clear")
    o.forEach(a);
  else {
    const l = A(e), c = l && ss(n);
    if (l && n === "length") {
      const d = Number(r);
      o.forEach((f, h) => {
        (h === "length" || h === Mn || !It(h) && h >= d) && a(f);
      });
    } else
      switch ((n !== void 0 || o.has(void 0)) && a(o.get(n)), c && a(o.get(Mn)), t) {
        case "add":
          l ? c && a(o.get("length")) : (a(o.get(zt)), Zt(e) && a(o.get(Ii)));
          break;
        case "delete":
          l || (a(o.get(zt)), Zt(e) && a(o.get(Ii)));
          break;
        case "set":
          Zt(e) && a(o.get(zt));
          break;
      }
  }
  ls();
}
function Qt(e) {
  const t = Z(e);
  return t === e ? t : (le(t, "iterate", Mn), we(e) ? t : t.map(ge));
}
function Xr(e) {
  return le(e = Z(e), "iterate", Mn), e;
}
const Ql = {
  __proto__: null,
  [Symbol.iterator]() {
    return _i(this, Symbol.iterator, ge);
  },
  concat(...e) {
    return Qt(this).concat(
      ...e.map((t) => A(t) ? Qt(t) : t)
    );
  },
  entries() {
    return _i(this, "entries", (e) => (e[1] = ge(e[1]), e));
  },
  every(e, t) {
    return ct(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return ct(this, "filter", e, t, (n) => n.map(ge), arguments);
  },
  find(e, t) {
    return ct(this, "find", e, t, ge, arguments);
  },
  findIndex(e, t) {
    return ct(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return ct(this, "findLast", e, t, ge, arguments);
  },
  findLastIndex(e, t) {
    return ct(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return ct(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return wi(this, "includes", e);
  },
  indexOf(...e) {
    return wi(this, "indexOf", e);
  },
  join(e) {
    return Qt(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return wi(this, "lastIndexOf", e);
  },
  map(e, t) {
    return ct(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return En(this, "pop");
  },
  push(...e) {
    return En(this, "push", e);
  },
  reduce(e, ...t) {
    return Ps(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return Ps(this, "reduceRight", e, t);
  },
  shift() {
    return En(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return ct(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return En(this, "splice", e);
  },
  toReversed() {
    return Qt(this).toReversed();
  },
  toSorted(e) {
    return Qt(this).toSorted(e);
  },
  toSpliced(...e) {
    return Qt(this).toSpliced(...e);
  },
  unshift(...e) {
    return En(this, "unshift", e);
  },
  values() {
    return _i(this, "values", ge);
  }
};
function _i(e, t, n) {
  const r = Xr(e), i = r[t]();
  return r !== e && !we(e) && (i._next = i.next, i.next = () => {
    const s = i._next();
    return s.value && (s.value = n(s.value)), s;
  }), i;
}
const ec = Array.prototype;
function ct(e, t, n, r, i, s) {
  const o = Xr(e), a = o !== e && !we(e), l = o[t];
  if (l !== ec[t]) {
    const f = l.apply(e, s);
    return a ? ge(f) : f;
  }
  let c = n;
  o !== e && (a ? c = function(f, h) {
    return n.call(this, ge(f), h, e);
  } : n.length > 2 && (c = function(f, h) {
    return n.call(this, f, h, e);
  }));
  const d = l.call(o, c, r);
  return a && i ? i(d) : d;
}
function Ps(e, t, n, r) {
  const i = Xr(e);
  let s = n;
  return i !== e && (we(e) ? n.length > 3 && (s = function(o, a, l) {
    return n.call(this, o, a, l, e);
  }) : s = function(o, a, l) {
    return n.call(this, o, ge(a), l, e);
  }), i[t](s, ...r);
}
function wi(e, t, n) {
  const r = Z(e);
  le(r, "iterate", Mn);
  const i = r[t](...n);
  return (i === -1 || i === !1) && Tr(n[0]) ? (n[0] = Z(n[0]), r[t](...n)) : i;
}
function En(e, t, n = []) {
  gt(), as();
  const r = Z(e)[t].apply(e, n);
  return ls(), vt(), r;
}
const tc = /* @__PURE__ */ mt("__proto__,__v_isRef,__isVue"), Go = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(It)
);
function nc(e) {
  It(e) || (e = String(e));
  const t = Z(this);
  return le(t, "has", e), t.hasOwnProperty(e);
}
class Jo {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, r) {
    if (n === "__v_skip") return t.__v_skip;
    const i = this._isReadonly, s = this._isShallow;
    if (n === "__v_isReactive")
      return !i;
    if (n === "__v_isReadonly")
      return i;
    if (n === "__v_isShallow")
      return s;
    if (n === "__v_raw")
      return r === (i ? s ? na : ta : s ? ea : Qo).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(r) ? t : void 0;
    const o = A(t);
    if (!i) {
      let l;
      if (o && (l = Ql[n]))
        return l;
      if (n === "hasOwnProperty")
        return nc;
    }
    const a = Reflect.get(
      t,
      n,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      ae(t) ? t : r
    );
    return (It(n) ? Go.has(n) : tc(n)) || (i || le(t, "get", n), s) ? a : ae(a) ? o && ss(n) ? a : a.value : ee(a) ? i ? ra(a) : ds(a) : a;
  }
}
class Yo extends Jo {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, r, i) {
    let s = t[n];
    if (!this._isShallow) {
      const l = pt(s);
      if (!we(r) && !pt(r) && (s = Z(s), r = Z(r)), !A(t) && ae(s) && !ae(r))
        return l ? !1 : (s.value = r, !0);
    }
    const o = A(t) && ss(n) ? Number(n) < t.length : K(t, n), a = Reflect.set(
      t,
      n,
      r,
      ae(t) ? t : i
    );
    return t === Z(i) && (o ? St(r, s) && et(t, "set", n, r, s) : et(t, "add", n, r)), a;
  }
  deleteProperty(t, n) {
    const r = K(t, n), i = t[n], s = Reflect.deleteProperty(t, n);
    return s && r && et(t, "delete", n, void 0, i), s;
  }
  has(t, n) {
    const r = Reflect.has(t, n);
    return (!It(n) || !Go.has(n)) && le(t, "has", n), r;
  }
  ownKeys(t) {
    return le(
      t,
      "iterate",
      A(t) ? "length" : zt
    ), Reflect.ownKeys(t);
  }
}
class Xo extends Jo {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return process.env.NODE_ENV !== "production" && it(
      `Set operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, n) {
    return process.env.NODE_ENV !== "production" && it(
      `Delete operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const rc = /* @__PURE__ */ new Yo(), ic = /* @__PURE__ */ new Xo(), sc = /* @__PURE__ */ new Yo(!0), oc = /* @__PURE__ */ new Xo(!0), Ri = (e) => e, pr = (e) => Reflect.getPrototypeOf(e);
function ac(e, t, n) {
  return function(...r) {
    const i = this.__v_raw, s = Z(i), o = Zt(s), a = e === "entries" || e === Symbol.iterator && o, l = e === "keys" && o, c = i[e](...r), d = n ? Ri : t ? Mi : ge;
    return !t && le(
      s,
      "iterate",
      l ? Ii : zt
    ), {
      // iterator protocol
      next() {
        const { value: f, done: h } = c.next();
        return h ? { value: f, done: h } : {
          value: a ? [d(f[0]), d(f[1])] : d(f),
          done: h
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function hr(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const n = t[0] ? `on key "${t[0]}" ` : "";
      it(
        `${Kt(e)} operation ${n}failed: target is readonly.`,
        Z(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function lc(e, t) {
  const n = {
    get(i) {
      const s = this.__v_raw, o = Z(s), a = Z(i);
      e || (St(i, a) && le(o, "get", i), le(o, "get", a));
      const { has: l } = pr(o), c = t ? Ri : e ? Mi : ge;
      if (l.call(o, i))
        return c(s.get(i));
      if (l.call(o, a))
        return c(s.get(a));
      s !== o && s.get(i);
    },
    get size() {
      const i = this.__v_raw;
      return !e && le(Z(i), "iterate", zt), Reflect.get(i, "size", i);
    },
    has(i) {
      const s = this.__v_raw, o = Z(s), a = Z(i);
      return e || (St(i, a) && le(o, "has", i), le(o, "has", a)), i === a ? s.has(i) : s.has(i) || s.has(a);
    },
    forEach(i, s) {
      const o = this, a = o.__v_raw, l = Z(a), c = t ? Ri : e ? Mi : ge;
      return !e && le(l, "iterate", zt), a.forEach((d, f) => i.call(s, c(d), c(f), o));
    }
  };
  return se(
    n,
    e ? {
      add: hr("add"),
      set: hr("set"),
      delete: hr("delete"),
      clear: hr("clear")
    } : {
      add(i) {
        !t && !we(i) && !pt(i) && (i = Z(i));
        const s = Z(this);
        return pr(s).has.call(s, i) || (s.add(i), et(s, "add", i, i)), this;
      },
      set(i, s) {
        !t && !we(s) && !pt(s) && (s = Z(s));
        const o = Z(this), { has: a, get: l } = pr(o);
        let c = a.call(o, i);
        c ? process.env.NODE_ENV !== "production" && js(o, a, i) : (i = Z(i), c = a.call(o, i));
        const d = l.call(o, i);
        return o.set(i, s), c ? St(s, d) && et(o, "set", i, s, d) : et(o, "add", i, s), this;
      },
      delete(i) {
        const s = Z(this), { has: o, get: a } = pr(s);
        let l = o.call(s, i);
        l ? process.env.NODE_ENV !== "production" && js(s, o, i) : (i = Z(i), l = o.call(s, i));
        const c = a ? a.call(s, i) : void 0, d = s.delete(i);
        return l && et(s, "delete", i, void 0, c), d;
      },
      clear() {
        const i = Z(this), s = i.size !== 0, o = process.env.NODE_ENV !== "production" ? Zt(i) ? new Map(i) : new Set(i) : void 0, a = i.clear();
        return s && et(
          i,
          "clear",
          void 0,
          void 0,
          o
        ), a;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((i) => {
    n[i] = ac(i, e, t);
  }), n;
}
function Qr(e, t) {
  const n = lc(e, t);
  return (r, i, s) => i === "__v_isReactive" ? !e : i === "__v_isReadonly" ? e : i === "__v_raw" ? r : Reflect.get(
    K(n, i) && i in r ? n : r,
    i,
    s
  );
}
const cc = {
  get: /* @__PURE__ */ Qr(!1, !1)
}, uc = {
  get: /* @__PURE__ */ Qr(!1, !0)
}, dc = {
  get: /* @__PURE__ */ Qr(!0, !1)
}, fc = {
  get: /* @__PURE__ */ Qr(!0, !0)
};
function js(e, t, n) {
  const r = Z(n);
  if (r !== n && t.call(e, r)) {
    const i = is(e);
    it(
      `Reactive ${i} contains both the raw and reactive versions of the same object${i === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const Qo = /* @__PURE__ */ new WeakMap(), ea = /* @__PURE__ */ new WeakMap(), ta = /* @__PURE__ */ new WeakMap(), na = /* @__PURE__ */ new WeakMap();
function pc(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function hc(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : pc(is(e));
}
function ds(e) {
  return pt(e) ? e : ei(
    e,
    !1,
    rc,
    cc,
    Qo
  );
}
function mc(e) {
  return ei(
    e,
    !1,
    sc,
    uc,
    ea
  );
}
function ra(e) {
  return ei(
    e,
    !0,
    ic,
    dc,
    ta
  );
}
function tt(e) {
  return ei(
    e,
    !0,
    oc,
    fc,
    na
  );
}
function ei(e, t, n, r, i) {
  if (!ee(e))
    return process.env.NODE_ENV !== "production" && it(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const s = i.get(e);
  if (s)
    return s;
  const o = hc(e);
  if (o === 0)
    return e;
  const a = new Proxy(
    e,
    o === 2 ? r : n
  );
  return i.set(e, a), a;
}
function Ut(e) {
  return pt(e) ? Ut(e.__v_raw) : !!(e && e.__v_isReactive);
}
function pt(e) {
  return !!(e && e.__v_isReadonly);
}
function we(e) {
  return !!(e && e.__v_isShallow);
}
function Tr(e) {
  return e ? !!e.__v_raw : !1;
}
function Z(e) {
  const t = e && e.__v_raw;
  return t ? Z(t) : e;
}
function mn(e) {
  return !K(e, "__v_skip") && Object.isExtensible(e) && Cr(e, "__v_skip", !0), e;
}
const ge = (e) => ee(e) ? ds(e) : e, Mi = (e) => ee(e) ? ra(e) : e;
function ae(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function ia(e) {
  return gc(e, !1);
}
function gc(e, t) {
  return ae(e) ? e : new vc(e, t);
}
class vc {
  constructor(t, n) {
    this.dep = new us(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = n ? t : Z(t), this._value = n ? t : ge(t), this.__v_isShallow = n;
  }
  get value() {
    return process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track(), this._value;
  }
  set value(t) {
    const n = this._rawValue, r = this.__v_isShallow || we(t) || pt(t);
    t = r ? t : Z(t), St(t, n) && (this._rawValue = t, this._value = r ? t : ge(t), process.env.NODE_ENV !== "production" ? this.dep.trigger({
      target: this,
      type: "set",
      key: "value",
      newValue: t,
      oldValue: n
    }) : this.dep.trigger());
  }
}
function ti(e) {
  return ae(e) ? e.value : e;
}
const yc = {
  get: (e, t, n) => t === "__v_raw" ? e : ti(Reflect.get(e, t, n)),
  set: (e, t, n, r) => {
    const i = e[t];
    return ae(i) && !ae(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
  }
};
function sa(e) {
  return Ut(e) ? e : new Proxy(e, yc);
}
class bc {
  constructor(t, n, r) {
    this.fn = t, this.setter = n, this._value = void 0, this.dep = new us(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Rn - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !n, this.isSSR = r;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    J !== this)
      return Uo(this, !0), !0;
    process.env.NODE_ENV;
  }
  get value() {
    const t = process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    return Wo(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter ? this.setter(t) : process.env.NODE_ENV !== "production" && it("Write operation failed: computed value is readonly");
  }
}
function _c(e, t, n = !1) {
  let r, i;
  M(e) ? r = e : (r = e.get, i = e.set);
  const s = new bc(r, i, n);
  return process.env.NODE_ENV, s;
}
const mr = {}, Dr = /* @__PURE__ */ new WeakMap();
let Ft;
function wc(e, t = !1, n = Ft) {
  if (n) {
    let r = Dr.get(n);
    r || Dr.set(n, r = []), r.push(e);
  } else process.env.NODE_ENV !== "production" && !t && it(
    "onWatcherCleanup() was called when there was no active watcher to associate with."
  );
}
function xc(e, t, n = Q) {
  const { immediate: r, deep: i, once: s, scheduler: o, augmentJob: a, call: l } = n, c = (P) => {
    (n.onWarn || it)(
      "Invalid watch source: ",
      P,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, d = (P) => i ? P : we(P) || i === !1 || i === 0 ? Nt(P, 1) : Nt(P);
  let f, h, v, S, R = !1, te = !1;
  if (ae(e) ? (h = () => e.value, R = we(e)) : Ut(e) ? (h = () => d(e), R = !0) : A(e) ? (te = !0, R = e.some((P) => Ut(P) || we(P)), h = () => e.map((P) => {
    if (ae(P))
      return P.value;
    if (Ut(P))
      return d(P);
    if (M(P))
      return l ? l(P, 2) : P();
    process.env.NODE_ENV !== "production" && c(P);
  })) : M(e) ? t ? h = l ? () => l(e, 2) : e : h = () => {
    if (v) {
      gt();
      try {
        v();
      } finally {
        vt();
      }
    }
    const P = Ft;
    Ft = f;
    try {
      return l ? l(e, 3, [S]) : e(S);
    } finally {
      Ft = P;
    }
  } : (h = ce, process.env.NODE_ENV !== "production" && c(e)), t && i) {
    const P = h, de = i === !0 ? 1 / 0 : i;
    h = () => Nt(P(), de);
  }
  const G = Jl(), oe = () => {
    f.stop(), G && G.active && ns(G.effects, f);
  };
  if (s && t) {
    const P = t;
    t = (...de) => {
      P(...de), oe();
    };
  }
  let Y = te ? new Array(e.length).fill(mr) : mr;
  const Se = (P) => {
    if (!(!(f.flags & 1) || !f.dirty && !P))
      if (t) {
        const de = f.run();
        if (i || R || (te ? de.some((Re, me) => St(Re, Y[me])) : St(de, Y))) {
          v && v();
          const Re = Ft;
          Ft = f;
          try {
            const me = [
              de,
              // pass undefined as the old value when it's changed for the first time
              Y === mr ? void 0 : te && Y[0] === mr ? [] : Y,
              S
            ];
            l ? l(t, 3, me) : (
              // @ts-expect-error
              t(...me)
            ), Y = de;
          } finally {
            Ft = Re;
          }
        }
      } else
        f.run();
  };
  return a && a(Se), f = new Zo(h), f.scheduler = o ? () => o(Se, !1) : Se, S = (P) => wc(P, !1, f), v = f.onStop = () => {
    const P = Dr.get(f);
    if (P) {
      if (l)
        l(P, 4);
      else
        for (const de of P) de();
      Dr.delete(f);
    }
  }, process.env.NODE_ENV !== "production" && (f.onTrack = n.onTrack, f.onTrigger = n.onTrigger), t ? r ? Se(!0) : Y = f.run() : o ? o(Se.bind(null, !0), !0) : f.run(), oe.pause = f.pause.bind(f), oe.resume = f.resume.bind(f), oe.stop = oe, oe;
}
function Nt(e, t = 1 / 0, n) {
  if (t <= 0 || !ee(e) || e.__v_skip || (n = n || /* @__PURE__ */ new Set(), n.has(e)))
    return e;
  if (n.add(e), t--, ae(e))
    Nt(e.value, t, n);
  else if (A(e))
    for (let r = 0; r < e.length; r++)
      Nt(e[r], t, n);
  else if (Io(e) || Zt(e))
    e.forEach((r) => {
      Nt(r, t, n);
    });
  else if (Gr(e)) {
    for (const r in e)
      Nt(e[r], t, n);
    for (const r of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, r) && Nt(e[r], t, n);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const Ht = [];
function vr(e) {
  Ht.push(e);
}
function yr() {
  Ht.pop();
}
let xi = !1;
function k(e, ...t) {
  if (xi) return;
  xi = !0, gt();
  const n = Ht.length ? Ht[Ht.length - 1].component : null, r = n && n.appContext.config.warnHandler, i = Ec();
  if (r)
    gn(
      r,
      n,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((s) => {
          var o, a;
          return (a = (o = s.toString) == null ? void 0 : o.call(s)) != null ? a : JSON.stringify(s);
        }).join(""),
        n && n.proxy,
        i.map(
          ({ vnode: s }) => `at <${li(n, s.type)}>`
        ).join(`
`),
        i
      ]
    );
  else {
    const s = [`[Vue warn]: ${e}`, ...t];
    i.length && s.push(`
`, ...kc(i)), console.warn(...s);
  }
  vt(), xi = !1;
}
function Ec() {
  let e = Ht[Ht.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const n = t[0];
    n && n.vnode === e ? n.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const r = e.component && e.component.parent;
    e = r && r.vnode;
  }
  return t;
}
function kc(e) {
  const t = [];
  return e.forEach((n, r) => {
    t.push(...r === 0 ? [] : [`
`], ...Nc(n));
  }), t;
}
function Nc({ vnode: e, recurseCount: t }) {
  const n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, i = ` at <${li(
    e.component,
    e.type,
    r
  )}`, s = ">" + n;
  return e.props ? [i, ...Oc(e.props), s] : [i + s];
}
function Oc(e) {
  const t = [], n = Object.keys(e);
  return n.slice(0, 3).forEach((r) => {
    t.push(...oa(r, e[r]));
  }), n.length > 3 && t.push(" ..."), t;
}
function oa(e, t, n) {
  return re(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : ae(t) ? (t = oa(e, Z(t.value), !0), n ? t : [`${e}=Ref<`, t, ">"]) : M(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = Z(t), n ? t : [`${e}=`, t]);
}
const fs = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function gn(e, t, n, r) {
  try {
    return r ? e(...r) : e();
  } catch (i) {
    or(i, t, n);
  }
}
function st(e, t, n, r) {
  if (M(e)) {
    const i = gn(e, t, n, r);
    return i && rs(i) && i.catch((s) => {
      or(s, t, n);
    }), i;
  }
  if (A(e)) {
    const i = [];
    for (let s = 0; s < e.length; s++)
      i.push(st(e[s], t, n, r));
    return i;
  } else process.env.NODE_ENV !== "production" && k(
    `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`
  );
}
function or(e, t, n, r = !0) {
  const i = t ? t.vnode : null, { errorHandler: s, throwUnhandledErrorInProduction: o } = t && t.appContext.config || Q;
  if (t) {
    let a = t.parent;
    const l = t.proxy, c = process.env.NODE_ENV !== "production" ? fs[n] : `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; a; ) {
      const d = a.ec;
      if (d) {
        for (let f = 0; f < d.length; f++)
          if (d[f](e, l, c) === !1)
            return;
      }
      a = a.parent;
    }
    if (s) {
      gt(), gn(s, null, 10, [
        e,
        l,
        c
      ]), vt();
      return;
    }
  }
  Sc(e, n, i, r, o);
}
function Sc(e, t, n, r = !0, i = !1) {
  if (process.env.NODE_ENV !== "production") {
    const s = fs[t];
    if (n && vr(n), k(`Unhandled error${s ? ` during execution of ${s}` : ""}`), n && yr(), r)
      throw e;
    console.error(e);
  } else {
    if (i)
      throw e;
    console.error(e);
  }
}
const _e = [];
let Qe = -1;
const an = [];
let Et = null, nn = 0;
const aa = /* @__PURE__ */ Promise.resolve();
let Vr = null;
const Cc = 100;
function la(e) {
  const t = Vr || aa;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function Tc(e) {
  let t = Qe + 1, n = _e.length;
  for (; t < n; ) {
    const r = t + n >>> 1, i = _e[r], s = $n(i);
    s < e || s === e && i.flags & 2 ? t = r + 1 : n = r;
  }
  return t;
}
function ni(e) {
  if (!(e.flags & 1)) {
    const t = $n(e), n = _e[_e.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= $n(n) ? _e.push(e) : _e.splice(Tc(t), 0, e), e.flags |= 1, ca();
  }
}
function ca() {
  Vr || (Vr = aa.then(fa));
}
function ua(e) {
  A(e) ? an.push(...e) : Et && e.id === -1 ? Et.splice(nn + 1, 0, e) : e.flags & 1 || (an.push(e), e.flags |= 1), ca();
}
function Is(e, t, n = Qe + 1) {
  for (process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()); n < _e.length; n++) {
    const r = _e[n];
    if (r && r.flags & 2) {
      if (e && r.id !== e.uid || process.env.NODE_ENV !== "production" && ps(t, r))
        continue;
      _e.splice(n, 1), n--, r.flags & 4 && (r.flags &= -2), r(), r.flags & 4 || (r.flags &= -2);
    }
  }
}
function da(e) {
  if (an.length) {
    const t = [...new Set(an)].sort(
      (n, r) => $n(n) - $n(r)
    );
    if (an.length = 0, Et) {
      Et.push(...t);
      return;
    }
    for (Et = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), nn = 0; nn < Et.length; nn++) {
      const n = Et[nn];
      process.env.NODE_ENV !== "production" && ps(e, n) || (n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2);
    }
    Et = null, nn = 0;
  }
}
const $n = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function fa(e) {
  process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (n) => ps(e, n) : ce;
  try {
    for (Qe = 0; Qe < _e.length; Qe++) {
      const n = _e[Qe];
      if (n && !(n.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(n))
          continue;
        n.flags & 4 && (n.flags &= -2), gn(
          n,
          n.i,
          n.i ? 15 : 14
        ), n.flags & 4 || (n.flags &= -2);
      }
    }
  } finally {
    for (; Qe < _e.length; Qe++) {
      const n = _e[Qe];
      n && (n.flags &= -2);
    }
    Qe = -1, _e.length = 0, da(e), Vr = null, (_e.length || an.length) && fa(e);
  }
}
function ps(e, t) {
  const n = e.get(t) || 0;
  if (n > Cc) {
    const r = t.i, i = r && Es(r.type);
    return or(
      `Maximum recursive updates exceeded${i ? ` in component <${i}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, n + 1), !1;
}
let nt = !1;
const br = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (sr().__VUE_HMR_RUNTIME__ = {
  createRecord: Ei(pa),
  rerender: Ei(Ac),
  reload: Ei(Pc)
});
const qt = /* @__PURE__ */ new Map();
function Dc(e) {
  const t = e.type.__hmrId;
  let n = qt.get(t);
  n || (pa(t, e.type), n = qt.get(t)), n.instances.add(e);
}
function Vc(e) {
  qt.get(e.type.__hmrId).instances.delete(e);
}
function pa(e, t) {
  return qt.has(e) ? !1 : (qt.set(e, {
    initialDef: Ar(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function Ar(e) {
  return Ka(e) ? e.__vccOpts : e;
}
function Ac(e, t) {
  const n = qt.get(e);
  n && (n.initialDef.render = t, [...n.instances].forEach((r) => {
    t && (r.render = t, Ar(r.type).render = t), r.renderCache = [], nt = !0, r.update(), nt = !1;
  }));
}
function Pc(e, t) {
  const n = qt.get(e);
  if (!n) return;
  t = Ar(t), Rs(n.initialDef, t);
  const r = [...n.instances];
  for (let i = 0; i < r.length; i++) {
    const s = r[i], o = Ar(s.type);
    let a = br.get(o);
    a || (o !== n.initialDef && Rs(o, t), br.set(o, a = /* @__PURE__ */ new Set())), a.add(s), s.appContext.propsCache.delete(s.type), s.appContext.emitsCache.delete(s.type), s.appContext.optionsCache.delete(s.type), s.ceReload ? (a.add(s), s.ceReload(t.styles), a.delete(s)) : s.parent ? ni(() => {
      nt = !0, s.parent.update(), nt = !1, a.delete(s);
    }) : s.appContext.reload ? s.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), s.root.ce && s !== s.root && s.root.ce._removeChildStyle(o);
  }
  ua(() => {
    br.clear();
  });
}
function Rs(e, t) {
  se(e, t);
  for (const n in e)
    n !== "__file" && !(n in t) && delete e[n];
}
function Ei(e) {
  return (t, n) => {
    try {
      return e(t, n);
    } catch (r) {
      console.error(r), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let ze, On = [], $i = !1;
function ar(e, ...t) {
  ze ? ze.emit(e, ...t) : $i || On.push({ event: e, args: t });
}
function hs(e, t) {
  var n, r;
  ze = e, ze ? (ze.enabled = !0, On.forEach(({ event: i, args: s }) => ze.emit(i, ...s)), On = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((r = (n = window.navigator) == null ? void 0 : n.userAgent) != null && r.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((s) => {
    hs(s, t);
  }), setTimeout(() => {
    ze || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, $i = !0, On = []);
  }, 3e3)) : ($i = !0, On = []);
}
function jc(e, t) {
  ar("app:init", e, t, {
    Fragment: Me,
    Text: lr,
    Comment: Pe,
    Static: xr
  });
}
function Ic(e) {
  ar("app:unmount", e);
}
const Rc = /* @__PURE__ */ ms(
  "component:added"
  /* COMPONENT_ADDED */
), ha = /* @__PURE__ */ ms(
  "component:updated"
  /* COMPONENT_UPDATED */
), Mc = /* @__PURE__ */ ms(
  "component:removed"
  /* COMPONENT_REMOVED */
), $c = (e) => {
  ze && typeof ze.cleanupBuffer == "function" && // remove the component if it wasn't buffered
  !ze.cleanupBuffer(e) && Mc(e);
};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function ms(e) {
  return (t) => {
    ar(
      e,
      t.appContext.app,
      t.uid,
      t.parent ? t.parent.uid : void 0,
      t
    );
  };
}
const Fc = /* @__PURE__ */ ma(
  "perf:start"
  /* PERFORMANCE_START */
), Lc = /* @__PURE__ */ ma(
  "perf:end"
  /* PERFORMANCE_END */
);
function ma(e) {
  return (t, n, r) => {
    ar(e, t.appContext.app, t.uid, t, n, r);
  };
}
function Zc(e, t, n) {
  ar(
    "component:emit",
    e.appContext.app,
    e,
    t,
    n
  );
}
let Oe = null, ga = null;
function Pr(e) {
  const t = Oe;
  return Oe = e, ga = e && e.type.__scopeId || null, t;
}
function zc(e, t = Oe, n) {
  if (!t || e._n)
    return e;
  const r = (...i) => {
    r._d && Gs(-1);
    const s = Pr(t);
    let o;
    try {
      o = e(...i);
    } finally {
      Pr(s), r._d && Gs(1);
    }
    return process.env.NODE_ENV !== "production" && ha(t), o;
  };
  return r._n = !0, r._c = !0, r._d = !0, r;
}
function va(e) {
  Pl(e) && k("Do not use built-in directive ids as custom directive id: " + e);
}
function Rt(e, t, n, r) {
  const i = e.dirs, s = t && t.dirs;
  for (let o = 0; o < i.length; o++) {
    const a = i[o];
    s && (a.oldValue = s[o].value);
    let l = a.dir[r];
    l && (gt(), st(l, n, 8, [
      e.el,
      a,
      e,
      t
    ]), vt());
  }
}
const Uc = Symbol("_vte"), Hc = (e) => e.__isTeleport;
function gs(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, gs(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function vn(e, t) {
  return M(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    se({ name: e.name }, t, { setup: e })
  ) : e;
}
function ya(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
const Bc = /* @__PURE__ */ new WeakSet();
function jr(e, t, n, r, i = !1) {
  if (A(e)) {
    e.forEach(
      (S, R) => jr(
        S,
        t && (A(t) ? t[R] : t),
        n,
        r,
        i
      )
    );
    return;
  }
  if (Pn(r) && !i) {
    r.shapeFlag & 512 && r.type.__asyncResolved && r.component.subTree.component && jr(e, t, n, r.component.subTree);
    return;
  }
  const s = r.shapeFlag & 4 ? xs(r.component) : r.el, o = i ? null : s, { i: a, r: l } = e;
  if (process.env.NODE_ENV !== "production" && !a) {
    k(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const c = t && t.r, d = a.refs === Q ? a.refs = {} : a.refs, f = a.setupState, h = Z(f), v = f === Q ? () => !1 : (S) => process.env.NODE_ENV !== "production" && (K(h, S) && !ae(h[S]) && k(
    `Template ref "${S}" used on a non-ref value. It will not work in the production build.`
  ), Bc.has(h[S])) ? !1 : K(h, S);
  if (c != null && c !== l && (re(c) ? (d[c] = null, v(c) && (f[c] = null)) : ae(c) && (c.value = null)), M(l))
    gn(l, a, 12, [o, d]);
  else {
    const S = re(l), R = ae(l);
    if (S || R) {
      const te = () => {
        if (e.f) {
          const G = S ? v(l) ? f[l] : d[l] : l.value;
          i ? A(G) && ns(G, s) : A(G) ? G.includes(s) || G.push(s) : S ? (d[l] = [s], v(l) && (f[l] = d[l])) : (l.value = [s], e.k && (d[e.k] = l.value));
        } else S ? (d[l] = o, v(l) && (f[l] = o)) : R ? (l.value = o, e.k && (d[e.k] = o)) : process.env.NODE_ENV !== "production" && k("Invalid template ref type:", l, `(${typeof l})`);
      };
      o ? (te.id = -1, Te(te, n)) : te();
    } else process.env.NODE_ENV !== "production" && k("Invalid template ref type:", l, `(${typeof l})`);
  }
}
sr().requestIdleCallback;
sr().cancelIdleCallback;
const Pn = (e) => !!e.type.__asyncLoader, vs = (e) => e.type.__isKeepAlive;
function Wc(e, t) {
  ba(e, "a", t);
}
function Kc(e, t) {
  ba(e, "da", t);
}
function ba(e, t, n = ue) {
  const r = e.__wdc || (e.__wdc = () => {
    let i = n;
    for (; i; ) {
      if (i.isDeactivated)
        return;
      i = i.parent;
    }
    return e();
  });
  if (ri(t, r, n), n) {
    let i = n.parent;
    for (; i && i.parent; )
      vs(i.parent.vnode) && qc(r, t, n, i), i = i.parent;
  }
}
function qc(e, t, n, r) {
  const i = ri(
    t,
    e,
    r,
    !0
    /* prepend */
  );
  _a(() => {
    ns(r[t], i);
  }, n);
}
function ri(e, t, n = ue, r = !1) {
  if (n) {
    const i = n[e] || (n[e] = []), s = t.__weh || (t.__weh = (...o) => {
      gt();
      const a = cr(n), l = st(t, n, e, o);
      return a(), vt(), l;
    });
    return r ? i.unshift(s) : i.push(s), s;
  } else if (process.env.NODE_ENV !== "production") {
    const i = $t(fs[e].replace(/ hook$/, ""));
    k(
      `${i} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const yt = (e) => (t, n = ue) => {
  (!Ln || e === "sp") && ri(e, (...r) => t(...r), n);
}, Gc = yt("bm"), Jc = yt("m"), Yc = yt(
  "bu"
), Xc = yt("u"), Qc = yt(
  "bum"
), _a = yt("um"), eu = yt(
  "sp"
), tu = yt("rtg"), nu = yt("rtc");
function ru(e, t = ue) {
  ri("ec", e, t);
}
const iu = "components", wa = Symbol.for("v-ndc");
function su(e) {
  return re(e) ? ou(iu, e, !1) || e : e || wa;
}
function ou(e, t, n = !0, r = !1) {
  const i = Oe || ue;
  if (i) {
    const s = i.type;
    {
      const a = Es(
        s,
        !1
      );
      if (a && (a === t || a === fe(t) || a === Kt(fe(t))))
        return s;
    }
    const o = (
      // local registration
      // check instance[type] first which is resolved for options API
      Ms(i[e] || s[e], t) || // global registration
      Ms(i.appContext[e], t)
    );
    return !o && r ? s : (process.env.NODE_ENV !== "production" && n && !o && k(`Failed to resolve ${e.slice(0, -1)}: ${t}
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.`), o);
  } else process.env.NODE_ENV !== "production" && k(
    `resolve${Kt(e.slice(0, -1))} can only be used in render() or setup().`
  );
}
function Ms(e, t) {
  return e && (e[t] || e[fe(t)] || e[Kt(fe(t))]);
}
function au(e, t, n, r) {
  let i;
  const s = n, o = A(e);
  if (o || re(e)) {
    const a = o && Ut(e);
    let l = !1;
    a && (l = !we(e), e = Xr(e)), i = new Array(e.length);
    for (let c = 0, d = e.length; c < d; c++)
      i[c] = t(
        l ? ge(e[c]) : e[c],
        c,
        void 0,
        s
      );
  } else if (typeof e == "number") {
    process.env.NODE_ENV !== "production" && !Number.isInteger(e) && k(`The v-for range expect an integer value but got ${e}.`), i = new Array(e);
    for (let a = 0; a < e; a++)
      i[a] = t(a + 1, a, void 0, s);
  } else if (ee(e))
    if (e[Symbol.iterator])
      i = Array.from(
        e,
        (a, l) => t(a, l, void 0, s)
      );
    else {
      const a = Object.keys(e);
      i = new Array(a.length);
      for (let l = 0, c = a.length; l < c; l++) {
        const d = a[l];
        i[l] = t(e[d], d, l, s);
      }
    }
  else
    i = [];
  return i;
}
const Fi = (e) => e ? Ba(e) ? xs(e) : Fi(e.parent) : null, Bt = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ se(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => process.env.NODE_ENV !== "production" ? tt(e.props) : e.props,
    $attrs: (e) => process.env.NODE_ENV !== "production" ? tt(e.attrs) : e.attrs,
    $slots: (e) => process.env.NODE_ENV !== "production" ? tt(e.slots) : e.slots,
    $refs: (e) => process.env.NODE_ENV !== "production" ? tt(e.refs) : e.refs,
    $parent: (e) => Fi(e.parent),
    $root: (e) => Fi(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => ka(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      ni(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = la.bind(e.proxy)),
    $watch: (e) => Lu.bind(e)
  })
), ys = (e) => e === "_" || e === "$", ki = (e, t) => e !== Q && !e.__isScriptSetup && K(e, t), xa = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: n, setupState: r, data: i, props: s, accessCache: o, type: a, appContext: l } = e;
    if (process.env.NODE_ENV !== "production" && t === "__isVue")
      return !0;
    let c;
    if (t[0] !== "$") {
      const v = o[t];
      if (v !== void 0)
        switch (v) {
          case 1:
            return r[t];
          case 2:
            return i[t];
          case 4:
            return n[t];
          case 3:
            return s[t];
        }
      else {
        if (ki(r, t))
          return o[t] = 1, r[t];
        if (i !== Q && K(i, t))
          return o[t] = 2, i[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (c = e.propsOptions[0]) && K(c, t)
        )
          return o[t] = 3, s[t];
        if (n !== Q && K(n, t))
          return o[t] = 4, n[t];
        Li && (o[t] = 0);
      }
    }
    const d = Bt[t];
    let f, h;
    if (d)
      return t === "$attrs" ? (le(e.attrs, "get", ""), process.env.NODE_ENV !== "production" && Mr()) : process.env.NODE_ENV !== "production" && t === "$slots" && le(e, "get", t), d(e);
    if (
      // css module (injected by vue-loader)
      (f = a.__cssModules) && (f = f[t])
    )
      return f;
    if (n !== Q && K(n, t))
      return o[t] = 4, n[t];
    if (
      // global properties
      h = l.config.globalProperties, K(h, t)
    )
      return h[t];
    process.env.NODE_ENV !== "production" && Oe && (!re(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    t.indexOf("__v") !== 0) && (i !== Q && ys(t[0]) && K(i, t) ? k(
      `Property ${JSON.stringify(
        t
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === Oe && k(
      `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, t, n) {
    const { data: r, setupState: i, ctx: s } = e;
    return ki(i, t) ? (i[t] = n, !0) : process.env.NODE_ENV !== "production" && i.__isScriptSetup && K(i, t) ? (k(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : r !== Q && K(r, t) ? (r[t] = n, !0) : K(e.props, t) ? (process.env.NODE_ENV !== "production" && k(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && k(
      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(s, t, {
      enumerable: !0,
      configurable: !0,
      value: n
    }) : s[t] = n, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: i, propsOptions: s }
  }, o) {
    let a;
    return !!n[o] || e !== Q && K(e, o) || ki(t, o) || (a = s[0]) && K(a, o) || K(r, o) || K(Bt, o) || K(i.config.globalProperties, o);
  },
  defineProperty(e, t, n) {
    return n.get != null ? e._.accessCache[t] = 0 : K(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
  }
};
process.env.NODE_ENV !== "production" && (xa.ownKeys = (e) => (k(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
function lu(e) {
  const t = {};
  return Object.defineProperty(t, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => e
  }), Object.keys(Bt).forEach((n) => {
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !1,
      get: () => Bt[n](e),
      // intercepted by the proxy so no need for implementation,
      // but needed to prevent set errors
      set: ce
    });
  }), t;
}
function cu(e) {
  const {
    ctx: t,
    propsOptions: [n]
  } = e;
  n && Object.keys(n).forEach((r) => {
    Object.defineProperty(t, r, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[r],
      set: ce
    });
  });
}
function uu(e) {
  const { ctx: t, setupState: n } = e;
  Object.keys(Z(n)).forEach((r) => {
    if (!n.__isScriptSetup) {
      if (ys(r[0])) {
        k(
          `setup() return property ${JSON.stringify(
            r
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(t, r, {
        enumerable: !0,
        configurable: !0,
        get: () => n[r],
        set: ce
      });
    }
  });
}
function $s(e) {
  return A(e) ? e.reduce(
    (t, n) => (t[n] = null, t),
    {}
  ) : e;
}
function du() {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, n) => {
    e[n] ? k(`${t} property "${n}" is already defined in ${e[n]}.`) : e[n] = t;
  };
}
let Li = !0;
function fu(e) {
  const t = ka(e), n = e.proxy, r = e.ctx;
  Li = !1, t.beforeCreate && Fs(t.beforeCreate, e, "bc");
  const {
    // state
    data: i,
    computed: s,
    methods: o,
    watch: a,
    provide: l,
    inject: c,
    // lifecycle
    created: d,
    beforeMount: f,
    mounted: h,
    beforeUpdate: v,
    updated: S,
    activated: R,
    deactivated: te,
    beforeDestroy: G,
    beforeUnmount: oe,
    destroyed: Y,
    unmounted: Se,
    render: P,
    renderTracked: de,
    renderTriggered: Re,
    errorCaptured: me,
    serverPrefetch: Ee,
    // public API
    expose: lt,
    inheritAttrs: bt,
    // assets
    components: Le,
    directives: dr,
    filters: Os
  } = t, _t = process.env.NODE_ENV !== "production" ? du() : null;
  if (process.env.NODE_ENV !== "production") {
    const [B] = e.propsOptions;
    if (B)
      for (const U in B)
        _t("Props", U);
  }
  if (c && pu(c, r, _t), o)
    for (const B in o) {
      const U = o[B];
      M(U) ? (process.env.NODE_ENV !== "production" ? Object.defineProperty(r, B, {
        value: U.bind(n),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : r[B] = U.bind(n), process.env.NODE_ENV !== "production" && _t("Methods", B)) : process.env.NODE_ENV !== "production" && k(
        `Method "${B}" has type "${typeof U}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (i) {
    process.env.NODE_ENV !== "production" && !M(i) && k(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const B = i.call(n, n);
    if (process.env.NODE_ENV !== "production" && rs(B) && k(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !ee(B))
      process.env.NODE_ENV !== "production" && k("data() should return an object.");
    else if (e.data = ds(B), process.env.NODE_ENV !== "production")
      for (const U in B)
        _t("Data", U), ys(U[0]) || Object.defineProperty(r, U, {
          configurable: !0,
          enumerable: !0,
          get: () => B[U],
          set: ce
        });
  }
  if (Li = !0, s)
    for (const B in s) {
      const U = s[B], Ke = M(U) ? U.bind(n, n) : M(U.get) ? U.get.bind(n, n) : ce;
      process.env.NODE_ENV !== "production" && Ke === ce && k(`Computed property "${B}" has no getter.`);
      const mi = !M(U) && M(U.set) ? U.set.bind(n) : process.env.NODE_ENV !== "production" ? () => {
        k(
          `Write operation failed: computed property "${B}" is readonly.`
        );
      } : ce, yn = un({
        get: Ke,
        set: mi
      });
      Object.defineProperty(r, B, {
        enumerable: !0,
        configurable: !0,
        get: () => yn.value,
        set: (Xt) => yn.value = Xt
      }), process.env.NODE_ENV !== "production" && _t("Computed", B);
    }
  if (a)
    for (const B in a)
      Ea(a[B], r, n, B);
  if (l) {
    const B = M(l) ? l.call(n) : l;
    Reflect.ownKeys(B).forEach((U) => {
      bu(U, B[U]);
    });
  }
  d && Fs(d, e, "c");
  function ke(B, U) {
    A(U) ? U.forEach((Ke) => B(Ke.bind(n))) : U && B(U.bind(n));
  }
  if (ke(Gc, f), ke(Jc, h), ke(Yc, v), ke(Xc, S), ke(Wc, R), ke(Kc, te), ke(ru, me), ke(nu, de), ke(tu, Re), ke(Qc, oe), ke(_a, Se), ke(eu, Ee), A(lt))
    if (lt.length) {
      const B = e.exposed || (e.exposed = {});
      lt.forEach((U) => {
        Object.defineProperty(B, U, {
          get: () => n[U],
          set: (Ke) => n[U] = Ke
        });
      });
    } else e.exposed || (e.exposed = {});
  P && e.render === ce && (e.render = P), bt != null && (e.inheritAttrs = bt), Le && (e.components = Le), dr && (e.directives = dr), Ee && ya(e);
}
function pu(e, t, n = ce) {
  A(e) && (e = Zi(e));
  for (const r in e) {
    const i = e[r];
    let s;
    ee(i) ? "default" in i ? s = _r(
      i.from || r,
      i.default,
      !0
    ) : s = _r(i.from || r) : s = _r(i), ae(s) ? Object.defineProperty(t, r, {
      enumerable: !0,
      configurable: !0,
      get: () => s.value,
      set: (o) => s.value = o
    }) : t[r] = s, process.env.NODE_ENV !== "production" && n("Inject", r);
  }
}
function Fs(e, t, n) {
  st(
    A(e) ? e.map((r) => r.bind(t.proxy)) : e.bind(t.proxy),
    t,
    n
  );
}
function Ea(e, t, n, r) {
  let i = r.includes(".") ? Ma(n, r) : () => n[r];
  if (re(e)) {
    const s = t[e];
    M(s) ? Oi(i, s) : process.env.NODE_ENV !== "production" && k(`Invalid watch handler specified by key "${e}"`, s);
  } else if (M(e))
    Oi(i, e.bind(n));
  else if (ee(e))
    if (A(e))
      e.forEach((s) => Ea(s, t, n, r));
    else {
      const s = M(e.handler) ? e.handler.bind(n) : t[e.handler];
      M(s) ? Oi(i, s, e) : process.env.NODE_ENV !== "production" && k(`Invalid watch handler specified by key "${e.handler}"`, s);
    }
  else process.env.NODE_ENV !== "production" && k(`Invalid watch option: "${r}"`, e);
}
function ka(e) {
  const t = e.type, { mixins: n, extends: r } = t, {
    mixins: i,
    optionsCache: s,
    config: { optionMergeStrategies: o }
  } = e.appContext, a = s.get(t);
  let l;
  return a ? l = a : !i.length && !n && !r ? l = t : (l = {}, i.length && i.forEach(
    (c) => Ir(l, c, o, !0)
  ), Ir(l, t, o)), ee(t) && s.set(t, l), l;
}
function Ir(e, t, n, r = !1) {
  const { mixins: i, extends: s } = t;
  s && Ir(e, s, n, !0), i && i.forEach(
    (o) => Ir(e, o, n, !0)
  );
  for (const o in t)
    if (r && o === "expose")
      process.env.NODE_ENV !== "production" && k(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const a = hu[o] || n && n[o];
      e[o] = a ? a(e[o], t[o]) : t[o];
    }
  return e;
}
const hu = {
  data: Ls,
  props: Zs,
  emits: Zs,
  // objects
  methods: Sn,
  computed: Sn,
  // lifecycle
  beforeCreate: be,
  created: be,
  beforeMount: be,
  mounted: be,
  beforeUpdate: be,
  updated: be,
  beforeDestroy: be,
  beforeUnmount: be,
  destroyed: be,
  unmounted: be,
  activated: be,
  deactivated: be,
  errorCaptured: be,
  serverPrefetch: be,
  // assets
  components: Sn,
  directives: Sn,
  // watch
  watch: gu,
  // provide / inject
  provide: Ls,
  inject: mu
};
function Ls(e, t) {
  return t ? e ? function() {
    return se(
      M(e) ? e.call(this, this) : e,
      M(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function mu(e, t) {
  return Sn(Zi(e), Zi(t));
}
function Zi(e) {
  if (A(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++)
      t[e[n]] = e[n];
    return t;
  }
  return e;
}
function be(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function Sn(e, t) {
  return e ? se(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function Zs(e, t) {
  return e ? A(e) && A(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : se(
    /* @__PURE__ */ Object.create(null),
    $s(e),
    $s(t ?? {})
  ) : t;
}
function gu(e, t) {
  if (!e) return t;
  if (!t) return e;
  const n = se(/* @__PURE__ */ Object.create(null), e);
  for (const r in t)
    n[r] = be(e[r], t[r]);
  return n;
}
function Na() {
  return {
    app: null,
    config: {
      isNativeTag: Vl,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let vu = 0;
function yu(e, t) {
  return function(r, i = null) {
    M(r) || (r = se({}, r)), i != null && !ee(i) && (process.env.NODE_ENV !== "production" && k("root props passed to app.mount() must be an object."), i = null);
    const s = Na(), o = /* @__PURE__ */ new WeakSet(), a = [];
    let l = !1;
    const c = s.app = {
      _uid: vu++,
      _component: r,
      _props: i,
      _container: null,
      _context: s,
      _instance: null,
      version: Qs,
      get config() {
        return s.config;
      },
      set config(d) {
        process.env.NODE_ENV !== "production" && k(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use(d, ...f) {
        return o.has(d) ? process.env.NODE_ENV !== "production" && k("Plugin has already been applied to target app.") : d && M(d.install) ? (o.add(d), d.install(c, ...f)) : M(d) ? (o.add(d), d(c, ...f)) : process.env.NODE_ENV !== "production" && k(
          'A plugin must either be a function or an object with an "install" function.'
        ), c;
      },
      mixin(d) {
        return s.mixins.includes(d) ? process.env.NODE_ENV !== "production" && k(
          "Mixin has already been applied to target app" + (d.name ? `: ${d.name}` : "")
        ) : s.mixins.push(d), c;
      },
      component(d, f) {
        return process.env.NODE_ENV !== "production" && Wi(d, s.config), f ? (process.env.NODE_ENV !== "production" && s.components[d] && k(`Component "${d}" has already been registered in target app.`), s.components[d] = f, c) : s.components[d];
      },
      directive(d, f) {
        return process.env.NODE_ENV !== "production" && va(d), f ? (process.env.NODE_ENV !== "production" && s.directives[d] && k(`Directive "${d}" has already been registered in target app.`), s.directives[d] = f, c) : s.directives[d];
      },
      mount(d, f, h) {
        if (l)
          process.env.NODE_ENV !== "production" && k(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          process.env.NODE_ENV !== "production" && d.__vue_app__ && k(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const v = c._ceVNode || $e(r, i);
          return v.appContext = s, h === !0 ? h = "svg" : h === !1 && (h = void 0), process.env.NODE_ENV !== "production" && (s.reload = () => {
            e(
              Tt(v),
              d,
              h
            );
          }), e(v, d, h), l = !0, c._container = d, d.__vue_app__ = c, process.env.NODE_ENV !== "production" && (c._instance = v.component, jc(c, Qs)), xs(v.component);
        }
      },
      onUnmount(d) {
        process.env.NODE_ENV !== "production" && typeof d != "function" && k(
          `Expected function as first argument to app.onUnmount(), but got ${typeof d}`
        ), a.push(d);
      },
      unmount() {
        l ? (st(
          a,
          c._instance,
          16
        ), e(null, c._container), process.env.NODE_ENV !== "production" && (c._instance = null, Ic(c)), delete c._container.__vue_app__) : process.env.NODE_ENV !== "production" && k("Cannot unmount an app that is not mounted.");
      },
      provide(d, f) {
        return process.env.NODE_ENV !== "production" && d in s.provides && k(
          `App already provides property with key "${String(d)}". It will be overwritten with the new value.`
        ), s.provides[d] = f, c;
      },
      runWithContext(d) {
        const f = ln;
        ln = c;
        try {
          return d();
        } finally {
          ln = f;
        }
      }
    };
    return c;
  };
}
let ln = null;
function bu(e, t) {
  if (!ue)
    process.env.NODE_ENV !== "production" && k("provide() can only be used inside setup().");
  else {
    let n = ue.provides;
    const r = ue.parent && ue.parent.provides;
    r === n && (n = ue.provides = Object.create(r)), n[e] = t;
  }
}
function _r(e, t, n = !1) {
  const r = ue || Oe;
  if (r || ln) {
    const i = ln ? ln._context.provides : r ? r.parent == null ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
    if (i && e in i)
      return i[e];
    if (arguments.length > 1)
      return n && M(t) ? t.call(r && r.proxy) : t;
    process.env.NODE_ENV !== "production" && k(`injection "${String(e)}" not found.`);
  } else process.env.NODE_ENV !== "production" && k("inject() can only be used inside setup() or functional components.");
}
const Oa = {}, Sa = () => Object.create(Oa), Ca = (e) => Object.getPrototypeOf(e) === Oa;
function _u(e, t, n, r = !1) {
  const i = {}, s = Sa();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), Ta(e, t, i, s);
  for (const o in e.propsOptions[0])
    o in i || (i[o] = void 0);
  process.env.NODE_ENV !== "production" && Va(t || {}, i, e), n ? e.props = r ? i : mc(i) : e.type.props ? e.props = i : e.props = s, e.attrs = s;
}
function wu(e) {
  for (; e; ) {
    if (e.type.__hmrId) return !0;
    e = e.parent;
  }
}
function xu(e, t, n, r) {
  const {
    props: i,
    attrs: s,
    vnode: { patchFlag: o }
  } = e, a = Z(i), [l] = e.propsOptions;
  let c = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(process.env.NODE_ENV !== "production" && wu(e)) && (r || o > 0) && !(o & 16)
  ) {
    if (o & 8) {
      const d = e.vnode.dynamicProps;
      for (let f = 0; f < d.length; f++) {
        let h = d[f];
        if (ii(e.emitsOptions, h))
          continue;
        const v = t[h];
        if (l)
          if (K(s, h))
            v !== s[h] && (s[h] = v, c = !0);
          else {
            const S = fe(h);
            i[S] = zi(
              l,
              a,
              S,
              v,
              e,
              !1
            );
          }
        else
          v !== s[h] && (s[h] = v, c = !0);
      }
    }
  } else {
    Ta(e, t, i, s) && (c = !0);
    let d;
    for (const f in a)
      (!t || // for camelCase
      !K(t, f) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((d = Ve(f)) === f || !K(t, d))) && (l ? n && // for camelCase
      (n[f] !== void 0 || // for kebab-case
      n[d] !== void 0) && (i[f] = zi(
        l,
        a,
        f,
        void 0,
        e,
        !0
      )) : delete i[f]);
    if (s !== a)
      for (const f in s)
        (!t || !K(t, f)) && (delete s[f], c = !0);
  }
  c && et(e.attrs, "set", ""), process.env.NODE_ENV !== "production" && Va(t || {}, i, e);
}
function Ta(e, t, n, r) {
  const [i, s] = e.propsOptions;
  let o = !1, a;
  if (t)
    for (let l in t) {
      if (Dn(l))
        continue;
      const c = t[l];
      let d;
      i && K(i, d = fe(l)) ? !s || !s.includes(d) ? n[d] = c : (a || (a = {}))[d] = c : ii(e.emitsOptions, l) || (!(l in r) || c !== r[l]) && (r[l] = c, o = !0);
    }
  if (s) {
    const l = Z(n), c = a || Q;
    for (let d = 0; d < s.length; d++) {
      const f = s[d];
      n[f] = zi(
        i,
        l,
        f,
        c[f],
        e,
        !K(c, f)
      );
    }
  }
  return o;
}
function zi(e, t, n, r, i, s) {
  const o = e[n];
  if (o != null) {
    const a = K(o, "default");
    if (a && r === void 0) {
      const l = o.default;
      if (o.type !== Function && !o.skipFactory && M(l)) {
        const { propsDefaults: c } = i;
        if (n in c)
          r = c[n];
        else {
          const d = cr(i);
          r = c[n] = l.call(
            null,
            t
          ), d();
        }
      } else
        r = l;
      i.ce && i.ce._setProp(n, r);
    }
    o[
      0
      /* shouldCast */
    ] && (s && !a ? r = !1 : o[
      1
      /* shouldCastTrue */
    ] && (r === "" || r === Ve(n)) && (r = !0));
  }
  return r;
}
const Eu = /* @__PURE__ */ new WeakMap();
function Da(e, t, n = !1) {
  const r = n ? Eu : t.propsCache, i = r.get(e);
  if (i)
    return i;
  const s = e.props, o = {}, a = [];
  let l = !1;
  if (!M(e)) {
    const d = (f) => {
      l = !0;
      const [h, v] = Da(f, t, !0);
      se(o, h), v && a.push(...v);
    };
    !n && t.mixins.length && t.mixins.forEach(d), e.extends && d(e.extends), e.mixins && e.mixins.forEach(d);
  }
  if (!s && !l)
    return ee(e) && r.set(e, on), on;
  if (A(s))
    for (let d = 0; d < s.length; d++) {
      process.env.NODE_ENV !== "production" && !re(s[d]) && k("props must be strings when using array syntax.", s[d]);
      const f = fe(s[d]);
      zs(f) && (o[f] = Q);
    }
  else if (s) {
    process.env.NODE_ENV !== "production" && !ee(s) && k("invalid props options", s);
    for (const d in s) {
      const f = fe(d);
      if (zs(f)) {
        const h = s[d], v = o[f] = A(h) || M(h) ? { type: h } : se({}, h), S = v.type;
        let R = !1, te = !0;
        if (A(S))
          for (let G = 0; G < S.length; ++G) {
            const oe = S[G], Y = M(oe) && oe.name;
            if (Y === "Boolean") {
              R = !0;
              break;
            } else Y === "String" && (te = !1);
          }
        else
          R = M(S) && S.name === "Boolean";
        v[
          0
          /* shouldCast */
        ] = R, v[
          1
          /* shouldCastTrue */
        ] = te, (R || K(v, "default")) && a.push(f);
      }
    }
  }
  const c = [o, a];
  return ee(e) && r.set(e, c), c;
}
function zs(e) {
  return e[0] !== "$" && !Dn(e) ? !0 : (process.env.NODE_ENV !== "production" && k(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function ku(e) {
  return e === null ? "null" : typeof e == "function" ? e.name || "" : typeof e == "object" && e.constructor && e.constructor.name || "";
}
function Va(e, t, n) {
  const r = Z(t), i = n.propsOptions[0], s = Object.keys(e).map((o) => fe(o));
  for (const o in i) {
    let a = i[o];
    a != null && Nu(
      o,
      r[o],
      a,
      process.env.NODE_ENV !== "production" ? tt(r) : r,
      !s.includes(o)
    );
  }
}
function Nu(e, t, n, r, i) {
  const { type: s, required: o, validator: a, skipCheck: l } = n;
  if (o && i) {
    k('Missing required prop: "' + e + '"');
    return;
  }
  if (!(t == null && !o)) {
    if (s != null && s !== !0 && !l) {
      let c = !1;
      const d = A(s) ? s : [s], f = [];
      for (let h = 0; h < d.length && !c; h++) {
        const { valid: v, expectedType: S } = Su(t, d[h]);
        f.push(S || ""), c = v;
      }
      if (!c) {
        k(Cu(e, t, f));
        return;
      }
    }
    a && !a(t, r) && k('Invalid prop: custom validator check failed for prop "' + e + '".');
  }
}
const Ou = /* @__PURE__ */ mt(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function Su(e, t) {
  let n;
  const r = ku(t);
  if (r === "null")
    n = e === null;
  else if (Ou(r)) {
    const i = typeof e;
    n = i === r.toLowerCase(), !n && i === "object" && (n = e instanceof t);
  } else r === "Object" ? n = ee(e) : r === "Array" ? n = A(e) : n = e instanceof t;
  return {
    valid: n,
    expectedType: r
  };
}
function Cu(e, t, n) {
  if (n.length === 0)
    return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
  let r = `Invalid prop: type check failed for prop "${e}". Expected ${n.map(Kt).join(" | ")}`;
  const i = n[0], s = is(t), o = Us(t, i), a = Us(t, s);
  return n.length === 1 && Hs(i) && !Tu(i, s) && (r += ` with value ${o}`), r += `, got ${s} `, Hs(s) && (r += `with value ${a}.`), r;
}
function Us(e, t) {
  return t === "String" ? `"${e}"` : t === "Number" ? `${Number(e)}` : `${e}`;
}
function Hs(e) {
  return ["string", "number", "boolean"].some((n) => e.toLowerCase() === n);
}
function Tu(...e) {
  return e.some((t) => t.toLowerCase() === "boolean");
}
const Aa = (e) => e[0] === "_" || e === "$stable", bs = (e) => A(e) ? e.map(Ze) : [Ze(e)], Du = (e, t, n) => {
  if (t._n)
    return t;
  const r = zc((...i) => (process.env.NODE_ENV !== "production" && ue && (!n || n.root === ue.root) && k(
    `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), bs(t(...i))), n);
  return r._c = !1, r;
}, Pa = (e, t, n) => {
  const r = e._ctx;
  for (const i in e) {
    if (Aa(i)) continue;
    const s = e[i];
    if (M(s))
      t[i] = Du(i, s, r);
    else if (s != null) {
      process.env.NODE_ENV !== "production" && k(
        `Non-function value encountered for slot "${i}". Prefer function slots for better performance.`
      );
      const o = bs(s);
      t[i] = () => o;
    }
  }
}, ja = (e, t) => {
  process.env.NODE_ENV !== "production" && !vs(e.vnode) && k(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const n = bs(t);
  e.slots.default = () => n;
}, Ui = (e, t, n) => {
  for (const r in t)
    (n || r !== "_") && (e[r] = t[r]);
}, Vu = (e, t, n) => {
  const r = e.slots = Sa();
  if (e.vnode.shapeFlag & 32) {
    const i = t._;
    i ? (Ui(r, t, n), n && Cr(r, "_", i, !0)) : Pa(t, r);
  } else t && ja(e, t);
}, Au = (e, t, n) => {
  const { vnode: r, slots: i } = e;
  let s = !0, o = Q;
  if (r.shapeFlag & 32) {
    const a = t._;
    a ? process.env.NODE_ENV !== "production" && nt ? (Ui(i, t, n), et(e, "set", "$slots")) : n && a === 1 ? s = !1 : Ui(i, t, n) : (s = !t.$stable, Pa(t, i)), o = t;
  } else t && (ja(e, t), o = { default: 1 });
  if (s)
    for (const a in i)
      !Aa(a) && o[a] == null && delete i[a];
};
let kn, Ot;
function en(e, t) {
  e.appContext.config.performance && Rr() && Ot.mark(`vue-${t}-${e.uid}`), process.env.NODE_ENV !== "production" && Fc(e, t, Rr() ? Ot.now() : Date.now());
}
function tn(e, t) {
  if (e.appContext.config.performance && Rr()) {
    const n = `vue-${t}-${e.uid}`, r = n + ":end";
    Ot.mark(r), Ot.measure(
      `<${li(e, e.type)}> ${t}`,
      n,
      r
    ), Ot.clearMarks(n), Ot.clearMarks(r);
  }
  process.env.NODE_ENV !== "production" && Lc(e, t, Rr() ? Ot.now() : Date.now());
}
function Rr() {
  return kn !== void 0 || (typeof window < "u" && window.performance ? (kn = !0, Ot = window.performance) : kn = !1), kn;
}
function Pu() {
  const e = [];
  if (process.env.NODE_ENV !== "production" && e.length) {
    const t = e.length > 1;
    console.warn(
      `Feature flag${t ? "s" : ""} ${e.join(", ")} ${t ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const Te = Ku;
function ju(e) {
  return Iu(e);
}
function Iu(e, t) {
  Pu();
  const n = sr();
  n.__VUE__ = !0, process.env.NODE_ENV !== "production" && hs(n.__VUE_DEVTOOLS_GLOBAL_HOOK__, n);
  const {
    insert: r,
    remove: i,
    patchProp: s,
    createElement: o,
    createText: a,
    createComment: l,
    setText: c,
    setElementText: d,
    parentNode: f,
    nextSibling: h,
    setScopeId: v = ce,
    insertStaticContent: S
  } = e, R = (u, p, m, b = null, g = null, y = null, N = void 0, E = null, x = process.env.NODE_ENV !== "production" && nt ? !1 : !!p.dynamicChildren) => {
    if (u === p)
      return;
    u && !Nn(u, p) && (b = fr(u), wt(u, g, y, !0), u = null), p.patchFlag === -2 && (x = !1, p.dynamicChildren = null);
    const { type: _, ref: j, shapeFlag: O } = p;
    switch (_) {
      case lr:
        te(u, p, m, b);
        break;
      case Pe:
        G(u, p, m, b);
        break;
      case xr:
        u == null ? oe(p, m, b, N) : process.env.NODE_ENV !== "production" && Y(u, p, m, N);
        break;
      case Me:
        dr(
          u,
          p,
          m,
          b,
          g,
          y,
          N,
          E,
          x
        );
        break;
      default:
        O & 1 ? de(
          u,
          p,
          m,
          b,
          g,
          y,
          N,
          E,
          x
        ) : O & 6 ? Os(
          u,
          p,
          m,
          b,
          g,
          y,
          N,
          E,
          x
        ) : O & 64 || O & 128 ? _.process(
          u,
          p,
          m,
          b,
          g,
          y,
          N,
          E,
          x,
          _n
        ) : process.env.NODE_ENV !== "production" && k("Invalid VNode type:", _, `(${typeof _})`);
    }
    j != null && g && jr(j, u && u.ref, y, p || u, !p);
  }, te = (u, p, m, b) => {
    if (u == null)
      r(
        p.el = a(p.children),
        m,
        b
      );
    else {
      const g = p.el = u.el;
      p.children !== u.children && c(g, p.children);
    }
  }, G = (u, p, m, b) => {
    u == null ? r(
      p.el = l(p.children || ""),
      m,
      b
    ) : p.el = u.el;
  }, oe = (u, p, m, b) => {
    [u.el, u.anchor] = S(
      u.children,
      p,
      m,
      b,
      u.el,
      u.anchor
    );
  }, Y = (u, p, m, b) => {
    if (p.children !== u.children) {
      const g = h(u.anchor);
      P(u), [p.el, p.anchor] = S(
        p.children,
        m,
        g,
        b
      );
    } else
      p.el = u.el, p.anchor = u.anchor;
  }, Se = ({ el: u, anchor: p }, m, b) => {
    let g;
    for (; u && u !== p; )
      g = h(u), r(u, m, b), u = g;
    r(p, m, b);
  }, P = ({ el: u, anchor: p }) => {
    let m;
    for (; u && u !== p; )
      m = h(u), i(u), u = m;
    i(p);
  }, de = (u, p, m, b, g, y, N, E, x) => {
    p.type === "svg" ? N = "svg" : p.type === "math" && (N = "mathml"), u == null ? Re(
      p,
      m,
      b,
      g,
      y,
      N,
      E,
      x
    ) : lt(
      u,
      p,
      g,
      y,
      N,
      E,
      x
    );
  }, Re = (u, p, m, b, g, y, N, E) => {
    let x, _;
    const { props: j, shapeFlag: O, transition: V, dirs: F } = u;
    if (x = u.el = o(
      u.type,
      y,
      j && j.is,
      j
    ), O & 8 ? d(x, u.children) : O & 16 && Ee(
      u.children,
      x,
      null,
      b,
      g,
      Ni(u, y),
      N,
      E
    ), F && Rt(u, null, b, "created"), me(x, u, u.scopeId, N, b), j) {
      for (const ne in j)
        ne !== "value" && !Dn(ne) && s(x, ne, null, j[ne], y, b);
      "value" in j && s(x, "value", null, j.value, y), (_ = j.onVnodeBeforeMount) && Ye(_, b, u);
    }
    process.env.NODE_ENV !== "production" && (Cr(x, "__vnode", u, !0), Cr(x, "__vueParentComponent", b, !0)), F && Rt(u, null, b, "beforeMount");
    const W = Ru(g, V);
    W && V.beforeEnter(x), r(x, p, m), ((_ = j && j.onVnodeMounted) || W || F) && Te(() => {
      _ && Ye(_, b, u), W && V.enter(x), F && Rt(u, null, b, "mounted");
    }, g);
  }, me = (u, p, m, b, g) => {
    if (m && v(u, m), b)
      for (let y = 0; y < b.length; y++)
        v(u, b[y]);
    if (g) {
      let y = g.subTree;
      if (process.env.NODE_ENV !== "production" && y.patchFlag > 0 && y.patchFlag & 2048 && (y = _s(y.children) || y), p === y || La(y.type) && (y.ssContent === p || y.ssFallback === p)) {
        const N = g.vnode;
        me(
          u,
          N,
          N.scopeId,
          N.slotScopeIds,
          g.parent
        );
      }
    }
  }, Ee = (u, p, m, b, g, y, N, E, x = 0) => {
    for (let _ = x; _ < u.length; _++) {
      const j = u[_] = E ? kt(u[_]) : Ze(u[_]);
      R(
        null,
        j,
        p,
        m,
        b,
        g,
        y,
        N,
        E
      );
    }
  }, lt = (u, p, m, b, g, y, N) => {
    const E = p.el = u.el;
    process.env.NODE_ENV !== "production" && (E.__vnode = p);
    let { patchFlag: x, dynamicChildren: _, dirs: j } = p;
    x |= u.patchFlag & 16;
    const O = u.props || Q, V = p.props || Q;
    let F;
    if (m && Mt(m, !1), (F = V.onVnodeBeforeUpdate) && Ye(F, m, p, u), j && Rt(p, u, m, "beforeUpdate"), m && Mt(m, !0), process.env.NODE_ENV !== "production" && nt && (x = 0, N = !1, _ = null), (O.innerHTML && V.innerHTML == null || O.textContent && V.textContent == null) && d(E, ""), _ ? (bt(
      u.dynamicChildren,
      _,
      E,
      m,
      b,
      Ni(p, g),
      y
    ), process.env.NODE_ENV !== "production" && wr(u, p)) : N || Ke(
      u,
      p,
      E,
      null,
      m,
      b,
      Ni(p, g),
      y,
      !1
    ), x > 0) {
      if (x & 16)
        Le(E, O, V, m, g);
      else if (x & 2 && O.class !== V.class && s(E, "class", null, V.class, g), x & 4 && s(E, "style", O.style, V.style, g), x & 8) {
        const W = p.dynamicProps;
        for (let ne = 0; ne < W.length; ne++) {
          const X = W[ne], Ce = O[X], Ne = V[X];
          (Ne !== Ce || X === "value") && s(E, X, Ce, Ne, g, m);
        }
      }
      x & 1 && u.children !== p.children && d(E, p.children);
    } else !N && _ == null && Le(E, O, V, m, g);
    ((F = V.onVnodeUpdated) || j) && Te(() => {
      F && Ye(F, m, p, u), j && Rt(p, u, m, "updated");
    }, b);
  }, bt = (u, p, m, b, g, y, N) => {
    for (let E = 0; E < p.length; E++) {
      const x = u[E], _ = p[E], j = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        x.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (x.type === Me || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Nn(x, _) || // - In the case of a component, it could contain anything.
        x.shapeFlag & 70) ? f(x.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          m
        )
      );
      R(
        x,
        _,
        j,
        null,
        b,
        g,
        y,
        N,
        !0
      );
    }
  }, Le = (u, p, m, b, g) => {
    if (p !== m) {
      if (p !== Q)
        for (const y in p)
          !Dn(y) && !(y in m) && s(
            u,
            y,
            p[y],
            null,
            g,
            b
          );
      for (const y in m) {
        if (Dn(y)) continue;
        const N = m[y], E = p[y];
        N !== E && y !== "value" && s(u, y, E, N, g, b);
      }
      "value" in m && s(u, "value", p.value, m.value, g);
    }
  }, dr = (u, p, m, b, g, y, N, E, x) => {
    const _ = p.el = u ? u.el : a(""), j = p.anchor = u ? u.anchor : a("");
    let { patchFlag: O, dynamicChildren: V, slotScopeIds: F } = p;
    process.env.NODE_ENV !== "production" && // #5523 dev root fragment may inherit directives
    (nt || O & 2048) && (O = 0, x = !1, V = null), F && (E = E ? E.concat(F) : F), u == null ? (r(_, m, b), r(j, m, b), Ee(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      p.children || [],
      m,
      j,
      g,
      y,
      N,
      E,
      x
    )) : O > 0 && O & 64 && V && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    u.dynamicChildren ? (bt(
      u.dynamicChildren,
      V,
      m,
      g,
      y,
      N,
      E
    ), process.env.NODE_ENV !== "production" ? wr(u, p) : (
      // #2080 if the stable fragment has a key, it's a <template v-for> that may
      //  get moved around. Make sure all root level vnodes inherit el.
      // #2134 or if it's a component root, it may also get moved around
      // as the component is being moved.
      (p.key != null || g && p === g.subTree) && wr(
        u,
        p,
        !0
        /* shallow */
      )
    )) : Ke(
      u,
      p,
      m,
      j,
      g,
      y,
      N,
      E,
      x
    );
  }, Os = (u, p, m, b, g, y, N, E, x) => {
    p.slotScopeIds = E, u == null ? p.shapeFlag & 512 ? g.ctx.activate(
      p,
      m,
      b,
      N,
      x
    ) : _t(
      p,
      m,
      b,
      g,
      y,
      N,
      x
    ) : ke(u, p, x);
  }, _t = (u, p, m, b, g, y, N) => {
    const E = u.component = ed(
      u,
      b,
      g
    );
    if (process.env.NODE_ENV !== "production" && E.type.__hmrId && Dc(E), process.env.NODE_ENV !== "production" && (vr(u), en(E, "mount")), vs(u) && (E.ctx.renderer = _n), process.env.NODE_ENV !== "production" && en(E, "init"), rd(E, !1, N), process.env.NODE_ENV !== "production" && tn(E, "init"), E.asyncDep) {
      if (process.env.NODE_ENV !== "production" && nt && (u.el = null), g && g.registerDep(E, B, N), !u.el) {
        const x = E.subTree = $e(Pe);
        G(null, x, p, m);
      }
    } else
      B(
        E,
        u,
        p,
        m,
        g,
        y,
        N
      );
    process.env.NODE_ENV !== "production" && (yr(), tn(E, "mount"));
  }, ke = (u, p, m) => {
    const b = p.component = u.component;
    if (Bu(u, p, m))
      if (b.asyncDep && !b.asyncResolved) {
        process.env.NODE_ENV !== "production" && vr(p), U(b, p, m), process.env.NODE_ENV !== "production" && yr();
        return;
      } else
        b.next = p, b.update();
    else
      p.el = u.el, b.vnode = p;
  }, B = (u, p, m, b, g, y, N) => {
    const E = () => {
      if (u.isMounted) {
        let { next: O, bu: V, u: F, parent: W, vnode: ne } = u;
        {
          const Ge = Ia(u);
          if (Ge) {
            O && (O.el = ne.el, U(u, O, N)), Ge.asyncDep.then(() => {
              u.isUnmounted || E();
            });
            return;
          }
        }
        let X = O, Ce;
        process.env.NODE_ENV !== "production" && vr(O || u.vnode), Mt(u, !1), O ? (O.el = ne.el, U(u, O, N)) : O = ne, V && xn(V), (Ce = O.props && O.props.onVnodeBeforeUpdate) && Ye(Ce, W, O, ne), Mt(u, !0), process.env.NODE_ENV !== "production" && en(u, "render");
        const Ne = Ws(u);
        process.env.NODE_ENV !== "production" && tn(u, "render");
        const qe = u.subTree;
        u.subTree = Ne, process.env.NODE_ENV !== "production" && en(u, "patch"), R(
          qe,
          Ne,
          // parent may have changed if it's in a teleport
          f(qe.el),
          // anchor may have changed if it's in a fragment
          fr(qe),
          u,
          g,
          y
        ), process.env.NODE_ENV !== "production" && tn(u, "patch"), O.el = Ne.el, X === null && Wu(u, Ne.el), F && Te(F, g), (Ce = O.props && O.props.onVnodeUpdated) && Te(
          () => Ye(Ce, W, O, ne),
          g
        ), process.env.NODE_ENV !== "production" && ha(u), process.env.NODE_ENV !== "production" && yr();
      } else {
        let O;
        const { el: V, props: F } = p, { bm: W, m: ne, parent: X, root: Ce, type: Ne } = u, qe = Pn(p);
        Mt(u, !1), W && xn(W), !qe && (O = F && F.onVnodeBeforeMount) && Ye(O, X, p), Mt(u, !0);
        {
          Ce.ce && Ce.ce._injectChildStyle(Ne), process.env.NODE_ENV !== "production" && en(u, "render");
          const Ge = u.subTree = Ws(u);
          process.env.NODE_ENV !== "production" && tn(u, "render"), process.env.NODE_ENV !== "production" && en(u, "patch"), R(
            null,
            Ge,
            m,
            b,
            u,
            g,
            y
          ), process.env.NODE_ENV !== "production" && tn(u, "patch"), p.el = Ge.el;
        }
        if (ne && Te(ne, g), !qe && (O = F && F.onVnodeMounted)) {
          const Ge = p;
          Te(
            () => Ye(O, X, Ge),
            g
          );
        }
        (p.shapeFlag & 256 || X && Pn(X.vnode) && X.vnode.shapeFlag & 256) && u.a && Te(u.a, g), u.isMounted = !0, process.env.NODE_ENV !== "production" && Rc(u), p = m = b = null;
      }
    };
    u.scope.on();
    const x = u.effect = new Zo(E);
    u.scope.off();
    const _ = u.update = x.run.bind(x), j = u.job = x.runIfDirty.bind(x);
    j.i = u, j.id = u.uid, x.scheduler = () => ni(j), Mt(u, !0), process.env.NODE_ENV !== "production" && (x.onTrack = u.rtc ? (O) => xn(u.rtc, O) : void 0, x.onTrigger = u.rtg ? (O) => xn(u.rtg, O) : void 0), _();
  }, U = (u, p, m) => {
    p.component = u;
    const b = u.vnode.props;
    u.vnode = p, u.next = null, xu(u, p.props, b, m), Au(u, p.children, m), gt(), Is(u), vt();
  }, Ke = (u, p, m, b, g, y, N, E, x = !1) => {
    const _ = u && u.children, j = u ? u.shapeFlag : 0, O = p.children, { patchFlag: V, shapeFlag: F } = p;
    if (V > 0) {
      if (V & 128) {
        yn(
          _,
          O,
          m,
          b,
          g,
          y,
          N,
          E,
          x
        );
        return;
      } else if (V & 256) {
        mi(
          _,
          O,
          m,
          b,
          g,
          y,
          N,
          E,
          x
        );
        return;
      }
    }
    F & 8 ? (j & 16 && bn(_, g, y), O !== _ && d(m, O)) : j & 16 ? F & 16 ? yn(
      _,
      O,
      m,
      b,
      g,
      y,
      N,
      E,
      x
    ) : bn(_, g, y, !0) : (j & 8 && d(m, ""), F & 16 && Ee(
      O,
      m,
      b,
      g,
      y,
      N,
      E,
      x
    ));
  }, mi = (u, p, m, b, g, y, N, E, x) => {
    u = u || on, p = p || on;
    const _ = u.length, j = p.length, O = Math.min(_, j);
    let V;
    for (V = 0; V < O; V++) {
      const F = p[V] = x ? kt(p[V]) : Ze(p[V]);
      R(
        u[V],
        F,
        m,
        null,
        g,
        y,
        N,
        E,
        x
      );
    }
    _ > j ? bn(
      u,
      g,
      y,
      !0,
      !1,
      O
    ) : Ee(
      p,
      m,
      b,
      g,
      y,
      N,
      E,
      x,
      O
    );
  }, yn = (u, p, m, b, g, y, N, E, x) => {
    let _ = 0;
    const j = p.length;
    let O = u.length - 1, V = j - 1;
    for (; _ <= O && _ <= V; ) {
      const F = u[_], W = p[_] = x ? kt(p[_]) : Ze(p[_]);
      if (Nn(F, W))
        R(
          F,
          W,
          m,
          null,
          g,
          y,
          N,
          E,
          x
        );
      else
        break;
      _++;
    }
    for (; _ <= O && _ <= V; ) {
      const F = u[O], W = p[V] = x ? kt(p[V]) : Ze(p[V]);
      if (Nn(F, W))
        R(
          F,
          W,
          m,
          null,
          g,
          y,
          N,
          E,
          x
        );
      else
        break;
      O--, V--;
    }
    if (_ > O) {
      if (_ <= V) {
        const F = V + 1, W = F < j ? p[F].el : b;
        for (; _ <= V; )
          R(
            null,
            p[_] = x ? kt(p[_]) : Ze(p[_]),
            m,
            W,
            g,
            y,
            N,
            E,
            x
          ), _++;
      }
    } else if (_ > V)
      for (; _ <= O; )
        wt(u[_], g, y, !0), _++;
    else {
      const F = _, W = _, ne = /* @__PURE__ */ new Map();
      for (_ = W; _ <= V; _++) {
        const ye = p[_] = x ? kt(p[_]) : Ze(p[_]);
        ye.key != null && (process.env.NODE_ENV !== "production" && ne.has(ye.key) && k(
          "Duplicate keys found during update:",
          JSON.stringify(ye.key),
          "Make sure keys are unique."
        ), ne.set(ye.key, _));
      }
      let X, Ce = 0;
      const Ne = V - W + 1;
      let qe = !1, Ge = 0;
      const wn = new Array(Ne);
      for (_ = 0; _ < Ne; _++) wn[_] = 0;
      for (_ = F; _ <= O; _++) {
        const ye = u[_];
        if (Ce >= Ne) {
          wt(ye, g, y, !0);
          continue;
        }
        let Je;
        if (ye.key != null)
          Je = ne.get(ye.key);
        else
          for (X = W; X <= V; X++)
            if (wn[X - W] === 0 && Nn(ye, p[X])) {
              Je = X;
              break;
            }
        Je === void 0 ? wt(ye, g, y, !0) : (wn[Je - W] = _ + 1, Je >= Ge ? Ge = Je : qe = !0, R(
          ye,
          p[Je],
          m,
          null,
          g,
          y,
          N,
          E,
          x
        ), Ce++);
      }
      const Cs = qe ? Mu(wn) : on;
      for (X = Cs.length - 1, _ = Ne - 1; _ >= 0; _--) {
        const ye = W + _, Je = p[ye], Ts = ye + 1 < j ? p[ye + 1].el : b;
        wn[_] === 0 ? R(
          null,
          Je,
          m,
          Ts,
          g,
          y,
          N,
          E,
          x
        ) : qe && (X < 0 || _ !== Cs[X] ? Xt(Je, m, Ts, 2) : X--);
      }
    }
  }, Xt = (u, p, m, b, g = null) => {
    const { el: y, type: N, transition: E, children: x, shapeFlag: _ } = u;
    if (_ & 6) {
      Xt(u.component.subTree, p, m, b);
      return;
    }
    if (_ & 128) {
      u.suspense.move(p, m, b);
      return;
    }
    if (_ & 64) {
      N.move(u, p, m, _n);
      return;
    }
    if (N === Me) {
      r(y, p, m);
      for (let O = 0; O < x.length; O++)
        Xt(x[O], p, m, b);
      r(u.anchor, p, m);
      return;
    }
    if (N === xr) {
      Se(u, p, m);
      return;
    }
    if (b !== 2 && _ & 1 && E)
      if (b === 0)
        E.beforeEnter(y), r(y, p, m), Te(() => E.enter(y), g);
      else {
        const { leave: O, delayLeave: V, afterLeave: F } = E, W = () => r(y, p, m), ne = () => {
          O(y, () => {
            W(), F && F();
          });
        };
        V ? V(y, W, ne) : ne();
      }
    else
      r(y, p, m);
  }, wt = (u, p, m, b = !1, g = !1) => {
    const {
      type: y,
      props: N,
      ref: E,
      children: x,
      dynamicChildren: _,
      shapeFlag: j,
      patchFlag: O,
      dirs: V,
      cacheIndex: F
    } = u;
    if (O === -2 && (g = !1), E != null && jr(E, null, m, u, !0), F != null && (p.renderCache[F] = void 0), j & 256) {
      p.ctx.deactivate(u);
      return;
    }
    const W = j & 1 && V, ne = !Pn(u);
    let X;
    if (ne && (X = N && N.onVnodeBeforeUnmount) && Ye(X, p, u), j & 6)
      Dl(u.component, m, b);
    else {
      if (j & 128) {
        u.suspense.unmount(m, b);
        return;
      }
      W && Rt(u, null, p, "beforeUnmount"), j & 64 ? u.type.remove(
        u,
        p,
        m,
        _n,
        b
      ) : _ && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !_.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (y !== Me || O > 0 && O & 64) ? bn(
        _,
        p,
        m,
        !1,
        !0
      ) : (y === Me && O & 384 || !g && j & 16) && bn(x, p, m), b && gi(u);
    }
    (ne && (X = N && N.onVnodeUnmounted) || W) && Te(() => {
      X && Ye(X, p, u), W && Rt(u, null, p, "unmounted");
    }, m);
  }, gi = (u) => {
    const { type: p, el: m, anchor: b, transition: g } = u;
    if (p === Me) {
      process.env.NODE_ENV !== "production" && u.patchFlag > 0 && u.patchFlag & 2048 && g && !g.persisted ? u.children.forEach((N) => {
        N.type === Pe ? i(N.el) : gi(N);
      }) : Tl(m, b);
      return;
    }
    if (p === xr) {
      P(u);
      return;
    }
    const y = () => {
      i(m), g && !g.persisted && g.afterLeave && g.afterLeave();
    };
    if (u.shapeFlag & 1 && g && !g.persisted) {
      const { leave: N, delayLeave: E } = g, x = () => N(m, y);
      E ? E(u.el, y, x) : x();
    } else
      y();
  }, Tl = (u, p) => {
    let m;
    for (; u !== p; )
      m = h(u), i(u), u = m;
    i(p);
  }, Dl = (u, p, m) => {
    process.env.NODE_ENV !== "production" && u.type.__hmrId && Vc(u);
    const { bum: b, scope: g, job: y, subTree: N, um: E, m: x, a: _ } = u;
    Bs(x), Bs(_), b && xn(b), g.stop(), y && (y.flags |= 8, wt(N, u, p, m)), E && Te(E, p), Te(() => {
      u.isUnmounted = !0;
    }, p), p && p.pendingBranch && !p.isUnmounted && u.asyncDep && !u.asyncResolved && u.suspenseId === p.pendingId && (p.deps--, p.deps === 0 && p.resolve()), process.env.NODE_ENV !== "production" && $c(u);
  }, bn = (u, p, m, b = !1, g = !1, y = 0) => {
    for (let N = y; N < u.length; N++)
      wt(u[N], p, m, b, g);
  }, fr = (u) => {
    if (u.shapeFlag & 6)
      return fr(u.component.subTree);
    if (u.shapeFlag & 128)
      return u.suspense.next();
    const p = h(u.anchor || u.el), m = p && p[Uc];
    return m ? h(m) : p;
  };
  let vi = !1;
  const Ss = (u, p, m) => {
    u == null ? p._vnode && wt(p._vnode, null, null, !0) : R(
      p._vnode || null,
      u,
      p,
      null,
      null,
      null,
      m
    ), p._vnode = u, vi || (vi = !0, Is(), da(), vi = !1);
  }, _n = {
    p: R,
    um: wt,
    m: Xt,
    r: gi,
    mt: _t,
    mc: Ee,
    pc: Ke,
    pbc: bt,
    n: fr,
    o: e
  };
  return {
    render: Ss,
    hydrate: void 0,
    createApp: yu(Ss)
  };
}
function Ni({ type: e, props: t }, n) {
  return n === "svg" && e === "foreignObject" || n === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function Mt({ effect: e, job: t }, n) {
  n ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function Ru(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function wr(e, t, n = !1) {
  const r = e.children, i = t.children;
  if (A(r) && A(i))
    for (let s = 0; s < r.length; s++) {
      const o = r[s];
      let a = i[s];
      a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = i[s] = kt(i[s]), a.el = o.el), !n && a.patchFlag !== -2 && wr(o, a)), a.type === lr && (a.el = o.el), process.env.NODE_ENV !== "production" && a.type === Pe && !a.el && (a.el = o.el);
    }
}
function Mu(e) {
  const t = e.slice(), n = [0];
  let r, i, s, o, a;
  const l = e.length;
  for (r = 0; r < l; r++) {
    const c = e[r];
    if (c !== 0) {
      if (i = n[n.length - 1], e[i] < c) {
        t[r] = i, n.push(r);
        continue;
      }
      for (s = 0, o = n.length - 1; s < o; )
        a = s + o >> 1, e[n[a]] < c ? s = a + 1 : o = a;
      c < e[n[s]] && (s > 0 && (t[r] = n[s - 1]), n[s] = r);
    }
  }
  for (s = n.length, o = n[s - 1]; s-- > 0; )
    n[s] = o, o = t[o];
  return n;
}
function Ia(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : Ia(t);
}
function Bs(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
const $u = Symbol.for("v-scx"), Fu = () => {
  {
    const e = _r($u);
    return e || process.env.NODE_ENV !== "production" && k(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function Oi(e, t, n) {
  return process.env.NODE_ENV !== "production" && !M(t) && k(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), Ra(e, t, n);
}
function Ra(e, t, n = Q) {
  const { immediate: r, deep: i, flush: s, once: o } = n;
  process.env.NODE_ENV !== "production" && !t && (r !== void 0 && k(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), i !== void 0 && k(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), o !== void 0 && k(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const a = se({}, n);
  process.env.NODE_ENV !== "production" && (a.onWarn = k);
  const l = t && r || !t && s !== "post";
  let c;
  if (Ln) {
    if (s === "sync") {
      const v = Fu();
      c = v.__watcherHandles || (v.__watcherHandles = []);
    } else if (!l) {
      const v = () => {
      };
      return v.stop = ce, v.resume = ce, v.pause = ce, v;
    }
  }
  const d = ue;
  a.call = (v, S, R) => st(v, d, S, R);
  let f = !1;
  s === "post" ? a.scheduler = (v) => {
    Te(v, d && d.suspense);
  } : s !== "sync" && (f = !0, a.scheduler = (v, S) => {
    S ? v() : ni(v);
  }), a.augmentJob = (v) => {
    t && (v.flags |= 4), f && (v.flags |= 2, d && (v.id = d.uid, v.i = d));
  };
  const h = xc(e, t, a);
  return Ln && (c ? c.push(h) : l && h()), h;
}
function Lu(e, t, n) {
  const r = this.proxy, i = re(e) ? e.includes(".") ? Ma(r, e) : () => r[e] : e.bind(r, r);
  let s;
  M(t) ? s = t : (s = t.handler, n = t);
  const o = cr(this), a = Ra(i, s.bind(r), n);
  return o(), a;
}
function Ma(e, t) {
  const n = t.split(".");
  return () => {
    let r = e;
    for (let i = 0; i < n.length && r; i++)
      r = r[n[i]];
    return r;
  };
}
const Zu = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${fe(t)}Modifiers`] || e[`${Ve(t)}Modifiers`];
function zu(e, t, ...n) {
  if (e.isUnmounted) return;
  const r = e.vnode.props || Q;
  if (process.env.NODE_ENV !== "production") {
    const {
      emitsOptions: d,
      propsOptions: [f]
    } = e;
    if (d)
      if (!(t in d))
        (!f || !($t(fe(t)) in f)) && k(
          `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${$t(fe(t))}" prop.`
        );
      else {
        const h = d[t];
        M(h) && (h(...n) || k(
          `Invalid event arguments: event validation failed for event "${t}".`
        ));
      }
  }
  let i = n;
  const s = t.startsWith("update:"), o = s && Zu(r, t.slice(7));
  if (o && (o.trim && (i = n.map((d) => re(d) ? d.trim() : d)), o.number && (i = n.map(Rl))), process.env.NODE_ENV !== "production" && Zc(e, t, i), process.env.NODE_ENV !== "production") {
    const d = t.toLowerCase();
    d !== t && r[$t(d)] && k(
      `Event "${d}" is emitted in component ${li(
        e,
        e.type
      )} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${Ve(
        t
      )}" instead of "${t}".`
    );
  }
  let a, l = r[a = $t(t)] || // also try camelCase event handler (#2249)
  r[a = $t(fe(t))];
  !l && s && (l = r[a = $t(Ve(t))]), l && st(
    l,
    e,
    6,
    i
  );
  const c = r[a + "Once"];
  if (c) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[a])
      return;
    e.emitted[a] = !0, st(
      c,
      e,
      6,
      i
    );
  }
}
function $a(e, t, n = !1) {
  const r = t.emitsCache, i = r.get(e);
  if (i !== void 0)
    return i;
  const s = e.emits;
  let o = {}, a = !1;
  if (!M(e)) {
    const l = (c) => {
      const d = $a(c, t, !0);
      d && (a = !0, se(o, d));
    };
    !n && t.mixins.length && t.mixins.forEach(l), e.extends && l(e.extends), e.mixins && e.mixins.forEach(l);
  }
  return !s && !a ? (ee(e) && r.set(e, null), null) : (A(s) ? s.forEach((l) => o[l] = null) : se(o, s), ee(e) && r.set(e, o), o);
}
function ii(e, t) {
  return !e || !ir(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), K(e, t[0].toLowerCase() + t.slice(1)) || K(e, Ve(t)) || K(e, t));
}
let Hi = !1;
function Mr() {
  Hi = !0;
}
function Ws(e) {
  const {
    type: t,
    vnode: n,
    proxy: r,
    withProxy: i,
    propsOptions: [s],
    slots: o,
    attrs: a,
    emit: l,
    render: c,
    renderCache: d,
    props: f,
    data: h,
    setupState: v,
    ctx: S,
    inheritAttrs: R
  } = e, te = Pr(e);
  let G, oe;
  process.env.NODE_ENV !== "production" && (Hi = !1);
  try {
    if (n.shapeFlag & 4) {
      const P = i || r, de = process.env.NODE_ENV !== "production" && v.__isScriptSetup ? new Proxy(P, {
        get(Re, me, Ee) {
          return k(
            `Property '${String(
              me
            )}' was accessed via 'this'. Avoid using 'this' in templates.`
          ), Reflect.get(Re, me, Ee);
        }
      }) : P;
      G = Ze(
        c.call(
          de,
          P,
          d,
          process.env.NODE_ENV !== "production" ? tt(f) : f,
          v,
          h,
          S
        )
      ), oe = a;
    } else {
      const P = t;
      process.env.NODE_ENV !== "production" && a === f && Mr(), G = Ze(
        P.length > 1 ? P(
          process.env.NODE_ENV !== "production" ? tt(f) : f,
          process.env.NODE_ENV !== "production" ? {
            get attrs() {
              return Mr(), tt(a);
            },
            slots: o,
            emit: l
          } : { attrs: a, slots: o, emit: l }
        ) : P(
          process.env.NODE_ENV !== "production" ? tt(f) : f,
          null
        )
      ), oe = t.props ? a : Uu(a);
    }
  } catch (P) {
    jn.length = 0, or(P, e, 1), G = $e(Pe);
  }
  let Y = G, Se;
  if (process.env.NODE_ENV !== "production" && G.patchFlag > 0 && G.patchFlag & 2048 && ([Y, Se] = Fa(G)), oe && R !== !1) {
    const P = Object.keys(oe), { shapeFlag: de } = Y;
    if (P.length) {
      if (de & 7)
        s && P.some(Sr) && (oe = Hu(
          oe,
          s
        )), Y = Tt(Y, oe, !1, !0);
      else if (process.env.NODE_ENV !== "production" && !Hi && Y.type !== Pe) {
        const Re = Object.keys(a), me = [], Ee = [];
        for (let lt = 0, bt = Re.length; lt < bt; lt++) {
          const Le = Re[lt];
          ir(Le) ? Sr(Le) || me.push(Le[2].toLowerCase() + Le.slice(3)) : Ee.push(Le);
        }
        Ee.length && k(
          `Extraneous non-props attributes (${Ee.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`
        ), me.length && k(
          `Extraneous non-emits event listeners (${me.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return n.dirs && (process.env.NODE_ENV !== "production" && !Ks(Y) && k(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), Y = Tt(Y, null, !1, !0), Y.dirs = Y.dirs ? Y.dirs.concat(n.dirs) : n.dirs), n.transition && (process.env.NODE_ENV !== "production" && !Ks(Y) && k(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), gs(Y, n.transition)), process.env.NODE_ENV !== "production" && Se ? Se(Y) : G = Y, Pr(te), G;
}
const Fa = (e) => {
  const t = e.children, n = e.dynamicChildren, r = _s(t, !1);
  if (r) {
    if (process.env.NODE_ENV !== "production" && r.patchFlag > 0 && r.patchFlag & 2048)
      return Fa(r);
  } else return [e, void 0];
  const i = t.indexOf(r), s = n ? n.indexOf(r) : -1, o = (a) => {
    t[i] = a, n && (s > -1 ? n[s] = a : a.patchFlag > 0 && (e.dynamicChildren = [...n, a]));
  };
  return [Ze(r), o];
};
function _s(e, t = !0) {
  let n;
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    if (oi(i)) {
      if (i.type !== Pe || i.children === "v-if") {
        if (n)
          return;
        if (n = i, process.env.NODE_ENV !== "production" && t && n.patchFlag > 0 && n.patchFlag & 2048)
          return _s(n.children);
      }
    } else
      return;
  }
  return n;
}
const Uu = (e) => {
  let t;
  for (const n in e)
    (n === "class" || n === "style" || ir(n)) && ((t || (t = {}))[n] = e[n]);
  return t;
}, Hu = (e, t) => {
  const n = {};
  for (const r in e)
    (!Sr(r) || !(r.slice(9) in t)) && (n[r] = e[r]);
  return n;
}, Ks = (e) => e.shapeFlag & 7 || e.type === Pe;
function Bu(e, t, n) {
  const { props: r, children: i, component: s } = e, { props: o, children: a, patchFlag: l } = t, c = s.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (i || a) && nt || t.dirs || t.transition)
    return !0;
  if (n && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return r ? qs(r, o, c) : !!o;
    if (l & 8) {
      const d = t.dynamicProps;
      for (let f = 0; f < d.length; f++) {
        const h = d[f];
        if (o[h] !== r[h] && !ii(c, h))
          return !0;
      }
    }
  } else
    return (i || a) && (!a || !a.$stable) ? !0 : r === o ? !1 : r ? o ? qs(r, o, c) : !0 : !!o;
  return !1;
}
function qs(e, t, n) {
  const r = Object.keys(t);
  if (r.length !== Object.keys(e).length)
    return !0;
  for (let i = 0; i < r.length; i++) {
    const s = r[i];
    if (t[s] !== e[s] && !ii(n, s))
      return !0;
  }
  return !1;
}
function Wu({ vnode: e, parent: t }, n) {
  for (; t; ) {
    const r = t.subTree;
    if (r.suspense && r.suspense.activeBranch === e && (r.el = e.el), r === e)
      (e = t.vnode).el = n, t = t.parent;
    else
      break;
  }
}
const La = (e) => e.__isSuspense;
function Ku(e, t) {
  t && t.pendingBranch ? A(e) ? t.effects.push(...e) : t.effects.push(e) : ua(e);
}
const Me = Symbol.for("v-fgt"), lr = Symbol.for("v-txt"), Pe = Symbol.for("v-cmt"), xr = Symbol.for("v-stc"), jn = [];
let Ae = null;
function pe(e = !1) {
  jn.push(Ae = e ? null : []);
}
function qu() {
  jn.pop(), Ae = jn[jn.length - 1] || null;
}
let Fn = 1;
function Gs(e, t = !1) {
  Fn += e, e < 0 && Ae && t && (Ae.hasOnce = !0);
}
function Za(e) {
  return e.dynamicChildren = Fn > 0 ? Ae || on : null, qu(), Fn > 0 && Ae && Ae.push(e), e;
}
function je(e, t, n, r, i, s) {
  return Za(
    he(
      e,
      t,
      n,
      r,
      i,
      s,
      !0
    )
  );
}
function si(e, t, n, r, i) {
  return Za(
    $e(
      e,
      t,
      n,
      r,
      i,
      !0
    )
  );
}
function oi(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Nn(e, t) {
  if (process.env.NODE_ENV !== "production" && t.shapeFlag & 6 && e.component) {
    const n = br.get(t.type);
    if (n && n.has(e.component))
      return e.shapeFlag &= -257, t.shapeFlag &= -513, !1;
  }
  return e.type === t.type && e.key === t.key;
}
const Gu = (...e) => Ua(
  ...e
), za = ({ key: e }) => e ?? null, Er = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? re(e) || ae(e) || M(e) ? { i: Oe, r: e, k: t, f: !!n } : e : null);
function he(e, t = null, n = null, r = 0, i = null, s = e === Me ? 0 : 1, o = !1, a = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && za(t),
    ref: t && Er(t),
    scopeId: ga,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: s,
    patchFlag: r,
    dynamicProps: i,
    dynamicChildren: null,
    appContext: null,
    ctx: Oe
  };
  return a ? (ws(l, n), s & 128 && e.normalize(l)) : n && (l.shapeFlag |= re(n) ? 8 : 16), process.env.NODE_ENV !== "production" && l.key !== l.key && k("VNode created with invalid key (NaN). VNode type:", l.type), Fn > 0 && // avoid a block node from tracking itself
  !o && // has current parent block
  Ae && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (l.patchFlag > 0 || s & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  l.patchFlag !== 32 && Ae.push(l), l;
}
const $e = process.env.NODE_ENV !== "production" ? Gu : Ua;
function Ua(e, t = null, n = null, r = 0, i = null, s = !1) {
  if ((!e || e === wa) && (process.env.NODE_ENV !== "production" && !e && k(`Invalid vnode type when creating vnode: ${e}.`), e = Pe), oi(e)) {
    const a = Tt(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && ws(a, n), Fn > 0 && !s && Ae && (a.shapeFlag & 6 ? Ae[Ae.indexOf(e)] = a : Ae.push(a)), a.patchFlag = -2, a;
  }
  if (Ka(e) && (e = e.__vccOpts), t) {
    t = Ju(t);
    let { class: a, style: l } = t;
    a && !re(a) && (t.class = Yr(a)), ee(l) && (Tr(l) && !A(l) && (l = se({}, l)), t.style = os(l));
  }
  const o = re(e) ? 1 : La(e) ? 128 : Hc(e) ? 64 : ee(e) ? 4 : M(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && o & 4 && Tr(e) && (e = Z(e), k(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), he(
    e,
    t,
    n,
    r,
    i,
    o,
    s,
    !0
  );
}
function Ju(e) {
  return e ? Tr(e) || Ca(e) ? se({}, e) : e : null;
}
function Tt(e, t, n = !1, r = !1) {
  const { props: i, ref: s, patchFlag: o, children: a, transition: l } = e, c = t ? Yu(i || {}, t) : i, d = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: c,
    key: c && za(c),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && s ? A(s) ? s.concat(Er(t)) : [s, Er(t)] : Er(t)
    ) : s,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && o === -1 && A(a) ? a.map(Ha) : a,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== Me ? o === -1 ? 16 : o | 16 : o,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: l,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && Tt(e.ssContent),
    ssFallback: e.ssFallback && Tt(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return l && r && gs(
    d,
    l.clone(d)
  ), d;
}
function Ha(e) {
  const t = Tt(e);
  return A(e.children) && (t.children = e.children.map(Ha)), t;
}
function ai(e = " ", t = 0) {
  return $e(lr, null, e, t);
}
function kr(e = "", t = !1) {
  return t ? (pe(), si(Pe, null, e)) : $e(Pe, null, e);
}
function Ze(e) {
  return e == null || typeof e == "boolean" ? $e(Pe) : A(e) ? $e(
    Me,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : oi(e) ? kt(e) : $e(lr, null, String(e));
}
function kt(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : Tt(e);
}
function ws(e, t) {
  let n = 0;
  const { shapeFlag: r } = e;
  if (t == null)
    t = null;
  else if (A(t))
    n = 16;
  else if (typeof t == "object")
    if (r & 65) {
      const i = t.default;
      i && (i._c && (i._d = !1), ws(e, i()), i._c && (i._d = !0));
      return;
    } else {
      n = 32;
      const i = t._;
      !i && !Ca(t) ? t._ctx = Oe : i === 3 && Oe && (Oe.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else M(t) ? (t = { default: t, _ctx: Oe }, n = 32) : (t = String(t), r & 64 ? (n = 16, t = [ai(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function Yu(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    for (const i in r)
      if (i === "class")
        t.class !== r.class && (t.class = Yr([t.class, r.class]));
      else if (i === "style")
        t.style = os([t.style, r.style]);
      else if (ir(i)) {
        const s = t[i], o = r[i];
        o && s !== o && !(A(s) && s.includes(o)) && (t[i] = s ? [].concat(s, o) : o);
      } else i !== "" && (t[i] = r[i]);
  }
  return t;
}
function Ye(e, t, n, r = null) {
  st(e, t, 7, [
    n,
    r
  ]);
}
const Xu = Na();
let Qu = 0;
function ed(e, t, n) {
  const r = e.type, i = (t ? t.appContext : e.appContext) || Xu, s = {
    uid: Qu++,
    vnode: e,
    type: r,
    parent: t,
    appContext: i,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new Gl(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(i.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: Da(r, i),
    emitsOptions: $a(r, i),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: Q,
    // inheritAttrs
    inheritAttrs: r.inheritAttrs,
    // state
    ctx: Q,
    data: Q,
    props: Q,
    attrs: Q,
    slots: Q,
    refs: Q,
    setupState: Q,
    setupContext: null,
    // suspense related
    suspense: n,
    suspenseId: n ? n.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return process.env.NODE_ENV !== "production" ? s.ctx = lu(s) : s.ctx = { _: s }, s.root = t ? t.root : s, s.emit = zu.bind(null, s), e.ce && e.ce(s), s;
}
let ue = null;
const td = () => ue || Oe;
let $r, Bi;
{
  const e = sr(), t = (n, r) => {
    let i;
    return (i = e[n]) || (i = e[n] = []), i.push(r), (s) => {
      i.length > 1 ? i.forEach((o) => o(s)) : i[0](s);
    };
  };
  $r = t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => ue = n
  ), Bi = t(
    "__VUE_SSR_SETTERS__",
    (n) => Ln = n
  );
}
const cr = (e) => {
  const t = ue;
  return $r(e), e.scope.on(), () => {
    e.scope.off(), $r(t);
  };
}, Js = () => {
  ue && ue.scope.off(), $r(null);
}, nd = /* @__PURE__ */ mt("slot,component");
function Wi(e, { isNativeTag: t }) {
  (nd(e) || t(e)) && k(
    "Do not use built-in or reserved HTML elements as component id: " + e
  );
}
function Ba(e) {
  return e.vnode.shapeFlag & 4;
}
let Ln = !1;
function rd(e, t = !1, n = !1) {
  t && Bi(t);
  const { props: r, children: i } = e.vnode, s = Ba(e);
  _u(e, r, s, t), Vu(e, i, n);
  const o = s ? id(e, t) : void 0;
  return t && Bi(!1), o;
}
function id(e, t) {
  var n;
  const r = e.type;
  if (process.env.NODE_ENV !== "production") {
    if (r.name && Wi(r.name, e.appContext.config), r.components) {
      const s = Object.keys(r.components);
      for (let o = 0; o < s.length; o++)
        Wi(s[o], e.appContext.config);
    }
    if (r.directives) {
      const s = Object.keys(r.directives);
      for (let o = 0; o < s.length; o++)
        va(s[o]);
    }
    r.compilerOptions && sd() && k(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, xa), process.env.NODE_ENV !== "production" && cu(e);
  const { setup: i } = r;
  if (i) {
    gt();
    const s = e.setupContext = i.length > 1 ? ad(e) : null, o = cr(e), a = gn(
      i,
      e,
      0,
      [
        process.env.NODE_ENV !== "production" ? tt(e.props) : e.props,
        s
      ]
    ), l = rs(a);
    if (vt(), o(), (l || e.sp) && !Pn(e) && ya(e), l) {
      if (a.then(Js, Js), t)
        return a.then((c) => {
          Ys(e, c, t);
        }).catch((c) => {
          or(c, e, 0);
        });
      if (e.asyncDep = a, process.env.NODE_ENV !== "production" && !e.suspense) {
        const c = (n = r.name) != null ? n : "Anonymous";
        k(
          `Component <${c}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      Ys(e, a, t);
  } else
    Wa(e, t);
}
function Ys(e, t, n) {
  M(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : ee(t) ? (process.env.NODE_ENV !== "production" && oi(t) && k(
    "setup() should not return VNodes directly - return a render function instead."
  ), process.env.NODE_ENV !== "production" && (e.devtoolsRawSetupState = t), e.setupState = sa(t), process.env.NODE_ENV !== "production" && uu(e)) : process.env.NODE_ENV !== "production" && t !== void 0 && k(
    `setup() should return an object. Received: ${t === null ? "null" : typeof t}`
  ), Wa(e, n);
}
const sd = () => !0;
function Wa(e, t, n) {
  const r = e.type;
  e.render || (e.render = r.render || ce);
  {
    const i = cr(e);
    gt();
    try {
      fu(e);
    } finally {
      vt(), i();
    }
  }
  process.env.NODE_ENV !== "production" && !r.render && e.render === ce && !t && (r.template ? k(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
  ) : k("Component is missing template or render function: ", r));
}
const Xs = process.env.NODE_ENV !== "production" ? {
  get(e, t) {
    return Mr(), le(e, "get", ""), e[t];
  },
  set() {
    return k("setupContext.attrs is readonly."), !1;
  },
  deleteProperty() {
    return k("setupContext.attrs is readonly."), !1;
  }
} : {
  get(e, t) {
    return le(e, "get", ""), e[t];
  }
};
function od(e) {
  return new Proxy(e.slots, {
    get(t, n) {
      return le(e, "get", "$slots"), t[n];
    }
  });
}
function ad(e) {
  const t = (n) => {
    if (process.env.NODE_ENV !== "production" && (e.exposed && k("expose() should be called only once per setup()."), n != null)) {
      let r = typeof n;
      r === "object" && (A(n) ? r = "array" : ae(n) && (r = "ref")), r !== "object" && k(
        `expose() should be passed a plain object, received ${r}.`
      );
    }
    e.exposed = n || {};
  };
  if (process.env.NODE_ENV !== "production") {
    let n, r;
    return Object.freeze({
      get attrs() {
        return n || (n = new Proxy(e.attrs, Xs));
      },
      get slots() {
        return r || (r = od(e));
      },
      get emit() {
        return (i, ...s) => e.emit(i, ...s);
      },
      expose: t
    });
  } else
    return {
      attrs: new Proxy(e.attrs, Xs),
      slots: e.slots,
      emit: e.emit,
      expose: t
    };
}
function xs(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(sa(mn(e.exposed)), {
    get(t, n) {
      if (n in t)
        return t[n];
      if (n in Bt)
        return Bt[n](e);
    },
    has(t, n) {
      return n in t || n in Bt;
    }
  })) : e.proxy;
}
const ld = /(?:^|[-_])(\w)/g, cd = (e) => e.replace(ld, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function Es(e, t = !0) {
  return M(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function li(e, t, n = !1) {
  let r = Es(t);
  if (!r && t.__file) {
    const i = t.__file.match(/([^/\\]+)\.\w+$/);
    i && (r = i[1]);
  }
  if (!r && e && e.parent) {
    const i = (s) => {
      for (const o in s)
        if (s[o] === t)
          return o;
    };
    r = i(
      e.components || e.parent.type.components
    ) || i(e.appContext.components);
  }
  return r ? cd(r) : n ? "App" : "Anonymous";
}
function Ka(e) {
  return M(e) && "__vccOpts" in e;
}
const un = (e, t) => {
  const n = _c(e, t, Ln);
  if (process.env.NODE_ENV !== "production") {
    const r = td();
    r && r.appContext.config.warnRecursiveComputed && (n._warnRecursive = !0);
  }
  return n;
};
function ud() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, r = { style: "color:#eb2f96" }, i = {
    __vue_custom_formatter: !0,
    header(f) {
      return ee(f) ? f.__isVue ? ["div", e, "VueInstance"] : ae(f) ? [
        "div",
        {},
        ["span", e, d(f)],
        "<",
        // avoid debugger accessing value affecting behavior
        a("_value" in f ? f._value : f),
        ">"
      ] : Ut(f) ? [
        "div",
        {},
        ["span", e, we(f) ? "ShallowReactive" : "Reactive"],
        "<",
        a(f),
        `>${pt(f) ? " (readonly)" : ""}`
      ] : pt(f) ? [
        "div",
        {},
        ["span", e, we(f) ? "ShallowReadonly" : "Readonly"],
        "<",
        a(f),
        ">"
      ] : null : null;
    },
    hasBody(f) {
      return f && f.__isVue;
    },
    body(f) {
      if (f && f.__isVue)
        return [
          "div",
          {},
          ...s(f.$)
        ];
    }
  };
  function s(f) {
    const h = [];
    f.type.props && f.props && h.push(o("props", Z(f.props))), f.setupState !== Q && h.push(o("setup", f.setupState)), f.data !== Q && h.push(o("data", Z(f.data)));
    const v = l(f, "computed");
    v && h.push(o("computed", v));
    const S = l(f, "inject");
    return S && h.push(o("injected", S)), h.push([
      "div",
      {},
      [
        "span",
        {
          style: r.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: f }]
    ]), h;
  }
  function o(f, h) {
    return h = se({}, h), Object.keys(h).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        f
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(h).map((v) => [
          "div",
          {},
          ["span", r, v + ": "],
          a(h[v], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function a(f, h = !0) {
    return typeof f == "number" ? ["span", t, f] : typeof f == "string" ? ["span", n, JSON.stringify(f)] : typeof f == "boolean" ? ["span", r, f] : ee(f) ? ["object", { object: h ? Z(f) : f }] : ["span", n, String(f)];
  }
  function l(f, h) {
    const v = f.type;
    if (M(v))
      return;
    const S = {};
    for (const R in f.ctx)
      c(v, R, h) && (S[R] = f.ctx[R]);
    return S;
  }
  function c(f, h, v) {
    const S = f[v];
    if (A(S) && S.includes(h) || ee(S) && h in S || f.extends && c(f.extends, h, v) || f.mixins && f.mixins.some((R) => c(R, h, v)))
      return !0;
  }
  function d(f) {
    return we(f) ? "ShallowRef" : f.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(i) : window.devtoolsFormatters = [i];
}
const Qs = "3.5.13", Fe = process.env.NODE_ENV !== "production" ? k : ce;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let Ki;
const eo = typeof window < "u" && window.trustedTypes;
if (eo)
  try {
    Ki = /* @__PURE__ */ eo.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch (e) {
    process.env.NODE_ENV !== "production" && Fe(`Error creating trusted types policy: ${e}`);
  }
const qa = Ki ? (e) => Ki.createHTML(e) : (e) => e, dd = "http://www.w3.org/2000/svg", fd = "http://www.w3.org/1998/Math/MathML", ut = typeof document < "u" ? document : null, to = ut && /* @__PURE__ */ ut.createElement("template"), pd = {
  insert: (e, t, n) => {
    t.insertBefore(e, n || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, n, r) => {
    const i = t === "svg" ? ut.createElementNS(dd, e) : t === "mathml" ? ut.createElementNS(fd, e) : n ? ut.createElement(e, { is: n }) : ut.createElement(e);
    return e === "select" && r && r.multiple != null && i.setAttribute("multiple", r.multiple), i;
  },
  createText: (e) => ut.createTextNode(e),
  createComment: (e) => ut.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => ut.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, n, r, i, s) {
    const o = n ? n.previousSibling : t.lastChild;
    if (i && (i === s || i.nextSibling))
      for (; t.insertBefore(i.cloneNode(!0), n), !(i === s || !(i = i.nextSibling)); )
        ;
    else {
      to.innerHTML = qa(
        r === "svg" ? `<svg>${e}</svg>` : r === "mathml" ? `<math>${e}</math>` : e
      );
      const a = to.content;
      if (r === "svg" || r === "mathml") {
        const l = a.firstChild;
        for (; l.firstChild; )
          a.appendChild(l.firstChild);
        a.removeChild(l);
      }
      t.insertBefore(a, n);
    }
    return [
      // first
      o ? o.nextSibling : t.firstChild,
      // last
      n ? n.previousSibling : t.lastChild
    ];
  }
}, hd = Symbol("_vtc");
function md(e, t, n) {
  const r = e[hd];
  r && (t = (t ? [t, ...r] : [...r]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
const no = Symbol("_vod"), gd = Symbol("_vsh");
process.env.NODE_ENV;
const vd = Symbol(process.env.NODE_ENV !== "production" ? "CSS_VAR_TEXT" : ""), yd = /(^|;)\s*display\s*:/;
function bd(e, t, n) {
  const r = e.style, i = re(n);
  let s = !1;
  if (n && !i) {
    if (t)
      if (re(t))
        for (const o of t.split(";")) {
          const a = o.slice(0, o.indexOf(":")).trim();
          n[a] == null && Nr(r, a, "");
        }
      else
        for (const o in t)
          n[o] == null && Nr(r, o, "");
    for (const o in n)
      o === "display" && (s = !0), Nr(r, o, n[o]);
  } else if (i) {
    if (t !== n) {
      const o = r[vd];
      o && (n += ";" + o), r.cssText = n, s = yd.test(n);
    }
  } else t && e.removeAttribute("style");
  no in e && (e[no] = s ? r.display : "", e[gd] && (r.display = "none"));
}
const _d = /[^\\];\s*$/, ro = /\s*!important$/;
function Nr(e, t, n) {
  if (A(n))
    n.forEach((r) => Nr(e, t, r));
  else if (n == null && (n = ""), process.env.NODE_ENV !== "production" && _d.test(n) && Fe(
    `Unexpected semicolon at the end of '${t}' style value: '${n}'`
  ), t.startsWith("--"))
    e.setProperty(t, n);
  else {
    const r = wd(e, t);
    ro.test(n) ? e.setProperty(
      Ve(r),
      n.replace(ro, ""),
      "important"
    ) : e[r] = n;
  }
}
const io = ["Webkit", "Moz", "ms"], Si = {};
function wd(e, t) {
  const n = Si[t];
  if (n)
    return n;
  let r = fe(t);
  if (r !== "filter" && r in e)
    return Si[t] = r;
  r = Kt(r);
  for (let i = 0; i < io.length; i++) {
    const s = io[i] + r;
    if (s in e)
      return Si[t] = s;
  }
  return t;
}
const so = "http://www.w3.org/1999/xlink";
function oo(e, t, n, r, i, s = ql(t)) {
  r && t.startsWith("xlink:") ? n == null ? e.removeAttributeNS(so, t.slice(6, t.length)) : e.setAttributeNS(so, t, n) : n == null || s && !Mo(n) ? e.removeAttribute(t) : e.setAttribute(
    t,
    s ? "" : It(n) ? String(n) : n
  );
}
function ao(e, t, n, r, i) {
  if (t === "innerHTML" || t === "textContent") {
    n != null && (e[t] = t === "innerHTML" ? qa(n) : n);
    return;
  }
  const s = e.tagName;
  if (t === "value" && s !== "PROGRESS" && // custom elements may use _value internally
  !s.includes("-")) {
    const a = s === "OPTION" ? e.getAttribute("value") || "" : e.value, l = n == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(n);
    (a !== l || !("_value" in e)) && (e.value = l), n == null && e.removeAttribute(t), e._value = n;
    return;
  }
  let o = !1;
  if (n === "" || n == null) {
    const a = typeof e[t];
    a === "boolean" ? n = Mo(n) : n == null && a === "string" ? (n = "", o = !0) : a === "number" && (n = 0, o = !0);
  }
  try {
    e[t] = n;
  } catch (a) {
    process.env.NODE_ENV !== "production" && !o && Fe(
      `Failed setting prop "${t}" on <${s.toLowerCase()}>: value ${n} is invalid.`,
      a
    );
  }
  o && e.removeAttribute(i || t);
}
function xd(e, t, n, r) {
  e.addEventListener(t, n, r);
}
function Ed(e, t, n, r) {
  e.removeEventListener(t, n, r);
}
const lo = Symbol("_vei");
function kd(e, t, n, r, i = null) {
  const s = e[lo] || (e[lo] = {}), o = s[t];
  if (r && o)
    o.value = process.env.NODE_ENV !== "production" ? uo(r, t) : r;
  else {
    const [a, l] = Nd(t);
    if (r) {
      const c = s[t] = Cd(
        process.env.NODE_ENV !== "production" ? uo(r, t) : r,
        i
      );
      xd(e, a, c, l);
    } else o && (Ed(e, a, o, l), s[t] = void 0);
  }
}
const co = /(?:Once|Passive|Capture)$/;
function Nd(e) {
  let t;
  if (co.test(e)) {
    t = {};
    let r;
    for (; r = e.match(co); )
      e = e.slice(0, e.length - r[0].length), t[r[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : Ve(e.slice(2)), t];
}
let Ci = 0;
const Od = /* @__PURE__ */ Promise.resolve(), Sd = () => Ci || (Od.then(() => Ci = 0), Ci = Date.now());
function Cd(e, t) {
  const n = (r) => {
    if (!r._vts)
      r._vts = Date.now();
    else if (r._vts <= n.attached)
      return;
    st(
      Td(r, n.value),
      t,
      5,
      [r]
    );
  };
  return n.value = e, n.attached = Sd(), n;
}
function uo(e, t) {
  return M(e) || A(e) ? e : (Fe(
    `Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`
  ), ce);
}
function Td(e, t) {
  if (A(t)) {
    const n = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      n.call(e), e._stopped = !0;
    }, t.map(
      (r) => (i) => !i._stopped && r && r(i)
    );
  } else
    return t;
}
const fo = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, Dd = (e, t, n, r, i, s) => {
  const o = i === "svg";
  t === "class" ? md(e, r, o) : t === "style" ? bd(e, n, r) : ir(t) ? Sr(t) || kd(e, t, n, r, s) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : Vd(e, t, r, o)) ? (ao(e, t, r), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && oo(e, t, r, o, s, t !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && (/[A-Z]/.test(t) || !re(r)) ? ao(e, fe(t), r, s, t) : (t === "true-value" ? e._trueValue = r : t === "false-value" && (e._falseValue = r), oo(e, t, r, o));
};
function Vd(e, t, n, r) {
  if (r)
    return !!(t === "innerHTML" || t === "textContent" || t in e && fo(t) && M(n));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const i = e.tagName;
    if (i === "IMG" || i === "VIDEO" || i === "CANVAS" || i === "SOURCE")
      return !1;
  }
  return fo(t) && re(n) ? !1 : t in e;
}
const po = {};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function ci(e, t, n) {
  const r = /* @__PURE__ */ vn(e, t);
  Gr(r) && se(r, t);
  class i extends ks {
    constructor(o) {
      super(r, o, n);
    }
  }
  return i.def = r, i;
}
const Ad = typeof HTMLElement < "u" ? HTMLElement : class {
};
class ks extends Ad {
  constructor(t, n = {}, r = mo) {
    super(), this._def = t, this._props = n, this._createApp = r, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._numberProps = null, this._styleChildren = /* @__PURE__ */ new WeakSet(), this._ob = null, this.shadowRoot && r !== mo ? this._root = this.shadowRoot : (process.env.NODE_ENV !== "production" && this.shadowRoot && Fe(
      "Custom element has pre-rendered declarative shadow root but is not defined as hydratable. Use `defineSSRCustomElement`."
    ), t.shadowRoot !== !1 ? (this.attachShadow({ mode: "open" }), this._root = this.shadowRoot) : this._root = this), this._def.__asyncLoader || this._resolveProps(this._def);
  }
  connectedCallback() {
    if (!this.isConnected) return;
    this.shadowRoot || this._parseSlots(), this._connected = !0;
    let t = this;
    for (; t = t && (t.parentNode || t.host); )
      if (t instanceof ks) {
        this._parent = t;
        break;
      }
    this._instance || (this._resolved ? (this._setParent(), this._update()) : t && t._pendingResolve ? this._pendingResolve = t._pendingResolve.then(() => {
      this._pendingResolve = void 0, this._resolveDef();
    }) : this._resolveDef());
  }
  _setParent(t = this._parent) {
    t && (this._instance.parent = t._instance, this._instance.provides = t._instance.provides);
  }
  disconnectedCallback() {
    this._connected = !1, la(() => {
      this._connected || (this._ob && (this._ob.disconnect(), this._ob = null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    if (this._pendingResolve)
      return;
    for (let r = 0; r < this.attributes.length; r++)
      this._setAttr(this.attributes[r].name);
    this._ob = new MutationObserver((r) => {
      for (const i of r)
        this._setAttr(i.attributeName);
    }), this._ob.observe(this, { attributes: !0 });
    const t = (r, i = !1) => {
      this._resolved = !0, this._pendingResolve = void 0;
      const { props: s, styles: o } = r;
      let a;
      if (s && !A(s))
        for (const l in s) {
          const c = s[l];
          (c === Number || c && c.type === Number) && (l in this._props && (this._props[l] = Ds(this._props[l])), (a || (a = /* @__PURE__ */ Object.create(null)))[fe(l)] = !0);
        }
      this._numberProps = a, i && this._resolveProps(r), this.shadowRoot ? this._applyStyles(o) : process.env.NODE_ENV !== "production" && o && Fe(
        "Custom element style injection is not supported when using shadowRoot: false"
      ), this._mount(r);
    }, n = this._def.__asyncLoader;
    n ? this._pendingResolve = n().then(
      (r) => t(this._def = r, !0)
    ) : t(this._def);
  }
  _mount(t) {
    process.env.NODE_ENV !== "production" && !t.name && (t.name = "VueElement"), this._app = this._createApp(t), t.configureApp && t.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
    const n = this._instance && this._instance.exposed;
    if (n)
      for (const r in n)
        K(this, r) ? process.env.NODE_ENV !== "production" && Fe(`Exposed property "${r}" already exists on custom element.`) : Object.defineProperty(this, r, {
          // unwrap ref to be consistent with public instance behavior
          get: () => ti(n[r])
        });
  }
  _resolveProps(t) {
    const { props: n } = t, r = A(n) ? n : Object.keys(n || {});
    for (const i of Object.keys(this))
      i[0] !== "_" && r.includes(i) && this._setProp(i, this[i]);
    for (const i of r.map(fe))
      Object.defineProperty(this, i, {
        get() {
          return this._getProp(i);
        },
        set(s) {
          this._setProp(i, s, !0, !0);
        }
      });
  }
  _setAttr(t) {
    if (t.startsWith("data-v-")) return;
    const n = this.hasAttribute(t);
    let r = n ? this.getAttribute(t) : po;
    const i = fe(t);
    n && this._numberProps && this._numberProps[i] && (r = Ds(r)), this._setProp(i, r, !1, !0);
  }
  /**
   * @internal
   */
  _getProp(t) {
    return this._props[t];
  }
  /**
   * @internal
   */
  _setProp(t, n, r = !0, i = !1) {
    if (n !== this._props[t] && (n === po ? delete this._props[t] : (this._props[t] = n, t === "key" && this._app && (this._app._ceVNode.key = n)), i && this._instance && this._update(), r)) {
      const s = this._ob;
      s && s.disconnect(), n === !0 ? this.setAttribute(Ve(t), "") : typeof n == "string" || typeof n == "number" ? this.setAttribute(Ve(t), n + "") : n || this.removeAttribute(Ve(t)), s && s.observe(this, { attributes: !0 });
    }
  }
  _update() {
    jd(this._createVNode(), this._root);
  }
  _createVNode() {
    const t = {};
    this.shadowRoot || (t.onVnodeMounted = t.onVnodeUpdated = this._renderSlots.bind(this));
    const n = $e(this._def, se(t, this._props));
    return this._instance || (n.ce = (r) => {
      this._instance = r, r.ce = this, r.isCE = !0, process.env.NODE_ENV !== "production" && (r.ceReload = (s) => {
        this._styles && (this._styles.forEach((o) => this._root.removeChild(o)), this._styles.length = 0), this._applyStyles(s), this._instance = null, this._update();
      });
      const i = (s, o) => {
        this.dispatchEvent(
          new CustomEvent(
            s,
            Gr(o[0]) ? se({ detail: o }, o[0]) : { detail: o }
          )
        );
      };
      r.emit = (s, ...o) => {
        i(s, o), Ve(s) !== s && i(Ve(s), o);
      }, this._setParent();
    }), n;
  }
  _applyStyles(t, n) {
    if (!t) return;
    if (n) {
      if (n === this._def || this._styleChildren.has(n))
        return;
      this._styleChildren.add(n);
    }
    const r = this._nonce;
    for (let i = t.length - 1; i >= 0; i--) {
      const s = document.createElement("style");
      if (r && s.setAttribute("nonce", r), s.textContent = t[i], this.shadowRoot.prepend(s), process.env.NODE_ENV !== "production")
        if (n) {
          if (n.__hmrId) {
            this._childStyles || (this._childStyles = /* @__PURE__ */ new Map());
            let o = this._childStyles.get(n.__hmrId);
            o || this._childStyles.set(n.__hmrId, o = []), o.push(s);
          }
        } else
          (this._styles || (this._styles = [])).push(s);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _parseSlots() {
    const t = this._slots = {};
    let n;
    for (; n = this.firstChild; ) {
      const r = n.nodeType === 1 && n.getAttribute("slot") || "default";
      (t[r] || (t[r] = [])).push(n), this.removeChild(n);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _renderSlots() {
    const t = (this._teleportTarget || this).querySelectorAll("slot"), n = this._instance.type.__scopeId;
    for (let r = 0; r < t.length; r++) {
      const i = t[r], s = i.getAttribute("name") || "default", o = this._slots[s], a = i.parentNode;
      if (o)
        for (const l of o) {
          if (n && l.nodeType === 1) {
            const c = n + "-s", d = document.createTreeWalker(l, 1);
            l.setAttribute(c, "");
            let f;
            for (; f = d.nextNode(); )
              f.setAttribute(c, "");
          }
          a.insertBefore(l, i);
        }
      else
        for (; i.firstChild; ) a.insertBefore(i.firstChild, i);
      a.removeChild(i);
    }
  }
  /**
   * @internal
   */
  _injectChildStyle(t) {
    this._applyStyles(t.styles, t);
  }
  /**
   * @internal
   */
  _removeChildStyle(t) {
    if (process.env.NODE_ENV !== "production" && (this._styleChildren.delete(t), this._childStyles && t.__hmrId)) {
      const n = this._childStyles.get(t.__hmrId);
      n && (n.forEach((r) => this._root.removeChild(r)), n.length = 0);
    }
  }
}
const Pd = /* @__PURE__ */ se({ patchProp: Dd }, pd);
let ho;
function Ga() {
  return ho || (ho = ju(Pd));
}
const jd = (...e) => {
  Ga().render(...e);
}, mo = (...e) => {
  const t = Ga().createApp(...e);
  process.env.NODE_ENV !== "production" && (Rd(t), Md(t));
  const { mount: n } = t;
  return t.mount = (r) => {
    const i = $d(r);
    if (!i) return;
    const s = t._component;
    !M(s) && !s.render && !s.template && (s.template = i.innerHTML), i.nodeType === 1 && (i.textContent = "");
    const o = n(i, !1, Id(i));
    return i instanceof Element && (i.removeAttribute("v-cloak"), i.setAttribute("data-v-app", "")), o;
  }, t;
};
function Id(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function Rd(e) {
  Object.defineProperty(e.config, "isNativeTag", {
    value: (t) => Hl(t) || Bl(t) || Wl(t),
    writable: !1
  });
}
function Md(e) {
  {
    const t = e.config.isCustomElement;
    Object.defineProperty(e.config, "isCustomElement", {
      get() {
        return t;
      },
      set() {
        Fe(
          "The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead."
        );
      }
    });
    const n = e.config.compilerOptions, r = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
    Object.defineProperty(e.config, "compilerOptions", {
      get() {
        return Fe(r), n;
      },
      set() {
        Fe(r);
      }
    });
  }
}
function $d(e) {
  if (re(e)) {
    const t = document.querySelector(e);
    return process.env.NODE_ENV !== "production" && !t && Fe(
      `Failed to mount app: mount target selector "${e}" returned null.`
    ), t;
  }
  return process.env.NODE_ENV !== "production" && window.ShadowRoot && e instanceof window.ShadowRoot && e.mode === "closed" && Fe(
    'mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'
  ), e;
}
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Fd() {
  ud();
}
process.env.NODE_ENV !== "production" && Fd();
const Ld = ["href"], Zd = /* @__PURE__ */ vn({
  __name: "AuthServiceForgotButton.ce",
  props: {
    endpoint: { type: String },
    returnUrl: { type: String },
    registrationToken: { type: String }
  },
  setup(e) {
    const t = e, n = un(() => {
      const r = new URL("/login/forgot", t.endpoint);
      return r.searchParams.set("returnUrl", t.returnUrl), r;
    });
    return (r, i) => (pe(), je("a", {
      href: n.value.toString()
    }, " Forgotten login details? ", 8, Ld));
  }
}), zd = '/*! tailwindcss v4.1.4 | MIT License | https://tailwindcss.com */@layer properties{@supports (((-webkit-hyphens:none)) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))){*,:before,:after,::backdrop{--tw-leading:initial;--tw-font-weight:initial;--tw-shadow:0 0 #0000;--tw-shadow-color:initial;--tw-shadow-alpha:100%;--tw-inset-shadow:0 0 #0000;--tw-inset-shadow-color:initial;--tw-inset-shadow-alpha:100%;--tw-ring-color:initial;--tw-ring-shadow:0 0 #0000;--tw-inset-ring-color:initial;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-inset:initial;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-offset-shadow:0 0 #0000;--tw-outline-style:solid}}}@layer theme{:root,:host{--font-sans:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";--font-mono:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;--color-orange-300:oklch(83.7% .128 66.29);--color-orange-400:oklch(75% .183 55.934);--color-orange-500:oklch(70.5% .213 47.604);--color-gray-200:oklch(92.8% .006 264.531);--color-gray-300:oklch(87.2% .01 258.338);--color-black:#000;--color-white:#fff;--spacing:.25rem;--text-sm:.875rem;--text-sm--line-height:calc(1.25/.875);--font-weight-semibold:600;--radius-md:.375rem;--default-font-family:var(--font-sans);--default-mono-font-family:var(--font-mono)}}@layer base{*,:after,:before,::backdrop{box-sizing:border-box;border:0 solid;margin:0;padding:0}::file-selector-button{box-sizing:border-box;border:0 solid;margin:0;padding:0}html,:host{-webkit-text-size-adjust:100%;-moz-tab-size:4;tab-size:4;line-height:1.5;font-family:var(--default-font-family,ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji");font-feature-settings:var(--default-font-feature-settings,normal);font-variation-settings:var(--default-font-variation-settings,normal);-webkit-tap-highlight-color:transparent}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:var(--default-mono-font-family,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace);font-feature-settings:var(--default-mono-font-feature-settings,normal);font-variation-settings:var(--default-mono-font-variation-settings,normal);font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}:-moz-focusring{outline:auto}progress{vertical-align:baseline}summary{display:list-item}ol,ul,menu{list-style:none}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}button,input,select,optgroup,textarea{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}::file-selector-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}:where(select:is([multiple],[size])) optgroup{font-weight:bolder}:where(select:is([multiple],[size])) optgroup option{padding-inline-start:20px}::file-selector-button{margin-inline-end:4px}::placeholder{opacity:1}@supports (not ((-webkit-appearance:-apple-pay-button))) or (contain-intrinsic-size:1px){::placeholder{color:currentColor}@supports (color:color-mix(in lab,red,red)){::placeholder{color:color-mix(in oklab,currentcolor 50%,transparent)}}}textarea{resize:vertical}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-date-and-time-value{min-height:1lh;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-datetime-edit{padding-block:0}::-webkit-datetime-edit-year-field{padding-block:0}::-webkit-datetime-edit-month-field{padding-block:0}::-webkit-datetime-edit-day-field{padding-block:0}::-webkit-datetime-edit-hour-field{padding-block:0}::-webkit-datetime-edit-minute-field{padding-block:0}::-webkit-datetime-edit-second-field{padding-block:0}::-webkit-datetime-edit-millisecond-field{padding-block:0}::-webkit-datetime-edit-meridiem-field{padding-block:0}:-moz-ui-invalid{box-shadow:none}button,input:where([type=button],[type=reset],[type=submit]){-webkit-appearance:button;-moz-appearance:button;appearance:button}::file-selector-button{-webkit-appearance:button;-moz-appearance:button;appearance:button}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[hidden]:where(:not([hidden=until-found])){display:none!important}*,:after,:before,::backdrop{border-color:var(--color-gray-200,currentColor)}::file-selector-button{border-color:var(--color-gray-200,currentColor)}button:not(:disabled),[role=button]:not(:disabled){cursor:pointer}}@layer components;@layer utilities{.mx-2{margin-inline:calc(var(--spacing)*2)}.mt-0{margin-top:calc(var(--spacing)*0)}.mt-8{margin-top:calc(var(--spacing)*8)}.flex{display:flex}.h-5{height:calc(var(--spacing)*5)}.w-5{width:calc(var(--spacing)*5)}.w-full{width:100%}.flex-col{flex-direction:column}.items-center{align-items:center}.justify-center{justify-content:center}.gap-y-3{row-gap:calc(var(--spacing)*3)}.rounded{border-radius:.25rem}.rounded-md{border-radius:var(--radius-md)}.bg-\\[\\#f97316\\]{background-color:#f97316}.bg-black{background-color:var(--color-black)}.bg-orange-500{background-color:var(--color-orange-500)}.bg-white{background-color:var(--color-white)}.px-3{padding-inline:calc(var(--spacing)*3)}.px-4{padding-inline:calc(var(--spacing)*4)}.py-1\\.5{padding-block:calc(var(--spacing)*1.5)}.py-2{padding-block:calc(var(--spacing)*2)}.text-center{text-align:center}.text-sm{font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height))}.leading-6{--tw-leading:calc(var(--spacing)*6);line-height:calc(var(--spacing)*6)}.font-semibold{--tw-font-weight:var(--font-weight-semibold);font-weight:var(--font-weight-semibold)}.text-black{color:var(--color-black)}.text-white{color:var(--color-white)}.shadow-sm{--tw-shadow:0 1px 3px 0 var(--tw-shadow-color,#0000001a),0 1px 2px -1px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}@media (hover:hover){.hover\\:bg-\\[\\#F7923C\\]:hover{background-color:#f7923c}.hover\\:bg-gray-200:hover{background-color:var(--color-gray-200)}.hover\\:bg-orange-400:hover{background-color:var(--color-orange-400)}}.focus-visible\\:outline:focus-visible{outline-style:var(--tw-outline-style);outline-width:1px}.focus-visible\\:outline-2:focus-visible{outline-style:var(--tw-outline-style);outline-width:2px}.focus-visible\\:outline-offset-2:focus-visible{outline-offset:2px}.focus-visible\\:outline-gray-300:focus-visible{outline-color:var(--color-gray-300)}.focus-visible\\:outline-orange-300:focus-visible{outline-color:var(--color-orange-300)}.scrollbar-hidden::-webkit-scrollbar{display:none}.scrollbar-hidden{scrollbar-width:none;-ms-overflow-style:none}}@property --tw-leading{syntax:"*";inherits:false}@property --tw-font-weight{syntax:"*";inherits:false}@property --tw-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:"*";inherits:false}@property --tw-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-inset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:"*";inherits:false}@property --tw-inset-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-ring-color{syntax:"*";inherits:false}@property --tw-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:"*";inherits:false}@property --tw-inset-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:"*";inherits:false}@property --tw-ring-offset-width{syntax:"<length>";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:"*";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-outline-style{syntax:"*";inherits:false;initial-value:solid}', ui = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
}, Ud = /* @__PURE__ */ ui(Zd, [["styles", [zd]]]);
var Hd = Object.defineProperty, Bd = (e, t, n) => t in e ? Hd(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, di = (e, t, n) => Bd(e, t + "", n);
function fi(e) {
  const t = {
    subscribe(n) {
      let r = null, i = !1, s = !1, o = !1;
      function a() {
        if (r === null) {
          o = !0;
          return;
        }
        s || (s = !0, typeof r == "function" ? r() : r && r.unsubscribe());
      }
      return r = e({
        next(l) {
          var c;
          i || (c = n.next) == null || c.call(n, l);
        },
        error(l) {
          var c;
          i || (i = !0, (c = n.error) == null || c.call(n, l), a());
        },
        complete() {
          var l;
          i || (i = !0, (l = n.complete) == null || l.call(n), a());
        }
      }), o && a(), {
        unsubscribe: a
      };
    },
    pipe(...n) {
      return n.reduce(Wd, t);
    }
  };
  return t;
}
function Wd(e, t) {
  return t(e);
}
function Kd(e) {
  const t = new AbortController();
  return new Promise((n, r) => {
    let i = !1;
    function s() {
      i || (i = !0, o.unsubscribe());
    }
    t.signal.addEventListener("abort", () => {
      r(t.signal.reason);
    });
    const o = e.subscribe({
      next(a) {
        i = !0, n(a), s();
      },
      error(a) {
        r(a);
      },
      complete() {
        t.abort(), s();
      }
    });
  });
}
function qd(e) {
  return (t) => {
    let n = 0, r = null;
    const i = [];
    function s() {
      r || (r = t.subscribe({
        next(a) {
          var l;
          for (const c of i)
            (l = c.next) == null || l.call(c, a);
        },
        error(a) {
          var l;
          for (const c of i)
            (l = c.error) == null || l.call(c, a);
        },
        complete() {
          var a;
          for (const l of i)
            (a = l.complete) == null || a.call(l);
        }
      }));
    }
    function o() {
      if (n === 0 && r) {
        const a = r;
        r = null, a.unsubscribe();
      }
    }
    return fi((a) => (n++, i.push(a), s(), {
      unsubscribe() {
        n--, o();
        const l = i.findIndex((c) => c === a);
        l > -1 && i.splice(l, 1);
      }
    }));
  };
}
function Gd(e) {
  let t = e;
  const n = [], r = (o) => {
    t !== void 0 && o.next(t), n.push(o);
  }, i = (o) => {
    n.splice(n.indexOf(o), 1);
  }, s = fi((o) => (r(o), () => {
    i(o);
  }));
  return s.next = (o) => {
    if (t !== o) {
      t = o;
      for (const a of n)
        a.next(o);
    }
  }, s.get = () => t, s;
}
function Jd(e) {
  return fi((t) => {
    function n(r = 0, i = e.op) {
      const s = e.links[r];
      if (!s)
        throw new Error("No more links to execute - did you forget to add an ending link?");
      return s({
        op: i,
        next(o) {
          return n(r + 1, o);
        }
      });
    }
    return n().subscribe(t);
  });
}
const Ja = () => {
}, go = (e) => {
  Object.freeze && Object.freeze(e);
};
function Ya(e, t, n) {
  var r, i;
  const s = t.join(".");
  return (r = n)[i = s] ?? (r[i] = new Proxy(Ja, {
    get(o, a) {
      if (!(typeof a != "string" || a === "then"))
        return Ya(e, [
          ...t,
          a
        ], n);
    },
    apply(o, a, l) {
      const c = t[t.length - 1];
      let d = {
        args: l,
        path: t
      };
      return c === "call" ? d = {
        args: l.length >= 2 ? [
          l[1]
        ] : [],
        path: t.slice(0, -1)
      } : c === "apply" && (d = {
        args: l.length >= 2 ? l[1] : [],
        path: t.slice(0, -1)
      }), go(d.args), go(d.path), e(d);
    }
  })), n[s];
}
const Yd = (e) => Ya(e, [], /* @__PURE__ */ Object.create(null)), Xd = (e) => new Proxy(Ja, {
  get(t, n) {
    if (n !== "then")
      return e(n);
  }
});
function Zn(e) {
  return !!e && !Array.isArray(e) && typeof e == "object";
}
function Qd(e, t) {
  if ("error" in e) {
    const n = t.deserialize(e.error);
    return {
      ok: !1,
      error: {
        ...e,
        error: n
      }
    };
  }
  return {
    ok: !0,
    result: {
      ...e.result,
      ...(!e.result.type || e.result.type === "data") && {
        type: "data",
        data: t.deserialize(e.result.data)
      }
    }
  };
}
class Ti extends Error {
  constructor() {
    super("Unable to transform response from server");
  }
}
function ef(e, t) {
  let n;
  try {
    n = Qd(e, t);
  } catch {
    throw new Ti();
  }
  if (!n.ok && (!Zn(n.error.error) || typeof n.error.error.code != "number"))
    throw new Ti();
  if (n.ok && !Zn(n.result))
    throw new Ti();
  return n;
}
var vo, yo;
(vo = Symbol).dispose ?? (vo.dispose = Symbol());
(yo = Symbol).asyncDispose ?? (yo.asyncDispose = Symbol());
var bo, _o, wo, xo, Eo, ko;
typeof window > "u" || "Deno" in window || // eslint-disable-next-line @typescript-eslint/dot-notation
((_o = (bo = globalThis.process) == null ? void 0 : bo.env) == null ? void 0 : _o.NODE_ENV) === "test" || (xo = (wo = globalThis.process) == null ? void 0 : wo.env) != null && xo.JEST_WORKER_ID || (ko = (Eo = globalThis.process) == null ? void 0 : Eo.env) != null && ko.VITEST_WORKER_ID;
function gr(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function tf(e) {
  return e instanceof Ct || /**
  * @deprecated
  * Delete in next major
  */
  e instanceof Error && e.name === "TRPCClientError";
}
function nf(e) {
  return Zn(e) && Zn(e.error) && typeof e.error.code == "number" && typeof e.error.message == "string";
}
function rf(e, t) {
  return typeof e == "string" ? e : Zn(e) && typeof e.message == "string" ? e.message : t;
}
class Ct extends Error {
  static from(t, n = {}) {
    const r = t;
    return tf(r) ? (n.meta && (r.meta = {
      ...r.meta,
      ...n.meta
    }), r) : nf(r) ? new Ct(r.error.message, {
      ...n,
      result: r
    }) : new Ct(rf(r, "Unknown error"), {
      ...n,
      cause: r
    });
  }
  constructor(t, n) {
    var r, i;
    const s = n == null ? void 0 : n.cause;
    super(t, {
      cause: s
    }), // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore override doesn't work in all environments due to "This member cannot have an 'override' modifier because it is not declared in the base class 'Error'"
    gr(this, "cause", void 0), gr(this, "shape", void 0), gr(this, "data", void 0), /**
    * Additional meta data about the error
    * In the case of HTTP-errors, we'll have `response` and potentially `responseJSON` here
    */
    gr(this, "meta", void 0), this.meta = n == null ? void 0 : n.meta, this.cause = s, this.shape = (r = n == null ? void 0 : n.result) == null ? void 0 : r.error, this.data = (i = n == null ? void 0 : n.result) == null ? void 0 : i.error.data, this.name = "TRPCClientError", Object.setPrototypeOf(this, Ct.prototype);
  }
}
function Di(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
class sf {
  $request(t) {
    return Jd({
      links: this.links,
      op: {
        ...t,
        context: t.context ?? {},
        id: ++this.requestId
      }
    }).pipe(qd());
  }
  async requestAsPromise(t) {
    try {
      const n = this.$request(t);
      return (await Kd(n)).result.data;
    } catch (n) {
      throw Ct.from(n);
    }
  }
  query(t, n, r) {
    return this.requestAsPromise({
      type: "query",
      path: t,
      input: n,
      context: r == null ? void 0 : r.context,
      signal: r == null ? void 0 : r.signal
    });
  }
  mutation(t, n, r) {
    return this.requestAsPromise({
      type: "mutation",
      path: t,
      input: n,
      context: r == null ? void 0 : r.context,
      signal: r == null ? void 0 : r.signal
    });
  }
  subscription(t, n, r) {
    return this.$request({
      type: "subscription",
      path: t,
      input: n,
      context: r.context,
      signal: r.signal
    }).subscribe({
      next(i) {
        var s, o, a, l;
        switch (i.result.type) {
          case "state": {
            (s = r.onConnectionStateChange) == null || s.call(r, i.result);
            break;
          }
          case "started": {
            (o = r.onStarted) == null || o.call(r, {
              context: i.context
            });
            break;
          }
          case "stopped": {
            (a = r.onStopped) == null || a.call(r);
            break;
          }
          case "data":
          case void 0: {
            (l = r.onData) == null || l.call(r, i.result.data);
            break;
          }
        }
      },
      error(i) {
        var s;
        (s = r.onError) == null || s.call(r, i);
      },
      complete() {
        var i;
        (i = r.onComplete) == null || i.call(r);
      }
    });
  }
  constructor(t) {
    Di(this, "links", void 0), Di(this, "runtime", void 0), Di(this, "requestId", void 0), this.requestId = 0, this.runtime = {}, this.links = t.links.map((n) => n(this.runtime));
  }
}
const of = Symbol.for("trpc_untypedClient"), af = {
  query: "query",
  mutate: "mutation",
  subscribe: "subscription"
}, lf = (e) => af[e];
function cf(e) {
  const t = Yd(({ path: n, args: r }) => {
    const i = [
      ...n
    ], s = lf(i.pop()), o = i.join(".");
    return e[s](o, ...r);
  });
  return Xd((n) => n === of ? e : t[n]);
}
function uf(e) {
  const t = new sf(e);
  return cf(t);
}
const No = (e) => typeof e == "function";
function df(e) {
  if (e)
    return e;
  if (typeof window < "u" && No(window.fetch))
    return window.fetch;
  if (typeof globalThis < "u" && No(globalThis.fetch))
    return globalThis.fetch;
  throw new Error("No fetch implementation found");
}
const Oo = () => {
  throw new Error("Something went wrong. Please submit an issue at https://github.com/trpc/trpc/issues/new");
};
function So(e) {
  let t = null, n = null;
  const r = () => {
    clearTimeout(n), n = null, t = null;
  };
  function i(a) {
    var l, c;
    const d = [
      []
    ];
    let f = 0;
    for (; ; ) {
      const h = a[f];
      if (!h)
        break;
      const v = d[d.length - 1];
      if (h.aborted) {
        (l = h.reject) == null || l.call(h, new Error("Aborted")), f++;
        continue;
      }
      if (e.validate(v.concat(h).map((S) => S.key))) {
        v.push(h), f++;
        continue;
      }
      if (v.length === 0) {
        (c = h.reject) == null || c.call(h, new Error("Input is too big for a single dispatch")), f++;
        continue;
      }
      d.push([]);
    }
    return d;
  }
  function s() {
    const a = i(t);
    r();
    for (const l of a) {
      if (!l.length)
        continue;
      const c = {
        items: l
      };
      for (const d of l)
        d.batch = c;
      e.fetch(c.items.map((d) => d.key)).then(async (d) => {
        var f;
        await Promise.all(d.map(async (h, v) => {
          var S, R;
          const te = c.items[v];
          try {
            const G = await Promise.resolve(h);
            (S = te.resolve) == null || S.call(te, G);
          } catch (G) {
            (R = te.reject) == null || R.call(te, G);
          }
          te.batch = null, te.reject = null, te.resolve = null;
        }));
        for (const h of c.items)
          (f = h.reject) == null || f.call(h, new Error("Missing result")), h.batch = null;
      }).catch((d) => {
        var f;
        for (const h of c.items)
          (f = h.reject) == null || f.call(h, d), h.batch = null;
      });
    }
  }
  function o(a) {
    const l = {
      aborted: !1,
      key: a,
      batch: null,
      resolve: Oo,
      reject: Oo
    }, c = new Promise((d, f) => {
      l.reject = f, l.resolve = d, t || (t = []), t.push(l);
    });
    return n || (n = setTimeout(s)), c;
  }
  return {
    load: o
  };
}
function ff(...e) {
  const t = new AbortController(), n = e.length;
  let r = 0;
  const i = () => {
    ++r === n && t.abort();
  };
  for (const s of e)
    s != null && s.aborted ? i() : s == null || s.addEventListener("abort", i, {
      once: !0
    });
  return t.signal;
}
function pf(e) {
  const t = e;
  return t ? "input" in t ? t : {
    input: t,
    output: t
  } : {
    input: {
      serialize: (n) => n,
      deserialize: (n) => n
    },
    output: {
      serialize: (n) => n,
      deserialize: (n) => n
    }
  };
}
function hf(e) {
  return {
    url: e.url.toString(),
    fetch: e.fetch,
    transformer: pf(e.transformer),
    methodOverride: e.methodOverride
  };
}
function mf(e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    t[n] = r;
  }
  return t;
}
const gf = {
  query: "GET",
  mutation: "POST",
  subscription: "PATCH"
};
function Xa(e) {
  return "input" in e ? e.transformer.input.serialize(e.input) : mf(e.inputs.map((t) => e.transformer.input.serialize(t)));
}
const Qa = (e) => {
  const t = e.url.split("?");
  let n = t[0].replace(/\/$/, "") + "/" + e.path;
  const r = [];
  if (t[1] && r.push(t[1]), "inputs" in e && r.push("batch=1"), e.type === "query" || e.type === "subscription") {
    const i = Xa(e);
    i !== void 0 && e.methodOverride !== "POST" && r.push(`input=${encodeURIComponent(JSON.stringify(i))}`);
  }
  return r.length && (n += "?" + r.join("&")), n;
}, vf = (e) => {
  if (e.type === "query" && e.methodOverride !== "POST")
    return;
  const t = Xa(e);
  return t !== void 0 ? JSON.stringify(t) : void 0;
}, yf = (e) => xf({
  ...e,
  contentTypeHeader: "application/json",
  getUrl: Qa,
  getBody: vf
});
class bf extends Error {
  constructor() {
    const t = "AbortError";
    super(t), this.name = t, this.message = t;
  }
}
const _f = (e) => {
  var t;
  if (e != null && e.aborted)
    throw (t = e.throwIfAborted) == null || t.call(e), typeof DOMException < "u" ? new DOMException("AbortError", "AbortError") : new bf();
};
async function wf(e) {
  _f(e.signal);
  const t = e.getUrl(e), n = e.getBody(e), { type: r } = e, i = await (async () => {
    const o = await e.headers();
    return Symbol.iterator in o ? Object.fromEntries(o) : o;
  })(), s = {
    ...e.contentTypeHeader ? {
      "content-type": e.contentTypeHeader
    } : {},
    ...e.trpcAcceptHeader ? {
      "trpc-accept": e.trpcAcceptHeader
    } : void 0,
    ...i
  };
  return df(e.fetch)(t, {
    method: e.methodOverride ?? gf[r],
    signal: e.signal,
    body: n,
    headers: s
  });
}
async function xf(e) {
  const t = {}, n = await wf(e);
  t.response = n;
  const r = await n.json();
  return t.responseJSON = r, {
    json: r,
    meta: t
  };
}
function Ef(e) {
  const t = hf(e), n = e.maxURLLength ?? 1 / 0, r = e.maxItems ?? 1 / 0;
  return () => {
    const i = (l) => ({
      validate(c) {
        if (n === 1 / 0 && r === 1 / 0)
          return !0;
        if (c.length > r)
          return !1;
        const d = c.map((h) => h.path).join(","), f = c.map((h) => h.input);
        return Qa({
          ...t,
          type: l,
          path: d,
          inputs: f,
          signal: null
        }).length <= n;
      },
      async fetch(c) {
        const d = c.map((S) => S.path).join(","), f = c.map((S) => S.input), h = ff(...c.map((S) => S.signal)), v = await yf({
          ...t,
          path: d,
          inputs: f,
          type: l,
          headers() {
            return e.headers ? typeof e.headers == "function" ? e.headers({
              opList: c
            }) : e.headers : {};
          },
          signal: h
        });
        return (Array.isArray(v.json) ? v.json : c.map(() => v.json)).map((S) => ({
          meta: v.meta,
          json: S
        }));
      }
    }), s = So(i("query")), o = So(i("mutation")), a = {
      query: s,
      mutation: o
    };
    return ({ op: l }) => fi((c) => {
      /* istanbul ignore if -- @preserve */
      if (l.type === "subscription")
        throw new Error("Subscriptions are unsupported by `httpLink` - use `httpSubscriptionLink` or `wsLink`");
      const d = a[l.type].load(l);
      let f;
      return d.then((h) => {
        f = h;
        const v = ef(h.json, t.transformer.output);
        if (!v.ok) {
          c.error(Ct.from(v.error, {
            meta: h.meta
          }));
          return;
        }
        c.next({
          context: h.meta,
          result: v.result
        }), c.complete();
      }).catch((h) => {
        c.error(Ct.from(h, {
          meta: f == null ? void 0 : f.meta
        }));
      }), () => {
      };
    });
  };
}
const el = (e, ...t) => typeof e == "function" ? e(...t) : e;
function kf() {
  let e, t;
  return {
    promise: new Promise((n, r) => {
      e = n, t = r;
    }),
    resolve: e,
    reject: t
  };
}
async function Nf(e) {
  const t = await el(e.url);
  if (!e.connectionParams) return t;
  const n = `${t.includes("?") ? "&" : "?"}connectionParams=1`;
  return t + n;
}
async function Of(e) {
  const t = {
    method: "connectionParams",
    data: await el(e)
  };
  return JSON.stringify(t);
}
function Lt(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Sf(e) {
  const { promise: t, resolve: n, reject: r } = kf();
  return e.addEventListener("open", () => {
    e.removeEventListener("error", r), n();
  }), e.addEventListener("error", r), t;
}
function Cf(e, { intervalMs: t, pongTimeoutMs: n }) {
  let r, i;
  function s() {
    r = setTimeout(() => {
      e.send("PING"), i = setTimeout(() => {
        e.close();
      }, n);
    }, t);
  }
  function o() {
    clearTimeout(r), s();
  }
  function a() {
    clearTimeout(i), o();
  }
  e.addEventListener("open", s), e.addEventListener("message", ({ data: l }) => {
    clearTimeout(r), s(), l === "PONG" && a();
  }), e.addEventListener("close", () => {
    clearTimeout(r), clearTimeout(i);
  });
}
class Fr {
  get ws() {
    return this.wsObservable.get();
  }
  set ws(t) {
    this.wsObservable.next(t);
  }
  /**
  * Checks if the WebSocket connection is open and ready to communicate.
  */
  isOpen() {
    return !!this.ws && this.ws.readyState === this.WebSocketPonyfill.OPEN && !this.openPromise;
  }
  /**
  * Checks if the WebSocket connection is closed or in the process of closing.
  */
  isClosed() {
    return !!this.ws && (this.ws.readyState === this.WebSocketPonyfill.CLOSING || this.ws.readyState === this.WebSocketPonyfill.CLOSED);
  }
  async open() {
    if (this.openPromise) return this.openPromise;
    this.id = ++Fr.connectCount;
    const t = Nf(this.urlOptions).then((n) => new this.WebSocketPonyfill(n));
    this.openPromise = t.then(async (n) => {
      this.ws = n, n.addEventListener("message", function({ data: r }) {
        r === "PING" && this.send("PONG");
      }), this.keepAliveOpts.enabled && Cf(n, this.keepAliveOpts), n.addEventListener("close", () => {
        this.ws === n && (this.ws = null);
      }), await Sf(n), this.urlOptions.connectionParams && n.send(await Of(this.urlOptions.connectionParams));
    });
    try {
      await this.openPromise;
    } finally {
      this.openPromise = null;
    }
  }
  /**
  * Closes the WebSocket connection gracefully.
  * Waits for any ongoing open operation to complete before closing.
  */
  async close() {
    var t;
    try {
      await this.openPromise;
    } finally {
      (t = this.ws) == null || t.close();
    }
  }
  constructor(t) {
    if (Lt(this, "id", ++Fr.connectCount), Lt(this, "WebSocketPonyfill", void 0), Lt(this, "urlOptions", void 0), Lt(this, "keepAliveOpts", void 0), Lt(this, "wsObservable", Gd(null)), Lt(this, "openPromise", null), this.WebSocketPonyfill = t.WebSocketPonyfill ?? WebSocket, !this.WebSocketPonyfill)
      throw new Error("No WebSocket implementation found - you probably don't want to use this on the server, but if you do you need to pass a `WebSocket`-ponyfill");
    this.urlOptions = t.urlOptions, this.keepAliveOpts = t.keepAlive;
  }
}
Lt(Fr, "connectCount", 0);
class Tf {
  constructor() {
    this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
  }
  set(t, n) {
    this.keyToValue.set(t, n), this.valueToKey.set(n, t);
  }
  getByKey(t) {
    return this.keyToValue.get(t);
  }
  getByValue(t) {
    return this.valueToKey.get(t);
  }
  clear() {
    this.keyToValue.clear(), this.valueToKey.clear();
  }
}
class tl {
  constructor(t) {
    this.generateIdentifier = t, this.kv = new Tf();
  }
  register(t, n) {
    this.kv.getByValue(t) || (n || (n = this.generateIdentifier(t)), this.kv.set(n, t));
  }
  clear() {
    this.kv.clear();
  }
  getIdentifier(t) {
    return this.kv.getByValue(t);
  }
  getValue(t) {
    return this.kv.getByKey(t);
  }
}
class Df extends tl {
  constructor() {
    super((t) => t.name), this.classToAllowedProps = /* @__PURE__ */ new Map();
  }
  register(t, n) {
    typeof n == "object" ? (n.allowProps && this.classToAllowedProps.set(t, n.allowProps), super.register(t, n.identifier)) : super.register(t, n);
  }
  getAllowedProps(t) {
    return this.classToAllowedProps.get(t);
  }
}
function Vf(e) {
  if ("values" in Object)
    return Object.values(e);
  const t = [];
  for (const n in e)
    e.hasOwnProperty(n) && t.push(e[n]);
  return t;
}
function Af(e, t) {
  const n = Vf(e);
  if ("find" in n)
    return n.find(t);
  const r = n;
  for (let i = 0; i < r.length; i++) {
    const s = r[i];
    if (t(s))
      return s;
  }
}
function dn(e, t) {
  Object.entries(e).forEach(([n, r]) => t(r, n));
}
function Or(e, t) {
  return e.indexOf(t) !== -1;
}
function Co(e, t) {
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    if (t(r))
      return r;
  }
}
class Pf {
  constructor() {
    this.transfomers = {};
  }
  register(t) {
    this.transfomers[t.name] = t;
  }
  findApplicable(t) {
    return Af(this.transfomers, (n) => n.isApplicable(t));
  }
  findByName(t) {
    return this.transfomers[t];
  }
}
const jf = (e) => Object.prototype.toString.call(e).slice(8, -1), nl = (e) => typeof e > "u", If = (e) => e === null, zn = (e) => typeof e != "object" || e === null || e === Object.prototype ? !1 : Object.getPrototypeOf(e) === null ? !0 : Object.getPrototypeOf(e) === Object.prototype, qi = (e) => zn(e) && Object.keys(e).length === 0, Dt = (e) => Array.isArray(e), Rf = (e) => typeof e == "string", Mf = (e) => typeof e == "number" && !isNaN(e), $f = (e) => typeof e == "boolean", Ff = (e) => e instanceof RegExp, Un = (e) => e instanceof Map, Hn = (e) => e instanceof Set, rl = (e) => jf(e) === "Symbol", Lf = (e) => e instanceof Date && !isNaN(e.valueOf()), Zf = (e) => e instanceof Error, To = (e) => typeof e == "number" && isNaN(e), zf = (e) => $f(e) || If(e) || nl(e) || Mf(e) || Rf(e) || rl(e), Uf = (e) => typeof e == "bigint", Hf = (e) => e === 1 / 0 || e === -1 / 0, Bf = (e) => ArrayBuffer.isView(e) && !(e instanceof DataView), Wf = (e) => e instanceof URL, il = (e) => e.replace(/\./g, "\\."), Vi = (e) => e.map(String).map(il).join("."), In = (e) => {
  const t = [];
  let n = "";
  for (let i = 0; i < e.length; i++) {
    let s = e.charAt(i);
    if (s === "\\" && e.charAt(i + 1) === ".") {
      n += ".", i++;
      continue;
    }
    if (s === ".") {
      t.push(n), n = "";
      continue;
    }
    n += s;
  }
  const r = n;
  return t.push(r), t;
};
function Xe(e, t, n, r) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: r
  };
}
const sl = [
  Xe(nl, "undefined", () => null, () => {
  }),
  Xe(Uf, "bigint", (e) => e.toString(), (e) => typeof BigInt < "u" ? BigInt(e) : (console.error("Please add a BigInt polyfill."), e)),
  Xe(Lf, "Date", (e) => e.toISOString(), (e) => new Date(e)),
  Xe(Zf, "Error", (e, t) => {
    const n = {
      name: e.name,
      message: e.message
    };
    return t.allowedErrorProps.forEach((r) => {
      n[r] = e[r];
    }), n;
  }, (e, t) => {
    const n = new Error(e.message);
    return n.name = e.name, n.stack = e.stack, t.allowedErrorProps.forEach((r) => {
      n[r] = e[r];
    }), n;
  }),
  Xe(Ff, "regexp", (e) => "" + e, (e) => {
    const t = e.slice(1, e.lastIndexOf("/")), n = e.slice(e.lastIndexOf("/") + 1);
    return new RegExp(t, n);
  }),
  Xe(
    Hn,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    (e) => [...e.values()],
    (e) => new Set(e)
  ),
  Xe(Un, "map", (e) => [...e.entries()], (e) => new Map(e)),
  Xe((e) => To(e) || Hf(e), "number", (e) => To(e) ? "NaN" : e > 0 ? "Infinity" : "-Infinity", Number),
  Xe((e) => e === 0 && 1 / e === -1 / 0, "number", () => "-0", Number),
  Xe(Wf, "URL", (e) => e.toString(), (e) => new URL(e))
];
function pi(e, t, n, r) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: r
  };
}
const ol = pi((e, t) => rl(e) ? !!t.symbolRegistry.getIdentifier(e) : !1, (e, t) => ["symbol", t.symbolRegistry.getIdentifier(e)], (e) => e.description, (e, t, n) => {
  const r = n.symbolRegistry.getValue(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown symbol");
  return r;
}), Kf = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce((e, t) => (e[t.name] = t, e), {}), al = pi(Bf, (e) => ["typed-array", e.constructor.name], (e) => [...e], (e, t) => {
  const n = Kf[t[1]];
  if (!n)
    throw new Error("Trying to deserialize unknown typed array");
  return new n(e);
});
function ll(e, t) {
  return e != null && e.constructor ? !!t.classRegistry.getIdentifier(e.constructor) : !1;
}
const cl = pi(ll, (e, t) => ["class", t.classRegistry.getIdentifier(e.constructor)], (e, t) => {
  const n = t.classRegistry.getAllowedProps(e.constructor);
  if (!n)
    return { ...e };
  const r = {};
  return n.forEach((i) => {
    r[i] = e[i];
  }), r;
}, (e, t, n) => {
  const r = n.classRegistry.getValue(t[1]);
  if (!r)
    throw new Error(`Trying to deserialize unknown class '${t[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`);
  return Object.assign(Object.create(r.prototype), e);
}), ul = pi((e, t) => !!t.customTransformerRegistry.findApplicable(e), (e, t) => ["custom", t.customTransformerRegistry.findApplicable(e).name], (e, t) => t.customTransformerRegistry.findApplicable(e).serialize(e), (e, t, n) => {
  const r = n.customTransformerRegistry.findByName(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown custom value");
  return r.deserialize(e);
}), qf = [cl, ol, ul, al], Do = (e, t) => {
  const n = Co(qf, (i) => i.isApplicable(e, t));
  if (n)
    return {
      value: n.transform(e, t),
      type: n.annotation(e, t)
    };
  const r = Co(sl, (i) => i.isApplicable(e, t));
  if (r)
    return {
      value: r.transform(e, t),
      type: r.annotation
    };
}, dl = {};
sl.forEach((e) => {
  dl[e.annotation] = e;
});
const Gf = (e, t, n) => {
  if (Dt(t))
    switch (t[0]) {
      case "symbol":
        return ol.untransform(e, t, n);
      case "class":
        return cl.untransform(e, t, n);
      case "custom":
        return ul.untransform(e, t, n);
      case "typed-array":
        return al.untransform(e, t, n);
      default:
        throw new Error("Unknown transformation: " + t);
    }
  else {
    const r = dl[t];
    if (!r)
      throw new Error("Unknown transformation: " + t);
    return r.untransform(e, n);
  }
}, sn = (e, t) => {
  if (t > e.size)
    throw new Error("index out of bounds");
  const n = e.keys();
  for (; t > 0; )
    n.next(), t--;
  return n.next().value;
};
function fl(e) {
  if (Or(e, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (Or(e, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (Or(e, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
const Jf = (e, t) => {
  fl(t);
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    if (Hn(e))
      e = sn(e, +r);
    else if (Un(e)) {
      const i = +r, s = +t[++n] == 0 ? "key" : "value", o = sn(e, i);
      switch (s) {
        case "key":
          e = o;
          break;
        case "value":
          e = e.get(o);
          break;
      }
    } else
      e = e[r];
  }
  return e;
}, Gi = (e, t, n) => {
  if (fl(t), t.length === 0)
    return n(e);
  let r = e;
  for (let s = 0; s < t.length - 1; s++) {
    const o = t[s];
    if (Dt(r)) {
      const a = +o;
      r = r[a];
    } else if (zn(r))
      r = r[o];
    else if (Hn(r)) {
      const a = +o;
      r = sn(r, a);
    } else if (Un(r)) {
      if (s === t.length - 2)
        break;
      const a = +o, l = +t[++s] == 0 ? "key" : "value", c = sn(r, a);
      switch (l) {
        case "key":
          r = c;
          break;
        case "value":
          r = r.get(c);
          break;
      }
    }
  }
  const i = t[t.length - 1];
  if (Dt(r) ? r[+i] = n(r[+i]) : zn(r) && (r[i] = n(r[i])), Hn(r)) {
    const s = sn(r, +i), o = n(s);
    s !== o && (r.delete(s), r.add(o));
  }
  if (Un(r)) {
    const s = +t[t.length - 2], o = sn(r, s);
    switch (+i == 0 ? "key" : "value") {
      case "key": {
        const a = n(o);
        r.set(a, r.get(o)), a !== o && r.delete(o);
        break;
      }
      case "value": {
        r.set(o, n(r.get(o)));
        break;
      }
    }
  }
  return e;
};
function Ji(e, t, n = []) {
  if (!e)
    return;
  if (!Dt(e)) {
    dn(e, (s, o) => Ji(s, t, [...n, ...In(o)]));
    return;
  }
  const [r, i] = e;
  i && dn(i, (s, o) => {
    Ji(s, t, [...n, ...In(o)]);
  }), t(r, n);
}
function Yf(e, t, n) {
  return Ji(t, (r, i) => {
    e = Gi(e, i, (s) => Gf(s, r, n));
  }), e;
}
function Xf(e, t) {
  function n(r, i) {
    const s = Jf(e, In(i));
    r.map(In).forEach((o) => {
      e = Gi(e, o, () => s);
    });
  }
  if (Dt(t)) {
    const [r, i] = t;
    r.forEach((s) => {
      e = Gi(e, In(s), () => e);
    }), i && dn(i, n);
  } else
    dn(t, n);
  return e;
}
const Qf = (e, t) => zn(e) || Dt(e) || Un(e) || Hn(e) || ll(e, t);
function ep(e, t, n) {
  const r = n.get(e);
  r ? r.push(t) : n.set(e, [t]);
}
function tp(e, t) {
  const n = {};
  let r;
  return e.forEach((i) => {
    if (i.length <= 1)
      return;
    t || (i = i.map((a) => a.map(String)).sort((a, l) => a.length - l.length));
    const [s, ...o] = i;
    s.length === 0 ? r = o.map(Vi) : n[Vi(s)] = o.map(Vi);
  }), r ? qi(n) ? [r] : [r, n] : qi(n) ? void 0 : n;
}
const pl = (e, t, n, r, i = [], s = [], o = /* @__PURE__ */ new Map()) => {
  const a = zf(e);
  if (!a) {
    ep(e, i, t);
    const v = o.get(e);
    if (v)
      return r ? {
        transformedValue: null
      } : v;
  }
  if (!Qf(e, n)) {
    const v = Do(e, n), S = v ? {
      transformedValue: v.value,
      annotations: [v.type]
    } : {
      transformedValue: e
    };
    return a || o.set(e, S), S;
  }
  if (Or(s, e))
    return {
      transformedValue: null
    };
  const l = Do(e, n), c = (l == null ? void 0 : l.value) ?? e, d = Dt(c) ? [] : {}, f = {};
  dn(c, (v, S) => {
    if (S === "__proto__" || S === "constructor" || S === "prototype")
      throw new Error(`Detected property ${S}. This is a prototype pollution risk, please remove it from your object.`);
    const R = pl(v, t, n, r, [...i, S], [...s, e], o);
    d[S] = R.transformedValue, Dt(R.annotations) ? f[S] = R.annotations : zn(R.annotations) && dn(R.annotations, (te, G) => {
      f[il(S) + "." + G] = te;
    });
  });
  const h = qi(f) ? {
    transformedValue: d,
    annotations: l ? [l.type] : void 0
  } : {
    transformedValue: d,
    annotations: l ? [l.type, f] : f
  };
  return a || o.set(e, h), h;
};
function hl(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function Vo(e) {
  return hl(e) === "Array";
}
function np(e) {
  if (hl(e) !== "Object")
    return !1;
  const t = Object.getPrototypeOf(e);
  return !!t && t.constructor === Object && t === Object.prototype;
}
function rp(e, t, n, r, i) {
  const s = {}.propertyIsEnumerable.call(r, t) ? "enumerable" : "nonenumerable";
  s === "enumerable" && (e[t] = n), i && s === "nonenumerable" && Object.defineProperty(e, t, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function Yi(e, t = {}) {
  if (Vo(e))
    return e.map((i) => Yi(i, t));
  if (!np(e))
    return e;
  const n = Object.getOwnPropertyNames(e), r = Object.getOwnPropertySymbols(e);
  return [...n, ...r].reduce((i, s) => {
    if (Vo(t.props) && !t.props.includes(s))
      return i;
    const o = e[s], a = Yi(o, t);
    return rp(i, s, a, e, t.nonenumerable), i;
  }, {});
}
class H {
  /**
   * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
   */
  constructor({ dedupe: t = !1 } = {}) {
    this.classRegistry = new Df(), this.symbolRegistry = new tl((n) => n.description ?? ""), this.customTransformerRegistry = new Pf(), this.allowedErrorProps = [], this.dedupe = t;
  }
  serialize(t) {
    const n = /* @__PURE__ */ new Map(), r = pl(t, n, this, this.dedupe), i = {
      json: r.transformedValue
    };
    r.annotations && (i.meta = {
      ...i.meta,
      values: r.annotations
    });
    const s = tp(n, this.dedupe);
    return s && (i.meta = {
      ...i.meta,
      referentialEqualities: s
    }), i;
  }
  deserialize(t) {
    const { json: n, meta: r } = t;
    let i = Yi(n);
    return r != null && r.values && (i = Yf(i, r.values, this)), r != null && r.referentialEqualities && (i = Xf(i, r.referentialEqualities)), i;
  }
  stringify(t) {
    return JSON.stringify(this.serialize(t));
  }
  parse(t) {
    return this.deserialize(JSON.parse(t));
  }
  registerClass(t, n) {
    this.classRegistry.register(t, n);
  }
  registerSymbol(t, n) {
    this.symbolRegistry.register(t, n);
  }
  registerCustom(t, n) {
    this.customTransformerRegistry.register({
      name: n,
      ...t
    });
  }
  allowErrorProps(...t) {
    this.allowedErrorProps.push(...t);
  }
}
H.defaultInstance = new H();
H.serialize = H.defaultInstance.serialize.bind(H.defaultInstance);
H.deserialize = H.defaultInstance.deserialize.bind(H.defaultInstance);
H.stringify = H.defaultInstance.stringify.bind(H.defaultInstance);
H.parse = H.defaultInstance.parse.bind(H.defaultInstance);
H.registerClass = H.defaultInstance.registerClass.bind(H.defaultInstance);
H.registerSymbol = H.defaultInstance.registerSymbol.bind(H.defaultInstance);
H.registerCustom = H.defaultInstance.registerCustom.bind(H.defaultInstance);
H.allowErrorProps = H.defaultInstance.allowErrorProps.bind(H.defaultInstance);
H.serialize;
H.deserialize;
H.stringify;
H.parse;
H.registerClass;
H.registerCustom;
H.registerSymbol;
H.allowErrorProps;
new TextEncoder();
new TextDecoder();
class ml extends Error {
  constructor(t, n) {
    var r;
    super(t, n), di(this, "code", "ERR_JOSE_GENERIC"), this.name = this.constructor.name, (r = Error.captureStackTrace) == null || r.call(Error, this, this.constructor);
  }
}
di(ml, "code", "ERR_JOSE_GENERIC");
class ip extends ml {
  constructor() {
    super(...arguments), di(this, "code", "ERR_JWT_INVALID");
  }
}
di(ip, "code", "ERR_JWT_INVALID");
var q;
(function(e) {
  e.assertEqual = (i) => i;
  function t(i) {
  }
  e.assertIs = t;
  function n(i) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = (i) => {
    const s = {};
    for (const o of i)
      s[o] = o;
    return s;
  }, e.getValidEnumValues = (i) => {
    const s = e.objectKeys(i).filter((a) => typeof i[i[a]] != "number"), o = {};
    for (const a of s)
      o[a] = i[a];
    return e.objectValues(o);
  }, e.objectValues = (i) => e.objectKeys(i).map(function(s) {
    return i[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const s = [];
    for (const o in i)
      Object.prototype.hasOwnProperty.call(i, o) && s.push(o);
    return s;
  }, e.find = (i, s) => {
    for (const o of i)
      if (s(o))
        return o;
  }, e.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function r(i, s = " | ") {
    return i.map((o) => typeof o == "string" ? `'${o}'` : o).join(s);
  }
  e.joinValues = r, e.jsonStringifyReplacer = (i, s) => typeof s == "bigint" ? s.toString() : s;
})(q || (q = {}));
var Xi;
(function(e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(Xi || (Xi = {}));
const T = q.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), dt = (e) => {
  switch (typeof e) {
    case "undefined":
      return T.undefined;
    case "string":
      return T.string;
    case "number":
      return isNaN(e) ? T.nan : T.number;
    case "boolean":
      return T.boolean;
    case "function":
      return T.function;
    case "bigint":
      return T.bigint;
    case "symbol":
      return T.symbol;
    case "object":
      return Array.isArray(e) ? T.array : e === null ? T.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? T.promise : typeof Map < "u" && e instanceof Map ? T.map : typeof Set < "u" && e instanceof Set ? T.set : typeof Date < "u" && e instanceof Date ? T.date : T.object;
    default:
      return T.unknown;
  }
}, w = q.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), sp = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class Ie extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const n = t || function(s) {
      return s.message;
    }, r = { _errors: [] }, i = (s) => {
      for (const o of s.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(i);
        else if (o.code === "invalid_return_type")
          i(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          i(o.argumentsError);
        else if (o.path.length === 0)
          r._errors.push(n(o));
        else {
          let a = r, l = 0;
          for (; l < o.path.length; ) {
            const c = o.path[l];
            l === o.path.length - 1 ? (a[c] = a[c] || { _errors: [] }, a[c]._errors.push(n(o))) : a[c] = a[c] || { _errors: [] }, a = a[c], l++;
          }
        }
    };
    return i(this), r;
  }
  static assert(t) {
    if (!(t instanceof Ie))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, q.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, r = [];
    for (const i of this.issues)
      i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Ie.create = (e) => new Ie(e);
const fn = (e, t) => {
  let n;
  switch (e.code) {
    case w.invalid_type:
      e.received === T.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case w.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, q.jsonStringifyReplacer)}`;
      break;
    case w.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${q.joinValues(e.keys, ", ")}`;
      break;
    case w.invalid_union:
      n = "Invalid input";
      break;
    case w.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${q.joinValues(e.options)}`;
      break;
    case w.invalid_enum_value:
      n = `Invalid enum value. Expected ${q.joinValues(e.options)}, received '${e.received}'`;
      break;
    case w.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case w.invalid_return_type:
      n = "Invalid function return type";
      break;
    case w.invalid_date:
      n = "Invalid date";
      break;
    case w.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : q.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case w.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case w.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case w.custom:
      n = "Invalid input";
      break;
    case w.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case w.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case w.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, q.assertNever(e);
  }
  return { message: n };
};
let gl = fn;
function op(e) {
  gl = e;
}
function Lr() {
  return gl;
}
const Zr = (e) => {
  const { data: t, path: n, errorMaps: r, issueData: i } = e, s = [...n, ...i.path || []], o = {
    ...i,
    path: s
  };
  if (i.message !== void 0)
    return {
      ...i,
      path: s,
      message: i.message
    };
  let a = "";
  const l = r.filter((c) => !!c).slice().reverse();
  for (const c of l)
    a = c(o, { data: t, defaultError: a }).message;
  return {
    ...i,
    path: s,
    message: a
  };
}, ap = [];
function C(e, t) {
  const n = Lr(), r = Zr({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      n,
      // then global override map
      n === fn ? void 0 : fn
      // then global default map
    ].filter((i) => !!i)
  });
  e.common.issues.push(r);
}
class ve {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const r = [];
    for (const i of n) {
      if (i.status === "aborted")
        return $;
      i.status === "dirty" && t.dirty(), r.push(i.value);
    }
    return { status: t.value, value: r };
  }
  static async mergeObjectAsync(t, n) {
    const r = [];
    for (const i of n) {
      const s = await i.key, o = await i.value;
      r.push({
        key: s,
        value: o
      });
    }
    return ve.mergeObjectSync(t, r);
  }
  static mergeObjectSync(t, n) {
    const r = {};
    for (const i of n) {
      const { key: s, value: o } = i;
      if (s.status === "aborted" || o.status === "aborted")
        return $;
      s.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof o.value < "u" || i.alwaysSet) && (r[s.value] = o.value);
    }
    return { status: t.value, value: r };
  }
}
const $ = Object.freeze({
  status: "aborted"
}), zr = (e) => ({ status: "dirty", value: e }), xe = (e) => ({ status: "valid", value: e }), Qi = (e) => e.status === "aborted", es = (e) => e.status === "dirty", Gt = (e) => e.status === "valid", Bn = (e) => typeof Promise < "u" && e instanceof Promise;
function Ur(e, t, n, r) {
  if (typeof t == "function" ? e !== t || !0 : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t.get(e);
}
function vl(e, t, n, r, i) {
  if (typeof t == "function" ? e !== t || !0 : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, n), n;
}
var D;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(D || (D = {}));
var Cn, Tn;
class ot {
  constructor(t, n, r, i) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = r, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Ao = (e, t) => {
  if (Gt(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new Ie(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function L(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: n, required_error: r, description: i } = e;
  if (t && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: i } : { errorMap: (s, o) => {
    var a, l;
    const { message: c } = e;
    return s.code === "invalid_enum_value" ? { message: c ?? o.defaultError } : typeof o.data > "u" ? { message: (a = c ?? r) !== null && a !== void 0 ? a : o.defaultError } : s.code !== "invalid_type" ? { message: o.defaultError } : { message: (l = c ?? n) !== null && l !== void 0 ? l : o.defaultError };
  }, description: i };
}
class z {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return dt(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: dt(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new ve(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: dt(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (Bn(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const r = this.safeParse(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(t, n) {
    var r;
    const i = {
      common: {
        issues: [],
        async: (r = n == null ? void 0 : n.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: dt(t)
    }, s = this._parseSync({ data: t, path: i.path, parent: i });
    return Ao(i, s);
  }
  "~validate"(t) {
    var n, r;
    const i = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: dt(t)
    };
    if (!this["~standard"].async)
      try {
        const s = this._parseSync({ data: t, path: [], parent: i });
        return Gt(s) ? {
          value: s.value
        } : {
          issues: i.common.issues
        };
      } catch (s) {
        !((r = (n = s == null ? void 0 : s.message) === null || n === void 0 ? void 0 : n.toLowerCase()) === null || r === void 0) && r.includes("encountered") && (this["~standard"].async = !0), i.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: i }).then((s) => Gt(s) ? {
      value: s.value
    } : {
      issues: i.common.issues
    });
  }
  async parseAsync(t, n) {
    const r = await this.safeParseAsync(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(t, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: dt(t)
    }, i = this._parse({ data: t, path: r.path, parent: r }), s = await (Bn(i) ? i : Promise.resolve(i));
    return Ao(r, s);
  }
  refine(t, n) {
    const r = (i) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(i) : n;
    return this._refinement((i, s) => {
      const o = t(i), a = () => s.addIssue({
        code: w.custom,
        ...r(i)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (a(), !1)) : o ? !0 : (a(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((r, i) => t(r) ? !0 : (i.addIssue(typeof n == "function" ? n(r, i) : n), !1));
  }
  _refinement(t) {
    return new We({
      schema: this,
      typeName: I.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (n) => this["~validate"](n)
    };
  }
  optional() {
    return rt.create(this, this._def);
  }
  nullable() {
    return jt.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Be.create(this);
  }
  promise() {
    return hn.create(this, this._def);
  }
  or(t) {
    return Gn.create([this, t], this._def);
  }
  and(t) {
    return Jn.create(this, t, this._def);
  }
  transform(t) {
    return new We({
      ...L(this._def),
      schema: this,
      typeName: I.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new tr({
      ...L(this._def),
      innerType: this,
      defaultValue: n,
      typeName: I.ZodDefault
    });
  }
  brand() {
    return new Ns({
      typeName: I.ZodBranded,
      type: this,
      ...L(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new nr({
      ...L(this._def),
      innerType: this,
      catchValue: n,
      typeName: I.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return ur.create(this, t);
  }
  readonly() {
    return rr.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const lp = /^c[^\s-]{8,}$/i, cp = /^[0-9a-z]+$/, up = /^[0-9A-HJKMNP-TV-Z]{26}$/i, dp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, fp = /^[a-z0-9_-]{21}$/i, pp = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, hp = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, mp = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, gp = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Ai;
const vp = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, yp = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, bp = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, _p = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, wp = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, xp = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, yl = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Ep = new RegExp(`^${yl}$`);
function bl(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function kp(e) {
  return new RegExp(`^${bl(e)}$`);
}
function _l(e) {
  let t = `${yl}T${bl(e)}`;
  const n = [];
  return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, new RegExp(`^${t}$`);
}
function Np(e, t) {
  return !!((t === "v4" || !t) && vp.test(e) || (t === "v6" || !t) && bp.test(e));
}
function Op(e, t) {
  if (!pp.test(e))
    return !1;
  try {
    const [n] = e.split("."), r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), i = JSON.parse(atob(r));
    return !(typeof i != "object" || i === null || !i.typ || !i.alg || t && i.alg !== t);
  } catch {
    return !1;
  }
}
function Sp(e, t) {
  return !!((t === "v4" || !t) && yp.test(e) || (t === "v6" || !t) && _p.test(e));
}
class Ue extends z {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== T.string) {
      const i = this._getOrReturnCtx(t);
      return C(i, {
        code: w.invalid_type,
        expected: T.string,
        received: i.parsedType
      }), $;
    }
    const n = new ve();
    let r;
    for (const i of this._def.checks)
      if (i.kind === "min")
        t.data.length < i.value && (r = this._getOrReturnCtx(t, r), C(r, {
          code: w.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        t.data.length > i.value && (r = this._getOrReturnCtx(t, r), C(r, {
          code: w.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const s = t.data.length > i.value, o = t.data.length < i.value;
        (s || o) && (r = this._getOrReturnCtx(t, r), s ? C(r, {
          code: w.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : o && C(r, {
          code: w.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        mp.test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
          validation: "email",
          code: w.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        Ai || (Ai = new RegExp(gp, "u")), Ai.test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
          validation: "emoji",
          code: w.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        dp.test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
          validation: "uuid",
          code: w.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        fp.test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
          validation: "nanoid",
          code: w.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        lp.test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
          validation: "cuid",
          code: w.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        cp.test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
          validation: "cuid2",
          code: w.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        up.test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
          validation: "ulid",
          code: w.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(t.data);
        } catch {
          r = this._getOrReturnCtx(t, r), C(r, {
            validation: "url",
            code: w.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
        validation: "regex",
        code: w.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? t.data = t.data.trim() : i.kind === "includes" ? t.data.includes(i.value, i.position) || (r = this._getOrReturnCtx(t, r), C(r, {
        code: w.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : i.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : i.kind === "startsWith" ? t.data.startsWith(i.value) || (r = this._getOrReturnCtx(t, r), C(r, {
        code: w.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? t.data.endsWith(i.value) || (r = this._getOrReturnCtx(t, r), C(r, {
        code: w.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? _l(i).test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
        code: w.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? Ep.test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
        code: w.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? kp(i).test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
        code: w.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? hp.test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
        validation: "duration",
        code: w.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? Np(t.data, i.version) || (r = this._getOrReturnCtx(t, r), C(r, {
        validation: "ip",
        code: w.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "jwt" ? Op(t.data, i.alg) || (r = this._getOrReturnCtx(t, r), C(r, {
        validation: "jwt",
        code: w.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "cidr" ? Sp(t.data, i.version) || (r = this._getOrReturnCtx(t, r), C(r, {
        validation: "cidr",
        code: w.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? wp.test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
        validation: "base64",
        code: w.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64url" ? xp.test(t.data) || (r = this._getOrReturnCtx(t, r), C(r, {
        validation: "base64url",
        code: w.invalid_string,
        message: i.message
      }), n.dirty()) : q.assertNever(i);
    return { status: n.value, value: t.data };
  }
  _regex(t, n, r) {
    return this.refinement((i) => t.test(i), {
      validation: n,
      code: w.invalid_string,
      ...D.errToObj(r)
    });
  }
  _addCheck(t) {
    return new Ue({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...D.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...D.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...D.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...D.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...D.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...D.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...D.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...D.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...D.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...D.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...D.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...D.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...D.errToObj(t) });
  }
  datetime(t) {
    var n, r;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (n = t == null ? void 0 : t.offset) !== null && n !== void 0 ? n : !1,
      local: (r = t == null ? void 0 : t.local) !== null && r !== void 0 ? r : !1,
      ...D.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...D.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...D.errToObj(t) });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...D.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n == null ? void 0 : n.position,
      ...D.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...D.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...D.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...D.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...D.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...D.errToObj(n)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, D.errToObj(t));
  }
  trim() {
    return new Ue({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Ue({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Ue({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Ue.create = (e) => {
  var t;
  return new Ue({
    checks: [],
    typeName: I.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...L(e)
  });
};
function Cp(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, i = n > r ? n : r, s = parseInt(e.toFixed(i).replace(".", "")), o = parseInt(t.toFixed(i).replace(".", ""));
  return s % o / Math.pow(10, i);
}
class Vt extends z {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== T.number) {
      const i = this._getOrReturnCtx(t);
      return C(i, {
        code: w.invalid_type,
        expected: T.number,
        received: i.parsedType
      }), $;
    }
    let n;
    const r = new ve();
    for (const i of this._def.checks)
      i.kind === "int" ? q.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), C(n, {
        code: w.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), r.dirty()) : i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (n = this._getOrReturnCtx(t, n), C(n, {
        code: w.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), r.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (n = this._getOrReturnCtx(t, n), C(n, {
        code: w.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), r.dirty()) : i.kind === "multipleOf" ? Cp(t.data, i.value) !== 0 && (n = this._getOrReturnCtx(t, n), C(n, {
        code: w.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), r.dirty()) : i.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), C(n, {
        code: w.not_finite,
        message: i.message
      }), r.dirty()) : q.assertNever(i);
    return { status: r.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, D.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, D.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, D.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, D.toString(n));
  }
  setLimit(t, n, r, i) {
    return new Vt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: D.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Vt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: D.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: D.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: D.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: D.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: D.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: D.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: D.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: D.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: D.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && q.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
Vt.create = (e) => new Vt({
  checks: [],
  typeName: I.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...L(e)
});
class At extends z {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== T.bigint)
      return this._getInvalidInput(t);
    let n;
    const r = new ve();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (n = this._getOrReturnCtx(t, n), C(n, {
        code: w.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), r.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (n = this._getOrReturnCtx(t, n), C(n, {
        code: w.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), r.dirty()) : i.kind === "multipleOf" ? t.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), C(n, {
        code: w.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), r.dirty()) : q.assertNever(i);
    return { status: r.value, value: t.data };
  }
  _getInvalidInput(t) {
    const n = this._getOrReturnCtx(t);
    return C(n, {
      code: w.invalid_type,
      expected: T.bigint,
      received: n.parsedType
    }), $;
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, D.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, D.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, D.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, D.toString(n));
  }
  setLimit(t, n, r, i) {
    return new At({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: D.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new At({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: D.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: D.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: D.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: D.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: D.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
At.create = (e) => {
  var t;
  return new At({
    checks: [],
    typeName: I.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...L(e)
  });
};
class Wn extends z {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== T.boolean) {
      const n = this._getOrReturnCtx(t);
      return C(n, {
        code: w.invalid_type,
        expected: T.boolean,
        received: n.parsedType
      }), $;
    }
    return xe(t.data);
  }
}
Wn.create = (e) => new Wn({
  typeName: I.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...L(e)
});
class Jt extends z {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== T.date) {
      const i = this._getOrReturnCtx(t);
      return C(i, {
        code: w.invalid_type,
        expected: T.date,
        received: i.parsedType
      }), $;
    }
    if (isNaN(t.data.getTime())) {
      const i = this._getOrReturnCtx(t);
      return C(i, {
        code: w.invalid_date
      }), $;
    }
    const n = new ve();
    let r;
    for (const i of this._def.checks)
      i.kind === "min" ? t.data.getTime() < i.value && (r = this._getOrReturnCtx(t, r), C(r, {
        code: w.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? t.data.getTime() > i.value && (r = this._getOrReturnCtx(t, r), C(r, {
        code: w.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : q.assertNever(i);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Jt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: D.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: D.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
Jt.create = (e) => new Jt({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: I.ZodDate,
  ...L(e)
});
class Hr extends z {
  _parse(t) {
    if (this._getType(t) !== T.symbol) {
      const n = this._getOrReturnCtx(t);
      return C(n, {
        code: w.invalid_type,
        expected: T.symbol,
        received: n.parsedType
      }), $;
    }
    return xe(t.data);
  }
}
Hr.create = (e) => new Hr({
  typeName: I.ZodSymbol,
  ...L(e)
});
class Kn extends z {
  _parse(t) {
    if (this._getType(t) !== T.undefined) {
      const n = this._getOrReturnCtx(t);
      return C(n, {
        code: w.invalid_type,
        expected: T.undefined,
        received: n.parsedType
      }), $;
    }
    return xe(t.data);
  }
}
Kn.create = (e) => new Kn({
  typeName: I.ZodUndefined,
  ...L(e)
});
class qn extends z {
  _parse(t) {
    if (this._getType(t) !== T.null) {
      const n = this._getOrReturnCtx(t);
      return C(n, {
        code: w.invalid_type,
        expected: T.null,
        received: n.parsedType
      }), $;
    }
    return xe(t.data);
  }
}
qn.create = (e) => new qn({
  typeName: I.ZodNull,
  ...L(e)
});
class pn extends z {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return xe(t.data);
  }
}
pn.create = (e) => new pn({
  typeName: I.ZodAny,
  ...L(e)
});
class Wt extends z {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return xe(t.data);
  }
}
Wt.create = (e) => new Wt({
  typeName: I.ZodUnknown,
  ...L(e)
});
class ht extends z {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return C(n, {
      code: w.invalid_type,
      expected: T.never,
      received: n.parsedType
    }), $;
  }
}
ht.create = (e) => new ht({
  typeName: I.ZodNever,
  ...L(e)
});
class Br extends z {
  _parse(t) {
    if (this._getType(t) !== T.undefined) {
      const n = this._getOrReturnCtx(t);
      return C(n, {
        code: w.invalid_type,
        expected: T.void,
        received: n.parsedType
      }), $;
    }
    return xe(t.data);
  }
}
Br.create = (e) => new Br({
  typeName: I.ZodVoid,
  ...L(e)
});
class Be extends z {
  _parse(t) {
    const { ctx: n, status: r } = this._processInputParams(t), i = this._def;
    if (n.parsedType !== T.array)
      return C(n, {
        code: w.invalid_type,
        expected: T.array,
        received: n.parsedType
      }), $;
    if (i.exactLength !== null) {
      const o = n.data.length > i.exactLength.value, a = n.data.length < i.exactLength.value;
      (o || a) && (C(n, {
        code: o ? w.too_big : w.too_small,
        minimum: a ? i.exactLength.value : void 0,
        maximum: o ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), r.dirty());
    }
    if (i.minLength !== null && n.data.length < i.minLength.value && (C(n, {
      code: w.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), r.dirty()), i.maxLength !== null && n.data.length > i.maxLength.value && (C(n, {
      code: w.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((o, a) => i.type._parseAsync(new ot(n, o, n.path, a)))).then((o) => ve.mergeArray(r, o));
    const s = [...n.data].map((o, a) => i.type._parseSync(new ot(n, o, n.path, a)));
    return ve.mergeArray(r, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new Be({
      ...this._def,
      minLength: { value: t, message: D.toString(n) }
    });
  }
  max(t, n) {
    return new Be({
      ...this._def,
      maxLength: { value: t, message: D.toString(n) }
    });
  }
  length(t, n) {
    return new Be({
      ...this._def,
      exactLength: { value: t, message: D.toString(n) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Be.create = (e, t) => new Be({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: I.ZodArray,
  ...L(t)
});
function rn(e) {
  if (e instanceof ie) {
    const t = {};
    for (const n in e.shape) {
      const r = e.shape[n];
      t[n] = rt.create(rn(r));
    }
    return new ie({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof Be ? new Be({
    ...e._def,
    type: rn(e.element)
  }) : e instanceof rt ? rt.create(rn(e.unwrap())) : e instanceof jt ? jt.create(rn(e.unwrap())) : e instanceof at ? at.create(e.items.map((t) => rn(t))) : e;
}
class ie extends z {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), n = q.objectKeys(t);
    return this._cached = { shape: t, keys: n };
  }
  _parse(t) {
    if (this._getType(t) !== T.object) {
      const l = this._getOrReturnCtx(t);
      return C(l, {
        code: w.invalid_type,
        expected: T.object,
        received: l.parsedType
      }), $;
    }
    const { status: n, ctx: r } = this._processInputParams(t), { shape: i, keys: s } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof ht && this._def.unknownKeys === "strip"))
      for (const l in r.data)
        s.includes(l) || o.push(l);
    const a = [];
    for (const l of s) {
      const c = i[l], d = r.data[l];
      a.push({
        key: { status: "valid", value: l },
        value: c._parse(new ot(r, d, r.path, l)),
        alwaysSet: l in r.data
      });
    }
    if (this._def.catchall instanceof ht) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const c of o)
          a.push({
            key: { status: "valid", value: c },
            value: { status: "valid", value: r.data[c] }
          });
      else if (l === "strict")
        o.length > 0 && (C(r, {
          code: w.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const c of o) {
        const d = r.data[c];
        a.push({
          key: { status: "valid", value: c },
          value: l._parse(
            new ot(r, d, r.path, c)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: c in r.data
        });
      }
    }
    return r.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const c of a) {
        const d = await c.key, f = await c.value;
        l.push({
          key: d,
          value: f,
          alwaysSet: c.alwaysSet
        });
      }
      return l;
    }).then((l) => ve.mergeObjectSync(n, l)) : ve.mergeObjectSync(n, a);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return D.errToObj, new ie({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (n, r) => {
          var i, s, o, a;
          const l = (o = (s = (i = this._def).errorMap) === null || s === void 0 ? void 0 : s.call(i, n, r).message) !== null && o !== void 0 ? o : r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (a = D.errToObj(t).message) !== null && a !== void 0 ? a : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new ie({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ie({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new ie({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new ie({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: I.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new ie({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    return q.objectKeys(t).forEach((r) => {
      t[r] && this.shape[r] && (n[r] = this.shape[r]);
    }), new ie({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    return q.objectKeys(this.shape).forEach((r) => {
      t[r] || (n[r] = this.shape[r]);
    }), new ie({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return rn(this);
  }
  partial(t) {
    const n = {};
    return q.objectKeys(this.shape).forEach((r) => {
      const i = this.shape[r];
      t && !t[r] ? n[r] = i : n[r] = i.optional();
    }), new ie({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    return q.objectKeys(this.shape).forEach((r) => {
      if (t && !t[r])
        n[r] = this.shape[r];
      else {
        let i = this.shape[r];
        for (; i instanceof rt; )
          i = i._def.innerType;
        n[r] = i;
      }
    }), new ie({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return wl(q.objectKeys(this.shape));
  }
}
ie.create = (e, t) => new ie({
  shape: () => e,
  unknownKeys: "strip",
  catchall: ht.create(),
  typeName: I.ZodObject,
  ...L(t)
});
ie.strictCreate = (e, t) => new ie({
  shape: () => e,
  unknownKeys: "strict",
  catchall: ht.create(),
  typeName: I.ZodObject,
  ...L(t)
});
ie.lazycreate = (e, t) => new ie({
  shape: e,
  unknownKeys: "strip",
  catchall: ht.create(),
  typeName: I.ZodObject,
  ...L(t)
});
class Gn extends z {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = this._def.options;
    function i(s) {
      for (const a of s)
        if (a.result.status === "valid")
          return a.result;
      for (const a of s)
        if (a.result.status === "dirty")
          return n.common.issues.push(...a.ctx.common.issues), a.result;
      const o = s.map((a) => new Ie(a.ctx.common.issues));
      return C(n, {
        code: w.invalid_union,
        unionErrors: o
      }), $;
    }
    if (n.common.async)
      return Promise.all(r.map(async (s) => {
        const o = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: n.data,
            path: n.path,
            parent: o
          }),
          ctx: o
        };
      })).then(i);
    {
      let s;
      const o = [];
      for (const l of r) {
        const c = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, d = l._parseSync({
          data: n.data,
          path: n.path,
          parent: c
        });
        if (d.status === "valid")
          return d;
        d.status === "dirty" && !s && (s = { result: d, ctx: c }), c.common.issues.length && o.push(c.common.issues);
      }
      if (s)
        return n.common.issues.push(...s.ctx.common.issues), s.result;
      const a = o.map((l) => new Ie(l));
      return C(n, {
        code: w.invalid_union,
        unionErrors: a
      }), $;
    }
  }
  get options() {
    return this._def.options;
  }
}
Gn.create = (e, t) => new Gn({
  options: e,
  typeName: I.ZodUnion,
  ...L(t)
});
const xt = (e) => e instanceof Xn ? xt(e.schema) : e instanceof We ? xt(e.innerType()) : e instanceof Qn ? [e.value] : e instanceof Pt ? e.options : e instanceof er ? q.objectValues(e.enum) : e instanceof tr ? xt(e._def.innerType) : e instanceof Kn ? [void 0] : e instanceof qn ? [null] : e instanceof rt ? [void 0, ...xt(e.unwrap())] : e instanceof jt ? [null, ...xt(e.unwrap())] : e instanceof Ns || e instanceof rr ? xt(e.unwrap()) : e instanceof nr ? xt(e._def.innerType) : [];
class hi extends z {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== T.object)
      return C(n, {
        code: w.invalid_type,
        expected: T.object,
        received: n.parsedType
      }), $;
    const r = this.discriminator, i = n.data[r], s = this.optionsMap.get(i);
    return s ? n.common.async ? s._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : s._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (C(n, {
      code: w.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), $);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, n, r) {
    const i = /* @__PURE__ */ new Map();
    for (const s of n) {
      const o = xt(s.shape[t]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const a of o) {
        if (i.has(a))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(a)}`);
        i.set(a, s);
      }
    }
    return new hi({
      typeName: I.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: i,
      ...L(r)
    });
  }
}
function ts(e, t) {
  const n = dt(e), r = dt(t);
  if (e === t)
    return { valid: !0, data: e };
  if (n === T.object && r === T.object) {
    const i = q.objectKeys(t), s = q.objectKeys(e).filter((a) => i.indexOf(a) !== -1), o = { ...e, ...t };
    for (const a of s) {
      const l = ts(e[a], t[a]);
      if (!l.valid)
        return { valid: !1 };
      o[a] = l.data;
    }
    return { valid: !0, data: o };
  } else if (n === T.array && r === T.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const i = [];
    for (let s = 0; s < e.length; s++) {
      const o = e[s], a = t[s], l = ts(o, a);
      if (!l.valid)
        return { valid: !1 };
      i.push(l.data);
    }
    return { valid: !0, data: i };
  } else return n === T.date && r === T.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Jn extends z {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), i = (s, o) => {
      if (Qi(s) || Qi(o))
        return $;
      const a = ts(s.value, o.value);
      return a.valid ? ((es(s) || es(o)) && n.dirty(), { status: n.value, value: a.data }) : (C(r, {
        code: w.invalid_intersection_types
      }), $);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([s, o]) => i(s, o)) : i(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
Jn.create = (e, t, n) => new Jn({
  left: e,
  right: t,
  typeName: I.ZodIntersection,
  ...L(n)
});
class at extends z {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== T.array)
      return C(r, {
        code: w.invalid_type,
        expected: T.array,
        received: r.parsedType
      }), $;
    if (r.data.length < this._def.items.length)
      return C(r, {
        code: w.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), $;
    !this._def.rest && r.data.length > this._def.items.length && (C(r, {
      code: w.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const i = [...r.data].map((s, o) => {
      const a = this._def.items[o] || this._def.rest;
      return a ? a._parse(new ot(r, s, r.path, o)) : null;
    }).filter((s) => !!s);
    return r.common.async ? Promise.all(i).then((s) => ve.mergeArray(n, s)) : ve.mergeArray(n, i);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new at({
      ...this._def,
      rest: t
    });
  }
}
at.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new at({
    items: e,
    typeName: I.ZodTuple,
    rest: null,
    ...L(t)
  });
};
class Yn extends z {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== T.object)
      return C(r, {
        code: w.invalid_type,
        expected: T.object,
        received: r.parsedType
      }), $;
    const i = [], s = this._def.keyType, o = this._def.valueType;
    for (const a in r.data)
      i.push({
        key: s._parse(new ot(r, a, r.path, a)),
        value: o._parse(new ot(r, r.data[a], r.path, a)),
        alwaysSet: a in r.data
      });
    return r.common.async ? ve.mergeObjectAsync(n, i) : ve.mergeObjectSync(n, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, r) {
    return n instanceof z ? new Yn({
      keyType: t,
      valueType: n,
      typeName: I.ZodRecord,
      ...L(r)
    }) : new Yn({
      keyType: Ue.create(),
      valueType: t,
      typeName: I.ZodRecord,
      ...L(n)
    });
  }
}
class Wr extends z {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== T.map)
      return C(r, {
        code: w.invalid_type,
        expected: T.map,
        received: r.parsedType
      }), $;
    const i = this._def.keyType, s = this._def.valueType, o = [...r.data.entries()].map(([a, l], c) => ({
      key: i._parse(new ot(r, a, r.path, [c, "key"])),
      value: s._parse(new ot(r, l, r.path, [c, "value"]))
    }));
    if (r.common.async) {
      const a = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const c = await l.key, d = await l.value;
          if (c.status === "aborted" || d.status === "aborted")
            return $;
          (c.status === "dirty" || d.status === "dirty") && n.dirty(), a.set(c.value, d.value);
        }
        return { status: n.value, value: a };
      });
    } else {
      const a = /* @__PURE__ */ new Map();
      for (const l of o) {
        const c = l.key, d = l.value;
        if (c.status === "aborted" || d.status === "aborted")
          return $;
        (c.status === "dirty" || d.status === "dirty") && n.dirty(), a.set(c.value, d.value);
      }
      return { status: n.value, value: a };
    }
  }
}
Wr.create = (e, t, n) => new Wr({
  valueType: t,
  keyType: e,
  typeName: I.ZodMap,
  ...L(n)
});
class Yt extends z {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== T.set)
      return C(r, {
        code: w.invalid_type,
        expected: T.set,
        received: r.parsedType
      }), $;
    const i = this._def;
    i.minSize !== null && r.data.size < i.minSize.value && (C(r, {
      code: w.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), n.dirty()), i.maxSize !== null && r.data.size > i.maxSize.value && (C(r, {
      code: w.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), n.dirty());
    const s = this._def.valueType;
    function o(l) {
      const c = /* @__PURE__ */ new Set();
      for (const d of l) {
        if (d.status === "aborted")
          return $;
        d.status === "dirty" && n.dirty(), c.add(d.value);
      }
      return { status: n.value, value: c };
    }
    const a = [...r.data.values()].map((l, c) => s._parse(new ot(r, l, r.path, c)));
    return r.common.async ? Promise.all(a).then((l) => o(l)) : o(a);
  }
  min(t, n) {
    return new Yt({
      ...this._def,
      minSize: { value: t, message: D.toString(n) }
    });
  }
  max(t, n) {
    return new Yt({
      ...this._def,
      maxSize: { value: t, message: D.toString(n) }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Yt.create = (e, t) => new Yt({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: I.ZodSet,
  ...L(t)
});
class cn extends z {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== T.function)
      return C(n, {
        code: w.invalid_type,
        expected: T.function,
        received: n.parsedType
      }), $;
    function r(a, l) {
      return Zr({
        data: a,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Lr(),
          fn
        ].filter((c) => !!c),
        issueData: {
          code: w.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function i(a, l) {
      return Zr({
        data: a,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Lr(),
          fn
        ].filter((c) => !!c),
        issueData: {
          code: w.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const s = { errorMap: n.common.contextualErrorMap }, o = n.data;
    if (this._def.returns instanceof hn) {
      const a = this;
      return xe(async function(...l) {
        const c = new Ie([]), d = await a._def.args.parseAsync(l, s).catch((h) => {
          throw c.addIssue(r(l, h)), c;
        }), f = await Reflect.apply(o, this, d);
        return await a._def.returns._def.type.parseAsync(f, s).catch((h) => {
          throw c.addIssue(i(f, h)), c;
        });
      });
    } else {
      const a = this;
      return xe(function(...l) {
        const c = a._def.args.safeParse(l, s);
        if (!c.success)
          throw new Ie([r(l, c.error)]);
        const d = Reflect.apply(o, this, c.data), f = a._def.returns.safeParse(d, s);
        if (!f.success)
          throw new Ie([i(d, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new cn({
      ...this._def,
      args: at.create(t).rest(Wt.create())
    });
  }
  returns(t) {
    return new cn({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, n, r) {
    return new cn({
      args: t || at.create([]).rest(Wt.create()),
      returns: n || Wt.create(),
      typeName: I.ZodFunction,
      ...L(r)
    });
  }
}
class Xn extends z {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
Xn.create = (e, t) => new Xn({
  getter: e,
  typeName: I.ZodLazy,
  ...L(t)
});
class Qn extends z {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return C(n, {
        received: n.data,
        code: w.invalid_literal,
        expected: this._def.value
      }), $;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Qn.create = (e, t) => new Qn({
  value: e,
  typeName: I.ZodLiteral,
  ...L(t)
});
function wl(e, t) {
  return new Pt({
    values: e,
    typeName: I.ZodEnum,
    ...L(t)
  });
}
class Pt extends z {
  constructor() {
    super(...arguments), Cn.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return C(n, {
        expected: q.joinValues(r),
        received: n.parsedType,
        code: w.invalid_type
      }), $;
    }
    if (Ur(this, Cn) || vl(this, Cn, new Set(this._def.values)), !Ur(this, Cn).has(t.data)) {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return C(n, {
        received: n.data,
        code: w.invalid_enum_value,
        options: r
      }), $;
    }
    return xe(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  extract(t, n = this._def) {
    return Pt.create(t, {
      ...this._def,
      ...n
    });
  }
  exclude(t, n = this._def) {
    return Pt.create(this.options.filter((r) => !t.includes(r)), {
      ...this._def,
      ...n
    });
  }
}
Cn = /* @__PURE__ */ new WeakMap();
Pt.create = wl;
class er extends z {
  constructor() {
    super(...arguments), Tn.set(this, void 0);
  }
  _parse(t) {
    const n = q.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(t);
    if (r.parsedType !== T.string && r.parsedType !== T.number) {
      const i = q.objectValues(n);
      return C(r, {
        expected: q.joinValues(i),
        received: r.parsedType,
        code: w.invalid_type
      }), $;
    }
    if (Ur(this, Tn) || vl(this, Tn, new Set(q.getValidEnumValues(this._def.values))), !Ur(this, Tn).has(t.data)) {
      const i = q.objectValues(n);
      return C(r, {
        received: r.data,
        code: w.invalid_enum_value,
        options: i
      }), $;
    }
    return xe(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Tn = /* @__PURE__ */ new WeakMap();
er.create = (e, t) => new er({
  values: e,
  typeName: I.ZodNativeEnum,
  ...L(t)
});
class hn extends z {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== T.promise && n.common.async === !1)
      return C(n, {
        code: w.invalid_type,
        expected: T.promise,
        received: n.parsedType
      }), $;
    const r = n.parsedType === T.promise ? n.data : Promise.resolve(n.data);
    return xe(r.then((i) => this._def.type.parseAsync(i, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
hn.create = (e, t) => new hn({
  type: e,
  typeName: I.ZodPromise,
  ...L(t)
});
class We extends z {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === I.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), i = this._def.effect || null, s = {
      addIssue: (o) => {
        C(r, o), o.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), i.type === "preprocess") {
      const o = i.transform(r.data, s);
      if (r.common.async)
        return Promise.resolve(o).then(async (a) => {
          if (n.value === "aborted")
            return $;
          const l = await this._def.schema._parseAsync({
            data: a,
            path: r.path,
            parent: r
          });
          return l.status === "aborted" ? $ : l.status === "dirty" || n.value === "dirty" ? zr(l.value) : l;
        });
      {
        if (n.value === "aborted")
          return $;
        const a = this._def.schema._parseSync({
          data: o,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? $ : a.status === "dirty" || n.value === "dirty" ? zr(a.value) : a;
      }
    }
    if (i.type === "refinement") {
      const o = (a) => {
        const l = i.refinement(a, s);
        if (r.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return a;
      };
      if (r.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? $ : (a.status === "dirty" && n.dirty(), o(a.value), { status: n.value, value: a.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((a) => a.status === "aborted" ? $ : (a.status === "dirty" && n.dirty(), o(a.value).then(() => ({ status: n.value, value: a.value }))));
    }
    if (i.type === "transform")
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!Gt(o))
          return o;
        const a = i.transform(o.value, s);
        if (a instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: a };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => Gt(o) ? Promise.resolve(i.transform(o.value, s)).then((a) => ({ status: n.value, value: a })) : o);
    q.assertNever(i);
  }
}
We.create = (e, t, n) => new We({
  schema: e,
  typeName: I.ZodEffects,
  effect: t,
  ...L(n)
});
We.createWithPreprocess = (e, t, n) => new We({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: I.ZodEffects,
  ...L(n)
});
class rt extends z {
  _parse(t) {
    return this._getType(t) === T.undefined ? xe(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
rt.create = (e, t) => new rt({
  innerType: e,
  typeName: I.ZodOptional,
  ...L(t)
});
class jt extends z {
  _parse(t) {
    return this._getType(t) === T.null ? xe(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
jt.create = (e, t) => new jt({
  innerType: e,
  typeName: I.ZodNullable,
  ...L(t)
});
class tr extends z {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let r = n.data;
    return n.parsedType === T.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
tr.create = (e, t) => new tr({
  innerType: e,
  typeName: I.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...L(t)
});
class nr extends z {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return Bn(i) ? i.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new Ie(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new Ie(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
nr.create = (e, t) => new nr({
  innerType: e,
  typeName: I.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...L(t)
});
class Kr extends z {
  _parse(t) {
    if (this._getType(t) !== T.nan) {
      const n = this._getOrReturnCtx(t);
      return C(n, {
        code: w.invalid_type,
        expected: T.nan,
        received: n.parsedType
      }), $;
    }
    return { status: "valid", value: t.data };
  }
}
Kr.create = (e) => new Kr({
  typeName: I.ZodNaN,
  ...L(e)
});
const Tp = Symbol("zod_brand");
class Ns extends z {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class ur extends z {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return i.status === "aborted" ? $ : i.status === "dirty" ? (n.dirty(), zr(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return i.status === "aborted" ? $ : i.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(t, n) {
    return new ur({
      in: t,
      out: n,
      typeName: I.ZodPipeline
    });
  }
}
class rr extends z {
  _parse(t) {
    const n = this._def.innerType._parse(t), r = (i) => (Gt(i) && (i.value = Object.freeze(i.value)), i);
    return Bn(n) ? n.then((i) => r(i)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
rr.create = (e, t) => new rr({
  innerType: e,
  typeName: I.ZodReadonly,
  ...L(t)
});
function Po(e, t) {
  const n = typeof e == "function" ? e(t) : typeof e == "string" ? { message: e } : e;
  return typeof n == "string" ? { message: n } : n;
}
function xl(e, t = {}, n) {
  return e ? pn.create().superRefine((r, i) => {
    var s, o;
    const a = e(r);
    if (a instanceof Promise)
      return a.then((l) => {
        var c, d;
        if (!l) {
          const f = Po(t, r), h = (d = (c = f.fatal) !== null && c !== void 0 ? c : n) !== null && d !== void 0 ? d : !0;
          i.addIssue({ code: "custom", ...f, fatal: h });
        }
      });
    if (!a) {
      const l = Po(t, r), c = (o = (s = l.fatal) !== null && s !== void 0 ? s : n) !== null && o !== void 0 ? o : !0;
      i.addIssue({ code: "custom", ...l, fatal: c });
    }
  }) : pn.create();
}
const Dp = {
  object: ie.lazycreate
};
var I;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(I || (I = {}));
const Vp = (e, t = {
  message: `Input not instance of ${e.name}`
}) => xl((n) => n instanceof e, t), El = Ue.create, kl = Vt.create, Ap = Kr.create, Pp = At.create, Nl = Wn.create, jp = Jt.create, Ip = Hr.create, Rp = Kn.create, Mp = qn.create, $p = pn.create, Fp = Wt.create, Lp = ht.create, Zp = Br.create, zp = Be.create, Up = ie.create, Hp = ie.strictCreate, Bp = Gn.create, Wp = hi.create, Kp = Jn.create, qp = at.create, Gp = Yn.create, Jp = Wr.create, Yp = Yt.create, Xp = cn.create, Qp = Xn.create, eh = Qn.create, th = Pt.create, nh = er.create, rh = hn.create, jo = We.create, ih = rt.create, sh = jt.create, oh = We.createWithPreprocess, ah = ur.create, lh = () => El().optional(), ch = () => kl().optional(), uh = () => Nl().optional(), dh = {
  string: (e) => Ue.create({ ...e, coerce: !0 }),
  number: (e) => Vt.create({ ...e, coerce: !0 }),
  boolean: (e) => Wn.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => At.create({ ...e, coerce: !0 }),
  date: (e) => Jt.create({ ...e, coerce: !0 })
}, fh = $;
var ft = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: fn,
  setErrorMap: op,
  getErrorMap: Lr,
  makeIssue: Zr,
  EMPTY_PATH: ap,
  addIssueToContext: C,
  ParseStatus: ve,
  INVALID: $,
  DIRTY: zr,
  OK: xe,
  isAborted: Qi,
  isDirty: es,
  isValid: Gt,
  isAsync: Bn,
  get util() {
    return q;
  },
  get objectUtil() {
    return Xi;
  },
  ZodParsedType: T,
  getParsedType: dt,
  ZodType: z,
  datetimeRegex: _l,
  ZodString: Ue,
  ZodNumber: Vt,
  ZodBigInt: At,
  ZodBoolean: Wn,
  ZodDate: Jt,
  ZodSymbol: Hr,
  ZodUndefined: Kn,
  ZodNull: qn,
  ZodAny: pn,
  ZodUnknown: Wt,
  ZodNever: ht,
  ZodVoid: Br,
  ZodArray: Be,
  ZodObject: ie,
  ZodUnion: Gn,
  ZodDiscriminatedUnion: hi,
  ZodIntersection: Jn,
  ZodTuple: at,
  ZodRecord: Yn,
  ZodMap: Wr,
  ZodSet: Yt,
  ZodFunction: cn,
  ZodLazy: Xn,
  ZodLiteral: Qn,
  ZodEnum: Pt,
  ZodNativeEnum: er,
  ZodPromise: hn,
  ZodEffects: We,
  ZodTransformer: We,
  ZodOptional: rt,
  ZodNullable: jt,
  ZodDefault: tr,
  ZodCatch: nr,
  ZodNaN: Kr,
  BRAND: Tp,
  ZodBranded: Ns,
  ZodPipeline: ur,
  ZodReadonly: rr,
  custom: xl,
  Schema: z,
  ZodSchema: z,
  late: Dp,
  get ZodFirstPartyTypeKind() {
    return I;
  },
  coerce: dh,
  any: $p,
  array: zp,
  bigint: Pp,
  boolean: Nl,
  date: jp,
  discriminatedUnion: Wp,
  effect: jo,
  enum: th,
  function: Xp,
  instanceof: Vp,
  intersection: Kp,
  lazy: Qp,
  literal: eh,
  map: Jp,
  nan: Ap,
  nativeEnum: nh,
  never: Lp,
  null: Mp,
  nullable: sh,
  number: kl,
  object: Up,
  oboolean: uh,
  onumber: ch,
  optional: ih,
  ostring: lh,
  pipeline: ah,
  preprocess: oh,
  promise: rh,
  record: Gp,
  set: Yp,
  strictObject: Hp,
  string: El,
  symbol: Ip,
  transformer: jo,
  tuple: qp,
  undefined: Rp,
  union: Bp,
  unknown: Fp,
  void: Zp,
  NEVER: fh,
  ZodIssueCode: w,
  quotelessJson: sp,
  ZodError: Ie
});
ft.object({
  user_id: ft.string()
});
ft.object({
  prospective_user_id: ft.string()
});
ft.object({
  wintrix_user_id: ft.number(),
  prospective_user_id: ft.string().optional()
});
ft.object({
  user_id: ft.string()
});
function Ol(e, t) {
  const n = new URL("/api/trpc", e).toString();
  return uf({
    links: [
      Ef({
        transformer: H,
        url: n,
        headers() {
          return {};
        }
      })
    ]
  });
}
const ph = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function hh(e, t) {
  return pe(), je("svg", ph, t[0] || (t[0] = [
    he("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
    }, null, -1)
  ]));
}
const Sl = mn({ name: "heroicons-document-text", render: hh }), mh = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function gh(e, t) {
  return pe(), je("svg", mh, t[0] || (t[0] = [
    he("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
    }, null, -1)
  ]));
}
const vh = mn({ name: "heroicons-outline-envelope", render: gh }), yh = {
  viewBox: "0 0 256 315",
  width: "0.99em",
  height: "1.2em"
};
function bh(e, t) {
  return pe(), je("svg", yh, t[0] || (t[0] = [
    he("path", { d: "M213.803 167.03c.442 47.58 41.74 63.413 42.197 63.615c-.35 1.116-6.599 22.563-21.757 44.716c-13.104 19.153-26.705 38.235-48.13 38.63c-21.05.388-27.82-12.483-51.888-12.483c-24.061 0-31.582 12.088-51.51 12.871c-20.68.783-36.428-20.71-49.64-39.793c-27-39.033-47.633-110.3-19.928-158.406c13.763-23.89 38.36-39.017 65.056-39.405c20.307-.387 39.475 13.662 51.889 13.662c12.406 0 35.699-16.895 60.186-14.414c10.25.427 39.026 4.14 57.503 31.186c-1.49.923-34.335 20.044-33.978 59.822M174.24 50.199c10.98-13.29 18.369-31.79 16.353-50.199c-15.826.636-34.962 10.546-46.314 23.828c-10.173 11.763-19.082 30.589-16.678 48.633c17.64 1.365 35.66-8.964 46.64-22.262" }, null, -1)
  ]));
}
const _h = mn({ name: "logos-apple", render: bh }), wh = {
  viewBox: "0 0 256 262",
  width: "1.18em",
  height: "1.2em"
};
function xh(e, t) {
  return pe(), je("svg", wh, t[0] || (t[0] = [
    he("path", {
      fill: "#4285F4",
      d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622l38.755 30.023l2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
    }, null, -1),
    he("path", {
      fill: "#34A853",
      d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055c-34.523 0-63.824-22.773-74.269-54.25l-1.531.13l-40.298 31.187l-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
    }, null, -1),
    he("path", {
      fill: "#FBBC05",
      d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82c0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602z"
    }, null, -1),
    he("path", {
      fill: "#EB4335",
      d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0C79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
    }, null, -1)
  ]));
}
const Eh = mn({ name: "logos-google-icon", render: xh }), kh = {
  viewBox: "0 0 256 256",
  width: "1.2em",
  height: "1.2em"
};
function Nh(e, t) {
  return pe(), je("svg", kh, t[0] || (t[0] = [
    he("path", {
      fill: "#F1511B",
      d: "M121.666 121.666H0V0h121.666z"
    }, null, -1),
    he("path", {
      fill: "#80CC28",
      d: "M256 121.666H134.335V0H256z"
    }, null, -1),
    he("path", {
      fill: "#00ADEF",
      d: "M121.663 256.002H0V134.336h121.663z"
    }, null, -1),
    he("path", {
      fill: "#FBBC09",
      d: "M256 256.002H134.335V134.336H256z"
    }, null, -1)
  ]));
}
const Oh = mn({ name: "logos-microsoft-icon", render: Nh }), Sh = { class: "flex flex-col justify-center mt-0" }, Ch = { class: "flex flex-col gap-y-3" }, Th = ["onClick"], Cl = /* @__PURE__ */ vn({
  __name: "ProviderButtons",
  props: {
    type: {},
    providers: {}
  },
  emits: ["signIn"],
  setup(e) {
    const t = e, n = un(() => t.providers.map((r) => {
      if (r.provider === "google")
        return {
          ...r,
          display: t.type === "register" ? "Register with Google" : "Sign in with Google",
          class: "text-black bg-white hover:bg-gray-200 focus-visible:outline-gray-300",
          icon: Eh
        };
      if (r.provider === "apple")
        return {
          ...r,
          display: t.type === "register" ? "Register with Apple" : "Sign in with Apple",
          class: "text-black bg-white hover:bg-gray-200 focus-visible:outline-gray-300",
          icon: _h
        };
      if (r.provider === "microsoft")
        return {
          ...r,
          display: t.type === "register" ? "Register with Microsoft" : "Sign in with Microsoft",
          class: "text-white bg-black hover:bg-gray-200 focus-visible:outline-gray-300",
          icon: Oh
        };
      if (r.provider === "credential")
        return {
          ...r,
          display: t.type === "register" ? "Register with Email and Password" : "Sign in with Email and Password",
          class: "text-white bg-orange-500 hover:bg-orange-400 focus-visible:outline-orange-300",
          icon: vh
        };
      throw new Error(`Unknown provider ${r.provider}`);
    }));
    return (r, i) => (pe(), je("div", Sh, [
      he("div", Ch, [
        (pe(!0), je(Me, null, au(n.value, (s) => (pe(), je("button", {
          key: s.id,
          class: Yr(["flex w-full justify-center items-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2", s.class]),
          onClick: (o) => r.$emit("signIn", s)
        }, [
          (pe(), si(su(s.icon), { class: "h-5 w-5 mx-2" })),
          ai(" " + Fo(s.display), 1)
        ], 10, Th))), 128))
      ])
    ]));
  }
}), Dh = { class: "flex flex-col gap-y-3 items-center text-center" }, Vh = ["href"], Ah = ["href"], Ph = /* @__PURE__ */ vn({
  __name: "AuthServiceLogin.ce",
  props: {
    endpoint: { type: String },
    returnUrl: { type: String },
    prospectToken: { type: String },
    registrationToken: { type: String },
    type: { type: String }
  },
  setup(e) {
    const t = e, n = ia();
    function r(a) {
      return t.endpoint ? new URL(a, t.endpoint) : new URL(a, window.location.origin);
    }
    Ol(t.endpoint).auth.enabledProviders.query().then((a) => {
      n.value = a;
    });
    function i({ id: a, provider: l }) {
      if (l === "credential") {
        const d = r(`/${t.type}/credentials`);
        d.searchParams.set("returnUrl", t.returnUrl), t.type === "register" && t.prospectToken && d.searchParams.set("prospectToken", t.prospectToken), t.type === "register" && t.registrationToken && d.searchParams.set("registrationToken", t.registrationToken), window.location.assign(d);
        return;
      }
      const c = r("/api/auth");
      c.searchParams.set("provider", a), c.searchParams.set("type", t.type), c.searchParams.set("returnUrl", t.returnUrl), t.type === "register" && t.prospectToken && c.searchParams.set("prospectToken", t.prospectToken), t.type === "register" && t.registrationToken && c.searchParams.set("registrationToken", t.registrationToken), window.location.assign(c);
    }
    const s = un(() => {
      const a = r("/login/forgot");
      return a.searchParams.set("returnUrl", t.returnUrl), a;
    }), o = un(() => {
      const a = r(`/register/policy?returnUrl=${t.returnUrl}`);
      return a.searchParams.set("returnUrl", t.returnUrl), a;
    });
    return (a, l) => (pe(), je("div", Dh, [
      a.type === "login" ? (pe(), je(Me, { key: 0 }, [
        l[1] || (l[1] = he("p", null, " We have recently updated how you access the customer portal. Please select 'Register your account' and follow the steps to get yourself registered ", -1)),
        he("a", {
          href: o.value.toString(),
          class: "flex justify-center bg-[#f97316] hover:bg-[#F7923C] text-white font-semibold py-2 px-4 rounded text-sm"
        }, [
          $e(ti(Sl), { class: "h-5 w-5 mx-2" }),
          l[0] || (l[0] = ai(" Register your account "))
        ], 8, Vh),
        l[2] || (l[2] = he("p", { class: "mt-8" }, " If you have a registered account, then please sign in with one of the options below ", -1))
      ], 64)) : kr("", !0),
      n.value ? (pe(), si(Cl, {
        key: 1,
        type: a.type,
        providers: n.value,
        onSignIn: i
      }, null, 8, ["type", "providers"])) : kr("", !0),
      a.type === "login" ? (pe(), je("a", {
        key: 2,
        href: s.value.toString()
      }, " Forgotten login details? ", 8, Ah)) : kr("", !0)
    ]));
  }
}), jh = '/*! tailwindcss v4.1.4 | MIT License | https://tailwindcss.com */@layer properties{@supports (((-webkit-hyphens:none)) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))){*,:before,:after,::backdrop{--tw-leading:initial;--tw-font-weight:initial;--tw-shadow:0 0 #0000;--tw-shadow-color:initial;--tw-shadow-alpha:100%;--tw-inset-shadow:0 0 #0000;--tw-inset-shadow-color:initial;--tw-inset-shadow-alpha:100%;--tw-ring-color:initial;--tw-ring-shadow:0 0 #0000;--tw-inset-ring-color:initial;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-inset:initial;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-offset-shadow:0 0 #0000;--tw-outline-style:solid}}}@layer theme{:root,:host{--font-sans:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";--font-mono:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;--color-orange-300:oklch(83.7% .128 66.29);--color-orange-400:oklch(75% .183 55.934);--color-orange-500:oklch(70.5% .213 47.604);--color-gray-200:oklch(92.8% .006 264.531);--color-gray-300:oklch(87.2% .01 258.338);--color-black:#000;--color-white:#fff;--spacing:.25rem;--text-sm:.875rem;--text-sm--line-height:calc(1.25/.875);--font-weight-semibold:600;--radius-md:.375rem;--default-font-family:var(--font-sans);--default-mono-font-family:var(--font-mono)}}@layer base{*,:after,:before,::backdrop{box-sizing:border-box;border:0 solid;margin:0;padding:0}::file-selector-button{box-sizing:border-box;border:0 solid;margin:0;padding:0}html,:host{-webkit-text-size-adjust:100%;-moz-tab-size:4;tab-size:4;line-height:1.5;font-family:var(--default-font-family,ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji");font-feature-settings:var(--default-font-feature-settings,normal);font-variation-settings:var(--default-font-variation-settings,normal);-webkit-tap-highlight-color:transparent}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:var(--default-mono-font-family,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace);font-feature-settings:var(--default-mono-font-feature-settings,normal);font-variation-settings:var(--default-mono-font-variation-settings,normal);font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}:-moz-focusring{outline:auto}progress{vertical-align:baseline}summary{display:list-item}ol,ul,menu{list-style:none}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}button,input,select,optgroup,textarea{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}::file-selector-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}:where(select:is([multiple],[size])) optgroup{font-weight:bolder}:where(select:is([multiple],[size])) optgroup option{padding-inline-start:20px}::file-selector-button{margin-inline-end:4px}::placeholder{opacity:1}@supports (not ((-webkit-appearance:-apple-pay-button))) or (contain-intrinsic-size:1px){::placeholder{color:currentColor}@supports (color:color-mix(in lab,red,red)){::placeholder{color:color-mix(in oklab,currentcolor 50%,transparent)}}}textarea{resize:vertical}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-date-and-time-value{min-height:1lh;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-datetime-edit{padding-block:0}::-webkit-datetime-edit-year-field{padding-block:0}::-webkit-datetime-edit-month-field{padding-block:0}::-webkit-datetime-edit-day-field{padding-block:0}::-webkit-datetime-edit-hour-field{padding-block:0}::-webkit-datetime-edit-minute-field{padding-block:0}::-webkit-datetime-edit-second-field{padding-block:0}::-webkit-datetime-edit-millisecond-field{padding-block:0}::-webkit-datetime-edit-meridiem-field{padding-block:0}:-moz-ui-invalid{box-shadow:none}button,input:where([type=button],[type=reset],[type=submit]){-webkit-appearance:button;-moz-appearance:button;appearance:button}::file-selector-button{-webkit-appearance:button;-moz-appearance:button;appearance:button}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[hidden]:where(:not([hidden=until-found])){display:none!important}*,:after,:before,::backdrop{border-color:var(--color-gray-200,currentColor)}::file-selector-button{border-color:var(--color-gray-200,currentColor)}button:not(:disabled),[role=button]:not(:disabled){cursor:pointer}}@layer components;@layer utilities{.mx-2{margin-inline:calc(var(--spacing)*2)}.mt-0{margin-top:calc(var(--spacing)*0)}.mt-8{margin-top:calc(var(--spacing)*8)}.flex{display:flex}.h-5{height:calc(var(--spacing)*5)}.w-5{width:calc(var(--spacing)*5)}.w-full{width:100%}.flex-col{flex-direction:column}.items-center{align-items:center}.justify-center{justify-content:center}.gap-y-3{row-gap:calc(var(--spacing)*3)}.rounded{border-radius:.25rem}.rounded-md{border-radius:var(--radius-md)}.bg-\\[\\#f97316\\]{background-color:#f97316}.bg-black{background-color:var(--color-black)}.bg-orange-500{background-color:var(--color-orange-500)}.bg-white{background-color:var(--color-white)}.px-3{padding-inline:calc(var(--spacing)*3)}.px-4{padding-inline:calc(var(--spacing)*4)}.py-1\\.5{padding-block:calc(var(--spacing)*1.5)}.py-2{padding-block:calc(var(--spacing)*2)}.text-center{text-align:center}.text-sm{font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height))}.leading-6{--tw-leading:calc(var(--spacing)*6);line-height:calc(var(--spacing)*6)}.font-semibold{--tw-font-weight:var(--font-weight-semibold);font-weight:var(--font-weight-semibold)}.text-black{color:var(--color-black)}.text-white{color:var(--color-white)}.shadow-sm{--tw-shadow:0 1px 3px 0 var(--tw-shadow-color,#0000001a),0 1px 2px -1px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}@media (hover:hover){.hover\\:bg-\\[\\#F7923C\\]:hover{background-color:#f7923c}.hover\\:bg-gray-200:hover{background-color:var(--color-gray-200)}.hover\\:bg-orange-400:hover{background-color:var(--color-orange-400)}}.focus-visible\\:outline:focus-visible{outline-style:var(--tw-outline-style);outline-width:1px}.focus-visible\\:outline-2:focus-visible{outline-style:var(--tw-outline-style);outline-width:2px}.focus-visible\\:outline-offset-2:focus-visible{outline-offset:2px}.focus-visible\\:outline-gray-300:focus-visible{outline-color:var(--color-gray-300)}.focus-visible\\:outline-orange-300:focus-visible{outline-color:var(--color-orange-300)}.scrollbar-hidden::-webkit-scrollbar{display:none}.scrollbar-hidden{scrollbar-width:none;-ms-overflow-style:none}}@property --tw-leading{syntax:"*";inherits:false}@property --tw-font-weight{syntax:"*";inherits:false}@property --tw-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:"*";inherits:false}@property --tw-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-inset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:"*";inherits:false}@property --tw-inset-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-ring-color{syntax:"*";inherits:false}@property --tw-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:"*";inherits:false}@property --tw-inset-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:"*";inherits:false}@property --tw-ring-offset-width{syntax:"<length>";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:"*";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-outline-style{syntax:"*";inherits:false;initial-value:solid}', Ih = /* @__PURE__ */ ui(Ph, [["styles", [jh]]]), Rh = /* @__PURE__ */ vn({
  __name: "AuthServiceLoginButtons.ce",
  props: {
    endpoint: { type: String },
    returnUrl: { type: String },
    prospectToken: { type: String },
    registrationToken: { type: String },
    type: { type: String }
  },
  setup(e) {
    const t = e, n = ia();
    Ol(t.endpoint).auth.enabledProviders.query().then((i) => {
      n.value = i;
    });
    function r({ id: i, provider: s }) {
      if (s === "credential") {
        const a = new URL(`/${t.type}/credentials`, t.endpoint);
        a.searchParams.set("returnUrl", t.returnUrl), t.type === "register" && t.prospectToken && a.searchParams.set("prospectToken", t.prospectToken), t.type === "register" && t.registrationToken && a.searchParams.set(
          "registrationToken",
          t.registrationToken
        ), window.location.assign(a);
        return;
      }
      const o = new URL("/api/auth", t.endpoint);
      o.searchParams.set("provider", i), o.searchParams.set("type", t.type), o.searchParams.set("returnUrl", t.returnUrl), t.type === "register" && t.prospectToken && o.searchParams.set("prospectToken", t.prospectToken), t.type === "register" && t.registrationToken && o.searchParams.set("registrationToken", t.registrationToken), window.location.assign(o);
    }
    return (i, s) => n.value ? (pe(), si(Cl, {
      key: 0,
      type: i.type,
      providers: n.value,
      onSignIn: r
    }, null, 8, ["type", "providers"])) : kr("", !0);
  }
}), Mh = '/*! tailwindcss v4.1.4 | MIT License | https://tailwindcss.com */@layer properties{@supports (((-webkit-hyphens:none)) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))){*,:before,:after,::backdrop{--tw-leading:initial;--tw-font-weight:initial;--tw-shadow:0 0 #0000;--tw-shadow-color:initial;--tw-shadow-alpha:100%;--tw-inset-shadow:0 0 #0000;--tw-inset-shadow-color:initial;--tw-inset-shadow-alpha:100%;--tw-ring-color:initial;--tw-ring-shadow:0 0 #0000;--tw-inset-ring-color:initial;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-inset:initial;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-offset-shadow:0 0 #0000;--tw-outline-style:solid}}}@layer theme{:root,:host{--font-sans:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";--font-mono:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;--color-orange-300:oklch(83.7% .128 66.29);--color-orange-400:oklch(75% .183 55.934);--color-orange-500:oklch(70.5% .213 47.604);--color-gray-200:oklch(92.8% .006 264.531);--color-gray-300:oklch(87.2% .01 258.338);--color-black:#000;--color-white:#fff;--spacing:.25rem;--text-sm:.875rem;--text-sm--line-height:calc(1.25/.875);--font-weight-semibold:600;--radius-md:.375rem;--default-font-family:var(--font-sans);--default-mono-font-family:var(--font-mono)}}@layer base{*,:after,:before,::backdrop{box-sizing:border-box;border:0 solid;margin:0;padding:0}::file-selector-button{box-sizing:border-box;border:0 solid;margin:0;padding:0}html,:host{-webkit-text-size-adjust:100%;-moz-tab-size:4;tab-size:4;line-height:1.5;font-family:var(--default-font-family,ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji");font-feature-settings:var(--default-font-feature-settings,normal);font-variation-settings:var(--default-font-variation-settings,normal);-webkit-tap-highlight-color:transparent}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:var(--default-mono-font-family,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace);font-feature-settings:var(--default-mono-font-feature-settings,normal);font-variation-settings:var(--default-mono-font-variation-settings,normal);font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}:-moz-focusring{outline:auto}progress{vertical-align:baseline}summary{display:list-item}ol,ul,menu{list-style:none}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}button,input,select,optgroup,textarea{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}::file-selector-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}:where(select:is([multiple],[size])) optgroup{font-weight:bolder}:where(select:is([multiple],[size])) optgroup option{padding-inline-start:20px}::file-selector-button{margin-inline-end:4px}::placeholder{opacity:1}@supports (not ((-webkit-appearance:-apple-pay-button))) or (contain-intrinsic-size:1px){::placeholder{color:currentColor}@supports (color:color-mix(in lab,red,red)){::placeholder{color:color-mix(in oklab,currentcolor 50%,transparent)}}}textarea{resize:vertical}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-date-and-time-value{min-height:1lh;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-datetime-edit{padding-block:0}::-webkit-datetime-edit-year-field{padding-block:0}::-webkit-datetime-edit-month-field{padding-block:0}::-webkit-datetime-edit-day-field{padding-block:0}::-webkit-datetime-edit-hour-field{padding-block:0}::-webkit-datetime-edit-minute-field{padding-block:0}::-webkit-datetime-edit-second-field{padding-block:0}::-webkit-datetime-edit-millisecond-field{padding-block:0}::-webkit-datetime-edit-meridiem-field{padding-block:0}:-moz-ui-invalid{box-shadow:none}button,input:where([type=button],[type=reset],[type=submit]){-webkit-appearance:button;-moz-appearance:button;appearance:button}::file-selector-button{-webkit-appearance:button;-moz-appearance:button;appearance:button}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[hidden]:where(:not([hidden=until-found])){display:none!important}*,:after,:before,::backdrop{border-color:var(--color-gray-200,currentColor)}::file-selector-button{border-color:var(--color-gray-200,currentColor)}button:not(:disabled),[role=button]:not(:disabled){cursor:pointer}}@layer components;@layer utilities{.mx-2{margin-inline:calc(var(--spacing)*2)}.mt-0{margin-top:calc(var(--spacing)*0)}.mt-8{margin-top:calc(var(--spacing)*8)}.flex{display:flex}.h-5{height:calc(var(--spacing)*5)}.w-5{width:calc(var(--spacing)*5)}.w-full{width:100%}.flex-col{flex-direction:column}.items-center{align-items:center}.justify-center{justify-content:center}.gap-y-3{row-gap:calc(var(--spacing)*3)}.rounded{border-radius:.25rem}.rounded-md{border-radius:var(--radius-md)}.bg-\\[\\#f97316\\]{background-color:#f97316}.bg-black{background-color:var(--color-black)}.bg-orange-500{background-color:var(--color-orange-500)}.bg-white{background-color:var(--color-white)}.px-3{padding-inline:calc(var(--spacing)*3)}.px-4{padding-inline:calc(var(--spacing)*4)}.py-1\\.5{padding-block:calc(var(--spacing)*1.5)}.py-2{padding-block:calc(var(--spacing)*2)}.text-center{text-align:center}.text-sm{font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height))}.leading-6{--tw-leading:calc(var(--spacing)*6);line-height:calc(var(--spacing)*6)}.font-semibold{--tw-font-weight:var(--font-weight-semibold);font-weight:var(--font-weight-semibold)}.text-black{color:var(--color-black)}.text-white{color:var(--color-white)}.shadow-sm{--tw-shadow:0 1px 3px 0 var(--tw-shadow-color,#0000001a),0 1px 2px -1px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}@media (hover:hover){.hover\\:bg-\\[\\#F7923C\\]:hover{background-color:#f7923c}.hover\\:bg-gray-200:hover{background-color:var(--color-gray-200)}.hover\\:bg-orange-400:hover{background-color:var(--color-orange-400)}}.focus-visible\\:outline:focus-visible{outline-style:var(--tw-outline-style);outline-width:1px}.focus-visible\\:outline-2:focus-visible{outline-style:var(--tw-outline-style);outline-width:2px}.focus-visible\\:outline-offset-2:focus-visible{outline-offset:2px}.focus-visible\\:outline-gray-300:focus-visible{outline-color:var(--color-gray-300)}.focus-visible\\:outline-orange-300:focus-visible{outline-color:var(--color-orange-300)}.scrollbar-hidden::-webkit-scrollbar{display:none}.scrollbar-hidden{scrollbar-width:none;-ms-overflow-style:none}}@property --tw-leading{syntax:"*";inherits:false}@property --tw-font-weight{syntax:"*";inherits:false}@property --tw-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:"*";inherits:false}@property --tw-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-inset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:"*";inherits:false}@property --tw-inset-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-ring-color{syntax:"*";inherits:false}@property --tw-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:"*";inherits:false}@property --tw-inset-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:"*";inherits:false}@property --tw-ring-offset-width{syntax:"<length>";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:"*";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-outline-style{syntax:"*";inherits:false;initial-value:solid}', $h = /* @__PURE__ */ ui(Rh, [["styles", [Mh]]]), Fh = ["href"], Lh = /* @__PURE__ */ vn({
  __name: "AuthServiceRegisterButton.ce",
  props: {
    endpoint: { type: String },
    returnUrl: { type: String }
  },
  setup(e) {
    const t = e, n = un(() => {
      const r = new URL(`/register/policy?returnUrl=${t.returnUrl}`, t.endpoint);
      return r.searchParams.set("returnUrl", t.returnUrl), r;
    });
    return (r, i) => (pe(), je("a", {
      href: n.value.toString(),
      class: "flex justify-center bg-[#f97316] hover:bg-[#F7923C] text-white font-semibold py-2 items-center px-4 rounded text-sm"
    }, [
      $e(ti(Sl), { class: "h-5 w-5 mx-2" }),
      i[0] || (i[0] = ai(" Register your account "))
    ], 8, Fh));
  }
}), Zh = '/*! tailwindcss v4.1.4 | MIT License | https://tailwindcss.com */@layer properties{@supports (((-webkit-hyphens:none)) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))){*,:before,:after,::backdrop{--tw-leading:initial;--tw-font-weight:initial;--tw-shadow:0 0 #0000;--tw-shadow-color:initial;--tw-shadow-alpha:100%;--tw-inset-shadow:0 0 #0000;--tw-inset-shadow-color:initial;--tw-inset-shadow-alpha:100%;--tw-ring-color:initial;--tw-ring-shadow:0 0 #0000;--tw-inset-ring-color:initial;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-inset:initial;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-offset-shadow:0 0 #0000;--tw-outline-style:solid}}}@layer theme{:root,:host{--font-sans:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";--font-mono:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;--color-orange-300:oklch(83.7% .128 66.29);--color-orange-400:oklch(75% .183 55.934);--color-orange-500:oklch(70.5% .213 47.604);--color-gray-200:oklch(92.8% .006 264.531);--color-gray-300:oklch(87.2% .01 258.338);--color-black:#000;--color-white:#fff;--spacing:.25rem;--text-sm:.875rem;--text-sm--line-height:calc(1.25/.875);--font-weight-semibold:600;--radius-md:.375rem;--default-font-family:var(--font-sans);--default-mono-font-family:var(--font-mono)}}@layer base{*,:after,:before,::backdrop{box-sizing:border-box;border:0 solid;margin:0;padding:0}::file-selector-button{box-sizing:border-box;border:0 solid;margin:0;padding:0}html,:host{-webkit-text-size-adjust:100%;-moz-tab-size:4;tab-size:4;line-height:1.5;font-family:var(--default-font-family,ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji");font-feature-settings:var(--default-font-feature-settings,normal);font-variation-settings:var(--default-font-variation-settings,normal);-webkit-tap-highlight-color:transparent}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:var(--default-mono-font-family,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace);font-feature-settings:var(--default-mono-font-feature-settings,normal);font-variation-settings:var(--default-mono-font-variation-settings,normal);font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}:-moz-focusring{outline:auto}progress{vertical-align:baseline}summary{display:list-item}ol,ul,menu{list-style:none}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}button,input,select,optgroup,textarea{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}::file-selector-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}:where(select:is([multiple],[size])) optgroup{font-weight:bolder}:where(select:is([multiple],[size])) optgroup option{padding-inline-start:20px}::file-selector-button{margin-inline-end:4px}::placeholder{opacity:1}@supports (not ((-webkit-appearance:-apple-pay-button))) or (contain-intrinsic-size:1px){::placeholder{color:currentColor}@supports (color:color-mix(in lab,red,red)){::placeholder{color:color-mix(in oklab,currentcolor 50%,transparent)}}}textarea{resize:vertical}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-date-and-time-value{min-height:1lh;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-datetime-edit{padding-block:0}::-webkit-datetime-edit-year-field{padding-block:0}::-webkit-datetime-edit-month-field{padding-block:0}::-webkit-datetime-edit-day-field{padding-block:0}::-webkit-datetime-edit-hour-field{padding-block:0}::-webkit-datetime-edit-minute-field{padding-block:0}::-webkit-datetime-edit-second-field{padding-block:0}::-webkit-datetime-edit-millisecond-field{padding-block:0}::-webkit-datetime-edit-meridiem-field{padding-block:0}:-moz-ui-invalid{box-shadow:none}button,input:where([type=button],[type=reset],[type=submit]){-webkit-appearance:button;-moz-appearance:button;appearance:button}::file-selector-button{-webkit-appearance:button;-moz-appearance:button;appearance:button}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[hidden]:where(:not([hidden=until-found])){display:none!important}*,:after,:before,::backdrop{border-color:var(--color-gray-200,currentColor)}::file-selector-button{border-color:var(--color-gray-200,currentColor)}button:not(:disabled),[role=button]:not(:disabled){cursor:pointer}}@layer components;@layer utilities{.mx-2{margin-inline:calc(var(--spacing)*2)}.mt-0{margin-top:calc(var(--spacing)*0)}.mt-8{margin-top:calc(var(--spacing)*8)}.flex{display:flex}.h-5{height:calc(var(--spacing)*5)}.w-5{width:calc(var(--spacing)*5)}.w-full{width:100%}.flex-col{flex-direction:column}.items-center{align-items:center}.justify-center{justify-content:center}.gap-y-3{row-gap:calc(var(--spacing)*3)}.rounded{border-radius:.25rem}.rounded-md{border-radius:var(--radius-md)}.bg-\\[\\#f97316\\]{background-color:#f97316}.bg-black{background-color:var(--color-black)}.bg-orange-500{background-color:var(--color-orange-500)}.bg-white{background-color:var(--color-white)}.px-3{padding-inline:calc(var(--spacing)*3)}.px-4{padding-inline:calc(var(--spacing)*4)}.py-1\\.5{padding-block:calc(var(--spacing)*1.5)}.py-2{padding-block:calc(var(--spacing)*2)}.text-center{text-align:center}.text-sm{font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height))}.leading-6{--tw-leading:calc(var(--spacing)*6);line-height:calc(var(--spacing)*6)}.font-semibold{--tw-font-weight:var(--font-weight-semibold);font-weight:var(--font-weight-semibold)}.text-black{color:var(--color-black)}.text-white{color:var(--color-white)}.shadow-sm{--tw-shadow:0 1px 3px 0 var(--tw-shadow-color,#0000001a),0 1px 2px -1px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}@media (hover:hover){.hover\\:bg-\\[\\#F7923C\\]:hover{background-color:#f7923c}.hover\\:bg-gray-200:hover{background-color:var(--color-gray-200)}.hover\\:bg-orange-400:hover{background-color:var(--color-orange-400)}}.focus-visible\\:outline:focus-visible{outline-style:var(--tw-outline-style);outline-width:1px}.focus-visible\\:outline-2:focus-visible{outline-style:var(--tw-outline-style);outline-width:2px}.focus-visible\\:outline-offset-2:focus-visible{outline-offset:2px}.focus-visible\\:outline-gray-300:focus-visible{outline-color:var(--color-gray-300)}.focus-visible\\:outline-orange-300:focus-visible{outline-color:var(--color-orange-300)}.scrollbar-hidden::-webkit-scrollbar{display:none}.scrollbar-hidden{scrollbar-width:none;-ms-overflow-style:none}}@property --tw-leading{syntax:"*";inherits:false}@property --tw-font-weight{syntax:"*";inherits:false}@property --tw-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:"*";inherits:false}@property --tw-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-inset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:"*";inherits:false}@property --tw-inset-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-ring-color{syntax:"*";inherits:false}@property --tw-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:"*";inherits:false}@property --tw-inset-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:"*";inherits:false}@property --tw-ring-offset-width{syntax:"<length>";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:"*";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-outline-style{syntax:"*";inherits:false;initial-value:solid}', zh = /* @__PURE__ */ ui(Lh, [["styles", [Zh]]]), Uh = /* @__PURE__ */ ci(Ih), Hh = /* @__PURE__ */ ci(Ud), Bh = /* @__PURE__ */ ci($h), Wh = /* @__PURE__ */ ci(zh);
function qh() {
  customElements.define("ignite-auth-service-login", Uh), customElements.define("ignite-auth-service-forgot-button", Hh), customElements.define("ignite-auth-service-login-buttons", Bh), customElements.define("ignite-auth-service-register-button", Wh);
}
export {
  Hh as AuthServiceForgotButtonCE,
  Bh as AuthServiceLoginButtonsCE,
  Uh as AuthServiceLoginCE,
  Wh as AuthServiceRegisterButtonCE,
  qh as register
};
